import React, { useCallback, useMemo, useState } from "react";
import Location from "../Common/Location";
import AuctionWeeklyStatsPanel from "./AuctionWeeklyStatsPanel";
import CloseIcon from "@mui/icons-material/Close";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import GavelIcon from "@mui/icons-material/Gavel";
import InsightsIcon from "@mui/icons-material/Insights";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Alert, Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, LinearProgress, MenuItem, Paper, Select, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tabs, TextField, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, Legend, Line, LineChart, Pie, PieChart, Tooltip as RechartsTooltip, ResponsiveContainer, XAxis, YAxis } from "recharts";

export default function HibidAuctionsTab({
  AUCTION_CONSIGNOR_FILTER_UNASSIGNED,
  accountManagers,
  addAuctionInlinePickupSlot,
  addAuctionPickupSlot,
  addCompareAuctionSlot,
  applyLocationMetadataRows,
  applySortToggle,
  aregAmountDueDraftByEmail,
  aregConsignorFilter,
  aregFulfillmentFilter,
  aregDeliveryFilter,
  aregDeliveryLocationFilter,
  aregLoading,
  aregNewUserFilter,
  aregPickupDateEnd,
  aregPickupDateStart,
  aregPickupFilter,
  aregPickupLocationFilter,
  aregPickupSelectionFilter,
  aregSearch,
  aregSelected,
  aregShelfDraftByEmail,
  aregShelfSavingByEmail,
  aregShippedFilter,
  aregSortDir,
  aregSortKey,
  auctionAccountManagerOptions,
  auctionChartData,
  auctionEndAtLocal,
  auctionEndSaving,
  auctionEntitySharePanels,
  auctionHibidSearch,
  auctionHibidTrendByRowKey,
  auctionHibidViewRows,
  auctionInlineInfoSavingById,
  auctionKpiCards,
  auctionListLayout,
  auctionLocationFilter,
  auctionLocationFilterOptions,
  auctionLotStatsSections,
  auctionParticipationSections,
  auctionPickupLocations,
  auctionPickupSlots,
  auctionRegs,
  auctionRegTrendAvailableRange,
  auctionRegTrendChartType,
  auctionRegTrendDateMode,
  auctionRegTrendDateModeOptions,
  auctionRegTrendEndDate,
  auctionRegTrendResolvedRange,
  auctionRegTrendStartDate,
  auctionRegTrendViewBy,
  auctionRegTrendViewByOptions,
  auctionRegistrationTrendData,
  auctionRegistrationTrendHasData,
  auctionRegistrationTrendTotalInRange,
  auctionSummary,
  auctionSummaryLoading,
  auctionTableSortDir,
  auctionTableSortKey,
  auctionViewMode,
  auctionWeeklyStatsOpen,
  auctions,
  backToAuctionList,
  bulkBoxLabelMode,
  bulkBoxLabelRows,
  captureChargebackSignatureDataUrl,
  chargebackEmailAlreadySentFilter,
  chargebackEmailFulfillmentFilter,
  chargebackEmailWonLotFilter,
  chargebackFilteredAuctionRegs,
  chargebackSignError,
  chargebackSignOpen,
  chargebackSignRow,
  chargebackSignSaving,
  chargebackSignSignatureHasInk,
  chargebackSignSignatureName,
  chargebackSignSuccess,
  chargebackSignatureCanvasRef,
  cityOptionsLoading,
  cityPlacesReady,
  clampDateKeyToRangeUTC,
  clearRegsSearch,
  compareAuctionIds,
  compareAuctionRegTrendAvailableRange,
  compareAuctionRegTrendChartType,
  compareAuctionRegTrendDateMode,
  compareAuctionRegTrendEndDate,
  compareAuctionRegTrendResolvedRange,
  compareAuctionRegTrendSeries,
  compareAuctionRegTrendStartDate,
  compareAuctionRegTrendViewBy,
  compareAuctionsOpen,
  compareAuctionView,
  computeAuctionShareTotals,
  computeSellerRowRevenue,
  copyText,
  createAuctionBusy,
  createAuctionEndAtLocal,
  createAuctionLocation,
  createAuctionLocationInput,
  createAuctionLocationOptions,
  createAuctionLotsFile,
  createAuctionLotsFileInputRef,
  createAuctionName,
  createAuctionNow,
  createAuctionOpen,
  createAuctionRegistrationFile,
  createAuctionRegistrationFileInputRef,
  endChargebackSignatureDraw,
  expandedMediaUrlsByKey,
  exportBulkRegistrationBoxLabelsPdf,
  exportSelectedDeliveryManifestExcel,
  exportSelectedDeliveryManifestLotsPdf,
  exportSelectedDeliveryManifestPdf,
  exportRegistrationRowBoxLabelsPdf,
  exportSelectedPickupPicklistExcel,
  exportSelectedPickupPicklistLotsPdf,
  exportSelectedPickupPicklistPdf,
  exportSelectedRegistrationsWorkbook,
  fetchAuctionRegsPage,
  fetchAuctionSummary,
  fileNameMismatchDialog,
  filterLabelSx,
  filteredAuctionHibidViewRows,
  flushAuctionInlineInfoAutosave,
  flushAuctionSettingsAutosave,
  fmtDate,
  formatDateKeyRangeShortUTC,
  formatEngagementSeriesName,
  formatLotDimensions,
  formatNumber2,
  formatPercent2,
  getAuctionInlineAccountManagerRows,
  getAuctionInlineInfoDraft,
  getAuctionInlineLocationInput,
  getAuctionInlineLocationOptions,
  getAuctionInlinePickupLocations,
  getAuctionInlinePickupSlots,
  getChargebackSignDetails,
  getDisplayBidderName,
  getDisplayUsername,
  getFirstLastNameParts,
  getListernautMediaUrls,
  getListernautThumbnailUrl,
  getLocationAddress,
  getLotDescriptionText,
  getLotPickupCounts,
  getLotShippedCounts,
  getPickupLocationSelectOptions,
  getRegistrationBoxLabelRowKey,
  getRegistrationDelivery,
  getSelectedRegRows,
  isAuctionRegistrationNewUser,
  isChargebackEmailSent,
  isEmail,
  isFloorBidderEmail,
  isShippingRequested,
  listernautFileInputRef,
  listernautUploadBusy,
  locationMetadataRows,
  locationScopedAuctionHibidViewRows,
  locationsManagerOpen,
  lotsAgg,
  lotsBusy,
  lotsData,
  lotsErr,
  lotsFileInputRef,
  lotsModalSortDir,
  lotsModalSortKey,
  lotsOpen,
  lotsUser,
  lotsUserFulfillmentLabel,
  lotsUserFulfillmentMode,
  lotsUserFulfillmentStatusLabel,
  modalPaperSx,
  moneyPlain,
  moveChargebackSignatureDraw,
  normalize,
  onShippingFileSelected,
  openAuctionFromHibidView,
  openAuctionNewUsersFromOverall,
  openAuctionUserDetailsModal,
  openChargebackSignModal,
  openCompareAuctionsDialog,
  openCreateAuctionDialog,
  openEmailForAuctionSelection,
  openLotsModal,
  openRegistrationFulfillmentDetails,
  openRegistrationFulfillmentConfirm,
  orgReady,
  overallAuctionCompareFields,
  overallAuctionCompareOptions,
  overallAuctionSearch,
  overallAuctionSortDir,
  overallAuctionSortKey,
  overallChartData,
  overallDashboardOpen,
  overallKpiCards,
  parseShelfBoxLabels,
  deliveryManifestExcelBusy,
  deliveryManifestLotsPdfBusy,
  deliveryManifestPdfBusy,
  pickupPicklistExcelBusy,
  pickupPicklistLotsPdfBusy,
  pickupPicklistPdfBusy,
  primary,
  queueCreateAuctionCityOptions,
  registrationBoxLabelsBusy,
  registrationBoxLabelsBusyByKey,
  registrationConsignorOptions,
  registrationDeliveryLocationOptions,
  registrationPickupLocationOptions,
  removeAuctionInlinePickupSlot,
  removeAuctionPickupSlot,
  removeCompareAuctionSlot,
  renderAuctionManagerSummary,
  renderAuctionPickupSlotSummary,
  renderAuctionRegistrationMobileCard,
  renderAuctionShareMiniTable,
  renderDescriptionPreview,
  renderPickupLocationSelectedDetails,
  renderTrendDeltaPair,
  renderTrendDeltaPairFromTrend,
  requestListernautUploadFile,
  requestShippingUploadFile,
  resetChargebackSignatureCanvas,
  resolveFileNameMismatchDialog,
  safeNum,
  sanitizeAuctionAccountManagerIds,
  sanitizeAuctionPickupLocations,
  selectedAuctionAccountManagerRows,
  selectedAuctionId,
  selectedAuctionLabel,
  selectedAuctionStatsTab,
  selectedAuctionViewRow,
  selectedCompareAuctionRows,
  selectedRegsExportBusy,
  setAregAmountDueDraftByEmail,
  setAregConsignorFilter,
  setAregFulfillmentFilter,
  setAregDeliveryFilter,
  setAregDeliveryLocationFilter,
  setAregNewUserFilter,
  setAregPickupDateEnd,
  setAregPickupDateStart,
  setAregPickupFilter,
  setAregPickupLocationFilter,
  setAregPickupSelectionFilter,
  setAregSearch,
  setAregShelfDraftByEmail,
  setAregShippedFilter,
  setAregShipperFilter,
  setAregSortDir,
  setAregSortKey,
  setAuctionAccountManagerIds,
  setAuctionEndAtLocal,
  setAuctionHibidSearch,
  setAuctionInlineAccountManagerIds,
  setAuctionInlineInfoField,
  setAuctionInlinePickupLocations,
  setAuctionListLayout,
  setAuctionLocationFilter,
  setAuctionRegTrendChartType,
  setAuctionRegTrendDateMode,
  setAuctionRegTrendEndDate,
  setAuctionRegTrendStartDate,
  setAuctionRegTrendViewBy,
  setAuctionTableSortDir,
  setAuctionTableSortKey,
  setAuctionViewMode,
  setAuctionWeeklyStatsOpen,
  setChargebackEmailAlreadySentFilter,
  setChargebackEmailFulfillmentFilter,
  setChargebackEmailWonLotFilter,
  setChargebackSignError,
  setChargebackSignOpen,
  setChargebackSignRow,
  setChargebackSignSignatureName,
  setCompareAuctionIds,
  setCompareAuctionRegTrendChartType,
  setCompareAuctionRegTrendDateMode,
  setCompareAuctionRegTrendEndDate,
  setCompareAuctionRegTrendStartDate,
  setCompareAuctionRegTrendViewBy,
  setCompareAuctionView,
  setCompareAuctionsOpen,
  setCreateAuctionEndAtLocal,
  setCreateAuctionLocation,
  setCreateAuctionLocationInput,
  setCreateAuctionLotsFile,
  setCreateAuctionName,
  setCreateAuctionOpen,
  setCreateAuctionRegistrationFile,
  setLocationsManagerOpen,
  setLotsModalSortDir,
  setLotsModalSortKey,
  setLotsOpen,
  setOverallAuctionSearch,
  setOverallAuctionSortDir,
  setOverallAuctionSortKey,
  setOverallDashboardOpen,
  setSelectedAuctionStatsTab,
  shipBusy,
  shippingFileInputRef,
  sortedFilteredAuctionHibidViewRows,
  sortedLotsModalRows,
  sortedOverallAuctionTableRows,
  startChargebackSignatureDraw,
  subscriptionId,
  toAbsInt,
  toggleMediaUrlsExpanded,
  toggleSelectAllRegs,
  toggleSelectReg,
  updateAuctionInlinePickupSlot,
  updateAuctionPickupLocations,
  updateAuctionPickupSlot,
  updateCompareAuctionSlot,
  updateLotPickup,
  updateLotShipped,
  updateLotDelivered,
  updateRegistrationDelivered,
  uploadRegistrationDeliveryProofPhotos,
  updateRegistrationShelf,
  updateRegistrationShipping,
  updateRegistrationSignature,
  uploadBusy,
  uploadDialogMessage,
  uploadDialogOpen,
  uploadListernautFile,
  uploadLotsCsv,
  userId,
}) {
  const isMobileDevice = useMediaQuery("(max-width:899.95px)");
  const [showRegistrationFilters, setShowRegistrationFilters] = useState(false);
  const [deliveryDriverOpen, setDeliveryDriverOpen] = useState(false);
  const [deliveryDriverRouteKeys, setDeliveryDriverRouteKeys] = useState([]);
  const [deliveryDriverRouteBusy, setDeliveryDriverRouteBusy] = useState(false);
  const [deliveryDriverRouteNote, setDeliveryDriverRouteNote] = useState("");
  const [deliveryDriverStatusBusyByKey, setDeliveryDriverStatusBusyByKey] = useState({});
  const [deliveryDriverUploadBusyByKey, setDeliveryDriverUploadBusyByKey] = useState({});
  const [deliveryDriverLocationFilter, setDeliveryDriverLocationFilter] = useState("all");
  const [deliveryDriverSearch, setDeliveryDriverSearch] = useState("");
  const [deliveryDriverActionModal, setDeliveryDriverActionModal] = useState({
    open: false,
    type: "",
    stopKey: "",
    failedReason: "",
  });
  const fulfillmentFilterOptions = [
    { value: "all", label: "All" },
    { value: "pickup", label: "Pickup" },
    { value: "delivery", label: "Delivery" },
    { value: "shipping", label: "Shipping" },
  ];
  const handleFulfillmentFilterChange = (nextValue) => {
    setAregFulfillmentFilter(nextValue);
    setAregShipperFilter("all");
    setAregPickupFilter("all");
    setAregShippedFilter("all");
    setAregDeliveryFilter("all");
    setAregPickupLocationFilter("all");
    setAregDeliveryLocationFilter("all");
    setAregPickupSelectionFilter("all");
    setAregPickupDateStart("");
    setAregPickupDateEnd("");
  };
  const getFulfillmentMode = useCallback(({ row = {}, shippingRequested = false, delivery = null } = {}) => {
    const nextDelivery = delivery && typeof delivery === "object" ? delivery : getRegistrationDelivery(row);
    if (
      nextDelivery?.isScheduled ||
      nextDelivery?.hasSelection ||
      nextDelivery?.location ||
      nextDelivery?.deliveryDateKey
    ) {
      return "delivery";
    }
    return shippingRequested ? "shipping" : "pickup";
  }, [getRegistrationDelivery]);
  const getFulfillmentButtonMeta = (mode = "pickup") => {
    if (mode === "delivery") {
      return {
        label: "Delivery",
        color: "#854d0e",
        background: "linear-gradient(90deg, rgba(250,204,21,0.2), rgba(245,158,11,0.24))",
        border: "1px solid rgba(245,158,11,0.35)",
      };
    }
    if (mode === "shipping") {
      return {
        label: "Shipping",
        color: "#374151",
        background: "linear-gradient(90deg, rgba(203,213,225,0.4), rgba(148,163,184,0.34))",
        border: "1px solid rgba(148,163,184,0.42)",
      };
    }
    return {
      label: "Pickup",
      color: "#1d4ed8",
      background: "linear-gradient(90deg, rgba(96,165,250,0.18), rgba(37,99,235,0.2))",
      border: "1px solid rgba(59,130,246,0.35)",
    };
  };
  const buildGoogleMapsUrl = useCallback((address = "") => {
    const safeAddress = String(address || "").trim();
    if (!safeAddress) return "";
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(safeAddress)}`;
  }, []);
  const buildAppleMapsUrl = useCallback((address = "") => {
    const safeAddress = String(address || "").trim();
    if (!safeAddress) return "";
    return `https://maps.apple.com/?q=${encodeURIComponent(safeAddress)}`;
  }, []);
  const buildGoogleRouteUrl = useCallback(({ origin = "", addresses = [] } = {}) => {
    const cleanAddresses = (Array.isArray(addresses) ? addresses : [])
      .map((value) => String(value || "").trim())
      .filter(Boolean);
    if (!cleanAddresses.length) return "";
    const safeOrigin = String(origin || "").trim();
    const originAddress = safeOrigin || cleanAddresses[0];
    const routeStops = safeOrigin ? cleanAddresses : cleanAddresses.slice(1);
    const destination = routeStops.length ? routeStops[routeStops.length - 1] : cleanAddresses[0];
    const waypoints = (safeOrigin ? routeStops.slice(0, -1) : cleanAddresses.slice(1, -1)).filter(Boolean);
    const qs = new URLSearchParams();
    qs.set("api", "1");
    qs.set("origin", originAddress);
    qs.set("destination", destination);
    if (waypoints.length) qs.set("waypoints", waypoints.join("|"));
    qs.set("travelmode", "driving");
    return `https://www.google.com/maps/dir/?${qs.toString()}`;
  }, []);
  const buildAppleRouteUrl = useCallback(({ origin = "", addresses = [] } = {}) => {
    const cleanAddresses = (Array.isArray(addresses) ? addresses : [])
      .map((value) => String(value || "").trim())
      .filter(Boolean);
    if (!cleanAddresses.length) return "";
    const safeOrigin = String(origin || "").trim();
    const destinationChain = cleanAddresses.join(" to:");
    const qs = new URLSearchParams();
    if (safeOrigin) qs.set("saddr", safeOrigin);
    qs.set("daddr", destinationChain);
    qs.set("dirflg", "d");
    return `https://maps.apple.com/?${qs.toString()}`;
  }, []);
  const openExternalUrl = useCallback((url = "") => {
    const safeUrl = String(url || "").trim();
    if (!safeUrl || typeof window === "undefined") return;
    window.open(safeUrl, "_blank", "noopener,noreferrer");
  }, []);
  const selectedAuctionOriginAddress = useMemo(() => {
    const byLocationName = String(getLocationAddress(selectedAuctionViewRow?.location || "") || "").trim();
    const directLocation = String(selectedAuctionViewRow?.location || "").trim();
    return byLocationName || directLocation;
  }, [getLocationAddress, selectedAuctionViewRow]);
  const deliveryDriverStops = useMemo(() => {
    const rows = Array.isArray(auctionRegs) ? auctionRegs : [];
    return rows
      .map((row) => {
        const delivery = getRegistrationDelivery(row);
        const shippingRequested = !!isShippingRequested(row);
        const fulfillmentMode = getFulfillmentMode({ row, shippingRequested, delivery });
        const email = String(row?.bidderEmail || row?.email || "").trim().toLowerCase();
        if (!email || fulfillmentMode !== "delivery") return null;
        if (!(delivery?.hasSelection || delivery?.address || delivery?.transactionId || delivery?.deliveryDateKey)) return null;
        const box = String(row?.shelf || "").trim();
        const driverStatus = delivery?.delivered ? "delivered" : delivery?.failed ? "failed" : "pending";
        return {
          key: email,
          email,
          name: String(getDisplayBidderName(row) || getDisplayUsername(row) || row?.bidderName || email).trim() || email,
          phone: String(delivery?.phone || row?.phone || row?.phoneNumber || row?.bidderPhone || "").trim(),
          address: String(delivery?.address || "").trim(),
          box,
          transactionId: String(delivery?.transactionId || "").trim(),
          deliveryDateLabel: String(delivery?.deliveryDateLabel || delivery?.deliveryDateKey || "").trim(),
          location: String(delivery?.location || "").trim(),
          notes: String(delivery?.notes || "").trim(),
          proofPhotos: Array.isArray(delivery?.proofPhotos) ? delivery.proofPhotos : [],
          deliveredAtMs: Number(delivery?.deliveredAtMs || 0) || 0,
          failedAtMs: Number(delivery?.failedAtMs || 0) || 0,
          failedReason: String(delivery?.failedReason || "").trim(),
          status: driverStatus,
          row,
          delivery,
        };
      })
      .filter(Boolean)
      .sort((a, b) => {
        const statusRank = { pending: 0, failed: 1, delivered: 2 };
        const byStatus = (statusRank[a?.status] ?? 9) - (statusRank[b?.status] ?? 9);
        if (byStatus !== 0) return byStatus;
        const byDate = String(a?.deliveryDateLabel || "").localeCompare(String(b?.deliveryDateLabel || ""));
        if (byDate !== 0) return byDate;
        return String(a?.name || "").localeCompare(String(b?.name || ""));
      });
  }, [auctionRegs, getDisplayBidderName, getDisplayUsername, getRegistrationDelivery, getFulfillmentMode, isShippingRequested]);
  const deliveryDriverStopsByKey = useMemo(
    () => new Map(deliveryDriverStops.map((stop) => [stop.key, stop])),
    [deliveryDriverStops]
  );
  const deliveryDriverLocationOptions = useMemo(() => {
    const labels = Array.from(
      new Set(
        deliveryDriverStops
          .map((stop) => String(stop?.location || "").trim())
          .filter(Boolean)
      )
    ).sort((a, b) => a.localeCompare(b));
    return labels;
  }, [deliveryDriverStops]);
  const deliveryDriverActionStop = useMemo(() => {
    if (!deliveryDriverActionModal?.stopKey) return null;
    return deliveryDriverStopsByKey.get(deliveryDriverActionModal.stopKey) || null;
  }, [deliveryDriverActionModal?.stopKey, deliveryDriverStopsByKey]);
  const orderedDeliveryDriverStops = useMemo(() => {
    if (!deliveryDriverRouteKeys.length) return deliveryDriverStops;
    const seen = new Set();
    const ordered = deliveryDriverRouteKeys
      .map((key) => {
        const stop = deliveryDriverStopsByKey.get(key);
        if (!stop) return null;
        seen.add(key);
        return stop;
      })
      .filter(Boolean);
    deliveryDriverStops.forEach((stop) => {
      if (!seen.has(stop.key)) ordered.push(stop);
    });
    return ordered;
  }, [deliveryDriverRouteKeys, deliveryDriverStops, deliveryDriverStopsByKey]);
  const filteredOrderedDeliveryDriverStops = useMemo(() => {
    const locationFiltered =
      deliveryDriverLocationFilter === "all"
        ? orderedDeliveryDriverStops
        : orderedDeliveryDriverStops.filter(
          (stop) => String(stop?.location || "").trim() === deliveryDriverLocationFilter
        );
    const query = String(deliveryDriverSearch || "").trim().toLowerCase();
    if (!query) return locationFiltered;
    return locationFiltered.filter(
      (stop) => [
          stop?.name,
          stop?.email,
          stop?.phone,
          stop?.address,
          stop?.box,
          stop?.transactionId,
          stop?.deliveryDateLabel,
          stop?.location,
          stop?.failedReason,
        ]
          .map((value) => String(value || "").toLowerCase())
          .some((value) => value.includes(query))
    );
  }, [deliveryDriverLocationFilter, deliveryDriverSearch, orderedDeliveryDriverStops]);
  const deliveryDriverRouteStops = useMemo(() => {
    const activeStops = filteredOrderedDeliveryDriverStops.filter((stop) => stop.status !== "delivered" && stop.address);
    return activeStops.length ? activeStops : filteredOrderedDeliveryDriverStops.filter((stop) => stop.address);
  }, [filteredOrderedDeliveryDriverStops]);
  const deliveryDriverSummary = useMemo(() => {
    const total = filteredOrderedDeliveryDriverStops.length;
    const delivered = filteredOrderedDeliveryDriverStops.filter((stop) => stop.status === "delivered").length;
    const failed = filteredOrderedDeliveryDriverStops.filter((stop) => stop.status === "failed").length;
    return {
      total,
      delivered,
      failed,
      remaining: Math.max(0, total - delivered - failed),
    };
  }, [filteredOrderedDeliveryDriverStops]);
  const openDeliveryDriverDialog = useCallback(() => {
    setDeliveryDriverRouteKeys(deliveryDriverStops.map((stop) => stop.key));
    setDeliveryDriverLocationFilter("all");
    setDeliveryDriverSearch("");
    setDeliveryDriverRouteNote(deliveryDriverStops.length ? "Showing current delivery order." : "No delivery stops found for this auction.");
    setDeliveryDriverOpen(true);
  }, [deliveryDriverStops]);
  const closeDeliveryDriverDialog = useCallback(() => {
    if (deliveryDriverRouteBusy) return;
    setDeliveryDriverOpen(false);
  }, [deliveryDriverRouteBusy]);
  const closeDeliveryDriverActionModal = useCallback(() => {
    setDeliveryDriverActionModal({
      open: false,
      type: "",
      stopKey: "",
      failedReason: "",
    });
  }, []);
  const openDeliveryDriverActionModal = useCallback((stop, type) => {
    const normalizedType = String(type || "").trim().toLowerCase();
    if (!stop?.key || !["delivered", "failed"].includes(normalizedType)) return;
    setDeliveryDriverActionModal({
      open: true,
      type: normalizedType,
      stopKey: stop.key,
      failedReason: normalizedType === "failed" ? String(stop?.failedReason || "").trim() : "",
    });
  }, []);
  const optimizeDeliveryDriverRoute = useCallback(async () => {
    if (deliveryDriverRouteBusy) return;
    if (deliveryDriverRouteStops.length < 2) {
      setDeliveryDriverRouteKeys(deliveryDriverStops.map((stop) => stop.key));
      setDeliveryDriverRouteNote("Need at least two active delivery stops to optimize.");
      return;
    }
    if (!window.google?.maps?.DistanceMatrixService || !window.google?.maps?.TravelMode) {
      setDeliveryDriverRouteKeys(deliveryDriverStops.map((stop) => stop.key));
      setDeliveryDriverRouteNote("Google routing is unavailable right now, so this is the current stop order.");
      return;
    }
    setDeliveryDriverRouteBusy(true);
    try {
      const distanceService = new window.google.maps.DistanceMatrixService();
      const getMatrix = (originAddress, destinations) =>
        new Promise((resolve, reject) => {
          distanceService.getDistanceMatrix(
            {
              origins: [originAddress],
              destinations,
              travelMode: window.google.maps.TravelMode.DRIVING,
              unitSystem: window.google.maps.UnitSystem.IMPERIAL,
            },
            (response, status) => {
              if (status !== "OK") {
                reject(new Error(String(status || "distance_matrix_failed")));
                return;
              }
              resolve(response);
            }
          );
        });
      const remaining = [...deliveryDriverRouteStops];
      const optimized = [];
      let currentOrigin = selectedAuctionOriginAddress || remaining[0]?.address || "";
      while (remaining.length) {
        const matrix = await getMatrix(currentOrigin, remaining.map((stop) => stop.address));
        const elements = Array.isArray(matrix?.rows?.[0]?.elements) ? matrix.rows[0].elements : [];
        let bestIndex = 0;
        let bestValue = Number.POSITIVE_INFINITY;
        elements.forEach((entry, index) => {
          const value = Number(entry?.duration?.value ?? entry?.distance?.value ?? Number.POSITIVE_INFINITY);
          if (String(entry?.status || "").toUpperCase() === "OK" && value < bestValue) {
            bestIndex = index;
            bestValue = value;
          }
        });
        const nextStop = remaining.splice(bestIndex, 1)[0];
        optimized.push(nextStop);
        currentOrigin = nextStop?.address || currentOrigin;
      }
      const completed = orderedDeliveryDriverStops.filter((stop) => stop.status === "delivered");
      setDeliveryDriverRouteKeys([...optimized, ...completed].map((stop) => stop.key));
      setDeliveryDriverRouteNote(`Optimized ${optimized.length} active delivery stops using Google route data.`);
    } catch (error) {
      setDeliveryDriverRouteKeys(deliveryDriverStops.map((stop) => stop.key));
      setDeliveryDriverRouteNote(error?.message ? `Route optimization failed: ${error.message}` : "Route optimization failed, showing current order.");
    } finally {
      setDeliveryDriverRouteBusy(false);
    }
  }, [deliveryDriverRouteBusy, deliveryDriverRouteStops, deliveryDriverStops, orderedDeliveryDriverStops, selectedAuctionOriginAddress]);
  const handleDeliveryDriverStatusUpdate = useCallback(async (stop, nextStatus, failedReason = "") => {
    const statusKey = String(nextStatus || "").trim().toLowerCase();
    if (!stop?.email || !selectedAuctionId || !["delivered", "failed", "pending"].includes(statusKey)) return;
    setDeliveryDriverStatusBusyByKey((prev) => ({ ...prev, [stop.key]: true }));
    try {
      await updateRegistrationDelivered({
        auctionId: selectedAuctionId,
        email: stop.email,
        delivered: statusKey === "delivered",
        status: statusKey,
        failedReason: statusKey === "failed" ? String(failedReason || "").trim() : "",
      });
    } finally {
      setDeliveryDriverStatusBusyByKey((prev) => ({ ...prev, [stop.key]: false }));
    }
  }, [selectedAuctionId, updateRegistrationDelivered]);
  const handleDeliveryDriverPhotoUpload = useCallback(async (stop, fileList) => {
    const uploadFiles = Array.from(fileList || []).filter(Boolean);
    if (!stop?.email || !selectedAuctionId || !uploadFiles.length) return;
    setDeliveryDriverUploadBusyByKey((prev) => ({ ...prev, [stop.key]: true }));
    try {
      await uploadRegistrationDeliveryProofPhotos({
        auctionId: selectedAuctionId,
        email: stop.email,
        files: uploadFiles,
      });
    } finally {
      setDeliveryDriverUploadBusyByKey((prev) => ({ ...prev, [stop.key]: false }));
    }
  }, [selectedAuctionId, uploadRegistrationDeliveryProofPhotos]);
  const renderRegistrationTrendTooltip = ({ active, payload, label }) => {
    if (!active) return null;
    const row = payload?.[0]?.payload || payload?.[1]?.payload || null;
    if (!row) return null;
    const shippers = toAbsInt(row?.shippingRequestedCount || 0);
    const pickups = toAbsInt(row?.pickupCount || 0);
    const total = toAbsInt(row?.registrations || 0);
    return (
      <Paper
        elevation={0}
        sx={{
          p: 1,
          borderRadius: 1.5,
          border: "1px solid rgba(226,232,240,0.95)",
          boxShadow: "0 10px 30px rgba(15,23,42,0.12)",
          minWidth: 190,
        }}
      >
        <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 13 }}>
          {String(row?.bucketLabel || label || "")}
        </Typography>
        <Box sx={{ mt: 0.75, display: "grid", gap: 0.45 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography variant="caption" sx={{ color: "#2563eb", fontWeight: 900 }}>
              Shippers
            </Typography>
            <Typography variant="caption" sx={{ color: "#111827", fontWeight: 900 }}>
              {formatNumber2(shippers)}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography variant="caption" sx={{ color: "#ec4899", fontWeight: 900 }}>
              Pickups
            </Typography>
            <Typography variant="caption" sx={{ color: "#111827", fontWeight: 900 }}>
              {formatNumber2(pickups)}
            </Typography>
          </Box>
          <Divider sx={{ my: 0.35 }} />
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography variant="caption" sx={{ color: "#475569", fontWeight: 900 }}>
              Total Registrations
            </Typography>
            <Typography variant="caption" sx={{ color: "#111827", fontWeight: 900 }}>
              {formatNumber2(total)}
            </Typography>
          </Box>
        </Box>
      </Paper>
    );
  };
  const [mountedRegistrationsAuctionId, setMountedRegistrationsAuctionId] = React.useState(null);
  const [registrationsViewReady, setRegistrationsViewReady] = React.useState(false);
  const isRegistrationsViewActive = auctionViewMode === "registrations";
  const shouldKeepRegistrationsMounted =
    !!selectedAuctionId && mountedRegistrationsAuctionId === selectedAuctionId;
  const shouldMountRegistrationsView =
    !!selectedAuctionId && (isRegistrationsViewActive || shouldKeepRegistrationsMounted);

  React.useEffect(() => {
    setMountedRegistrationsAuctionId(null);
    setRegistrationsViewReady(false);
  }, [selectedAuctionId]);

  React.useEffect(() => {
    if (!isRegistrationsViewActive || !selectedAuctionId || registrationsViewReady) return undefined;

    setMountedRegistrationsAuctionId(selectedAuctionId);

    let frameId = 0;
    let timeoutId = 0;
    const activateView = () => setRegistrationsViewReady(true);

    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
      frameId = window.requestAnimationFrame(() => {
        timeoutId = window.setTimeout(activateView, 0);
      });
    } else {
      timeoutId = setTimeout(activateView, 0);
    }

    return () => {
      if (typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function" && frameId) {
        window.cancelAnimationFrame(frameId);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isRegistrationsViewActive, registrationsViewReady, selectedAuctionId]);

  return (
    <>

      <Box
        sx={{
          display: "grid",

          gap: 2,
          alignItems: "start",
          width: "100%",
          minWidth: 0,
        }}
      >
        <Paper
          sx={{
            borderRadius: 3,
            p: 2,
            border: "1px solid rgba(51,57,153,0.10)",
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gap: 1.25,
              gridTemplateColumns: { xs: "1fr", lg: "repeat(2, minmax(0, 1fr))" },
            }}
          >
            {selectedAuctionId ? (
              <Box
                sx={{
                  p: 1.2,
                  borderRadius: 2.5,
                  border: "1px solid rgba(51,57,153,0.14)",
                  background: "linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>Auction Navigation</Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                    Current auction controls
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                  <Button
                    onClick={backToAuctionList}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      border: "1px solid rgba(51,57,153,0.18)",
                      color: primary,
                      background: "#fff",
                      "&:hover": { background: "rgba(99,102,241,0.06)" },
                    }}
                  >
                    Back to Auction List
                  </Button>

                  <Button
                    onClick={() => {
                      if (!selectedAuctionId) return;
                      fetchAuctionSummary(selectedAuctionId, { force: true });
                      fetchAuctionRegsPage({
                        auctionId: selectedAuctionId,
                        sync: false,
                        force: true,
                      });
                    }}
                    disabled={!selectedAuctionId || aregLoading || auctionSummaryLoading}
                    startIcon={aregLoading || auctionSummaryLoading ? <CircularProgress size={16} /> : <RefreshIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: "#fff",
                      background: "linear-gradient(90deg,#6366f1,#4f46e5)",
                      "&:hover": {
                        background: "linear-gradient(90deg,#4f46e5,#4338ca)",
                      },
                    }}
                  >
                    Refresh
                  </Button>

                  <Button
                    onClick={openDeliveryDriverDialog}
                    disabled={!deliveryDriverStops.length}
                    startIcon={<DirectionsCarFilledOutlinedIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: deliveryDriverStops.length ? "#fff" : "#e5e7eb",
                      background: deliveryDriverStops.length
                        ? "linear-gradient(90deg,#f59e0b,#d97706)"
                        : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      "&:hover": {
                        background: deliveryDriverStops.length
                          ? "linear-gradient(90deg,#d97706,#b45309)"
                          : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      },
                    }}
                  >
                    {deliveryDriverStops.length
                      ? `Get Delivery Details (${formatNumber2(deliveryDriverStops.length)})`
                      : "Get Delivery Details"}
                  </Button>
                </Box>
              </Box>
            ) : null}

            {selectedAuctionId ? (
              <Box
                sx={{
                  p: 1.2,
                  borderRadius: 2.5,
                  border: "1px solid rgba(14,165,233,0.18)",
                  background: "linear-gradient(180deg,#f8fdff 0%,#f8fafc 100%)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>Selected Registrations</Typography>
                  <Typography variant="caption" sx={{ color: "#0369a1", fontWeight: 800 }}>
                    {formatNumber2(getSelectedRegRows().length)} selected
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                  <Button
                    onClick={() => openEmailForAuctionSelection(getSelectedRegRows())}
                    disabled={!getSelectedRegRows().length}
                    startIcon={<MailOutlineIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: "#fff",
                      background: getSelectedRegRows().length
                        ? "linear-gradient(90deg,#0ea5e9,#0284c7)"
                        : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      "&:hover": {
                        background: getSelectedRegRows().length
                          ? "linear-gradient(90deg,#0284c7,#0369a1)"
                          : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      },
                    }}
                  >
                    Email selected
                  </Button>

                  <Button
                    onClick={exportSelectedRegistrationsWorkbook}
                    disabled={!getSelectedRegRows().length || selectedRegsExportBusy}
                    startIcon={selectedRegsExportBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: "#fff",
                      background: getSelectedRegRows().length
                        ? "linear-gradient(90deg,#16a34a,#15803d)"
                        : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      "&:hover": {
                        background: getSelectedRegRows().length
                          ? "linear-gradient(90deg,#15803d,#166534)"
                          : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      },
                    }}
                  >
                    {selectedRegsExportBusy ? "Preparing XLSX..." : "Download selected"}
                  </Button>

                  <Button
                    onClick={() => {
                      void exportBulkRegistrationBoxLabelsPdf({
                        rows: bulkBoxLabelRows,
                        mode: bulkBoxLabelMode,
                      });
                    }}
                    disabled={!bulkBoxLabelRows.length || registrationBoxLabelsBusy}
                    startIcon={registrationBoxLabelsBusy ? <CircularProgress size={16} /> : <LocalPrintshopOutlinedIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: "#fff",
                      background: bulkBoxLabelRows.length
                        ? "linear-gradient(90deg,#f97316,#ea580c)"
                        : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      "&:hover": {
                        background: bulkBoxLabelRows.length
                          ? "linear-gradient(90deg,#ea580c,#c2410c)"
                          : "linear-gradient(90deg,#9ca3af,#6b7280)",
                      },
                    }}
                  >
                    {registrationBoxLabelsBusy
                      ? bulkBoxLabelMode === "selected"
                        ? "Preparing Selected Boxes..."
                        : "Preparing All Boxes..."
                      : bulkBoxLabelMode === "selected"
                        ? "Print Selected Boxes"
                        : "Print All Boxes"}
                  </Button>
                </Box>
              </Box>
            ) : null}

            <Dialog
              open={deliveryDriverOpen}
              onClose={closeDeliveryDriverDialog}
              maxWidth="lg"
              fullWidth
              PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
            >
              <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
                {selectedAuctionLabel || selectedAuctionId ? `Delivery Driver: ${selectedAuctionLabel || selectedAuctionId}` : "Delivery Driver"}
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: "#f8fafc" }}>
                <Box sx={{ display: "grid", gap: 1.25 }}>
                  <Box
                    sx={{
                      p: 1.4,
                      borderRadius: 2.4,
                      border: "1px solid rgba(245,158,11,0.22)",
                      background: "linear-gradient(180deg,#fffdf7 0%,#ffffff 100%)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                      <Box>
                        <Typography sx={{ fontWeight: 900, color: "#0f172a" }}>Auction Delivery Route</Typography>
                        <Typography variant="body2" sx={{ color: "#64748b", mt: 0.25 }}>
                          Driver view for this auction with routing, maps, and delivery actions.
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                        <TextField
                          size="small"
                          value={deliveryDriverSearch}
                          onChange={(event) => setDeliveryDriverSearch(String(event.target.value || ""))}
                          placeholder="Search driver stops"
                          sx={{
                            minWidth: { xs: "100%", sm: 230 },
                            background: "#fff",
                            borderRadius: 999,
                            "& .MuiOutlinedInput-root": { borderRadius: 999 },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <FormControl
                          size="small"
                          sx={{
                            minWidth: { xs: "100%", sm: 210 },
                            background: "#fff",
                            borderRadius: 999,
                          }}
                        >
                          <InputLabel id="delivery-driver-location-filter-label">Delivery Location</InputLabel>
                          <Select
                            labelId="delivery-driver-location-filter-label"
                            value={deliveryDriverLocationFilter}
                            label="Delivery Location"
                            onChange={(event) => setDeliveryDriverLocationFilter(String(event.target.value || "all"))}
                            sx={{ borderRadius: 999 }}
                          >
                            <MenuItem value="all">All Locations</MenuItem>
                            {deliveryDriverLocationOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Button
                          onClick={() => void optimizeDeliveryDriverRoute()}
                          disabled={deliveryDriverRouteBusy || deliveryDriverRouteStops.length < 2}
                          startIcon={deliveryDriverRouteBusy ? <CircularProgress size={14} /> : <DirectionsCarFilledOutlinedIcon />}
                          sx={{
                            textTransform: "none",
                            borderRadius: 999,
                            px: 2,
                            fontWeight: 900,
                            color: "#fff",
                            background: deliveryDriverRouteStops.length >= 2
                              ? "linear-gradient(90deg,#f59e0b,#d97706)"
                              : "linear-gradient(90deg,#9ca3af,#6b7280)",
                            "&:hover": {
                              background: deliveryDriverRouteStops.length >= 2
                                ? "linear-gradient(90deg,#d97706,#b45309)"
                                : "linear-gradient(90deg,#9ca3af,#6b7280)",
                            },
                          }}
                        >
                          {deliveryDriverRouteBusy ? "Optimizing..." : "Optimize Route"}
                        </Button>
                        <Button
                          onClick={() =>
                            openExternalUrl(
                              buildGoogleRouteUrl({
                                origin: selectedAuctionOriginAddress,
                                addresses: deliveryDriverRouteStops.map((stop) => stop.address),
                              })
                            )
                          }
                          disabled={!deliveryDriverRouteStops.length}
                          startIcon={<MapOutlinedIcon />}
                          sx={{
                            textTransform: "none",
                            borderRadius: 999,
                            px: 2,
                            fontWeight: 900,
                            border: "1px solid rgba(2,132,199,0.28)",
                            color: "#0369a1",
                            background: "#fff",
                            "&:hover": { background: "rgba(14,165,233,0.06)" },
                          }}
                        >
                          Google Route
                        </Button>
                        <Button
                          onClick={() =>
                            openExternalUrl(
                              buildAppleRouteUrl({
                                origin: selectedAuctionOriginAddress,
                                addresses: deliveryDriverRouteStops.map((stop) => stop.address),
                              })
                            )
                          }
                          disabled={!deliveryDriverRouteStops.length}
                          startIcon={<MapOutlinedIcon />}
                          sx={{
                            textTransform: "none",
                            borderRadius: 999,
                            px: 2,
                            fontWeight: 900,
                            border: "1px solid rgba(107,114,128,0.28)",
                            color: "#374151",
                            background: "#fff",
                            "&:hover": { background: "rgba(148,163,184,0.08)" },
                          }}
                        >
                          Apple Route
                        </Button>
                      </Box>
                    </Box>

                    <Box sx={{ mt: 1.1, display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, minmax(0, 1fr))" }, gap: 0.9 }}>
                      {[
                        { label: "Total Stops", value: deliveryDriverSummary.total, color: "#1d4ed8", bg: "#dbeafe", border: "#bfdbfe" },
                        { label: "Delivered", value: deliveryDriverSummary.delivered, color: "#166534", bg: "#dcfce7", border: "#bbf7d0" },
                        { label: "Failed", value: deliveryDriverSummary.failed, color: "#991b1b", bg: "#fee2e2", border: "#fecaca" },
                        { label: "Remaining", value: deliveryDriverSummary.remaining, color: "#92400e", bg: "#fef3c7", border: "#fde68a" },
                      ].map((item) => (
                        <Box key={item.label} sx={{ p: 1.1, borderRadius: 1.8, background: item.bg, border: `1px solid ${item.border}` }}>
                          <Typography variant="caption" sx={{ display: "block", color: item.color, fontWeight: 900 }}>
                            {item.label}
                          </Typography>
                          <Typography sx={{ color: "#111827", fontWeight: 900 }}>
                            {formatNumber2(item.value)}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <Box sx={{ mt: 1, display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
                      <Chip
                        size="small"
                        label={selectedAuctionOriginAddress ? `Route Origin: ${selectedAuctionOriginAddress}` : "Route Origin: First delivery stop"}
                        sx={{ borderRadius: 999, fontWeight: 800, maxWidth: "100%" }}
                      />
                      <Chip
                        size="small"
                        label={
                          deliveryDriverLocationFilter === "all"
                            ? "Showing all delivery locations"
                            : `Filtered Location: ${deliveryDriverLocationFilter}`
                        }
                        sx={{ borderRadius: 999, fontWeight: 800, background: "#ecfeff", color: "#155e75" }}
                      />
                      {deliveryDriverSearch ? (
                        <Chip
                          size="small"
                          label={`Search: ${deliveryDriverSearch}`}
                          sx={{ borderRadius: 999, fontWeight: 800, background: "#f1f5f9", color: "#334155" }}
                        />
                      ) : null}
                      {deliveryDriverRouteNote ? (
                        <Chip
                          size="small"
                          label={deliveryDriverRouteNote}
                          sx={{ borderRadius: 999, fontWeight: 800, background: "#eef2ff", color: "#3730a3" }}
                        />
                      ) : null}
                    </Box>
                  </Box>

                  {!filteredOrderedDeliveryDriverStops.length ? (
                    <Paper sx={{ p: 3, borderRadius: 2.4, textAlign: "center", color: "#64748b" }}>
                      {deliveryDriverSearch
                        ? "No delivery stops match the current search and location filters."
                        : deliveryDriverLocationFilter === "all"
                          ? "No delivery stops found for this auction yet."
                          : "No delivery stops found for the selected delivery location."}
                    </Paper>
                  ) : (
                    <Box sx={{ display: "grid", gap: 1 }}>
                      {filteredOrderedDeliveryDriverStops.map((stop, index) => {
                        const stopBusy = !!deliveryDriverStatusBusyByKey?.[stop.key];
                        const uploadBusy = !!deliveryDriverUploadBusyByKey?.[stop.key];
                        const statusMeta =
                          stop.status === "delivered"
                            ? { label: "Delivered", color: "#166534", bg: "#dcfce7", border: "#86efac", icon: <TaskAltIcon sx={{ fontSize: 16 }} /> }
                            : stop.status === "failed"
                              ? { label: "Failed Delivery", color: "#991b1b", bg: "#fee2e2", border: "#fca5a5", icon: <ErrorOutlineIcon sx={{ fontSize: 16 }} /> }
                              : { label: "Pending", color: "#92400e", bg: "#fef3c7", border: "#fde68a", icon: <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 16 }} /> };
                        return (
                          <Paper
                            key={stop.key}
                            sx={{
                              p: 1.3,
                              borderRadius: 2.3,
                              border: "1px solid rgba(226,232,240,0.95)",
                              boxShadow: "none",
                              opacity: stop.status === "delivered" ? 0.82 : 1,
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1.25, flexWrap: "wrap" }}>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ color: "#94a3b8", fontWeight: 900, fontSize: 12 }}>
                                  Stop {formatNumber2(index + 1)}
                                </Typography>
                                <Typography sx={{ fontWeight: 900, color: "#111827", mt: 0.15 }}>
                                  {stop.name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#475569", mt: 0.2 }}>
                                  {stop.email}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#475569" }}>
                                  {stop.phone || "No phone number"}
                                </Typography>
                              </Box>
                              <Chip
                                icon={statusMeta.icon}
                                label={statusMeta.label}
                                sx={{
                                  borderRadius: 999,
                                  fontWeight: 900,
                                  color: statusMeta.color,
                                  background: statusMeta.bg,
                                  border: `1px solid ${statusMeta.border}`,
                                }}
                              />
                            </Box>

                            <Box sx={{ mt: 1, display: "grid", gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1.6fr) minmax(260px, 1fr)" }, gap: 1.1 }}>
                              <Box sx={{ display: "grid", gap: 0.55 }}>
                                <Typography variant="body2" sx={{ color: "#0f172a", fontWeight: 800 }}>
                                  {stop.address || "No address"}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                  Box: {stop.box || "—"}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                  Transaction ID: {stop.transactionId || "—"}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                  Delivery Date: {stop.deliveryDateLabel || "—"}
                                </Typography>
                                {stop.location ? (
                                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                    Delivery Location: {stop.location}
                                  </Typography>
                                ) : null}
                                {stop.failedReason ? (
                                  <Typography variant="caption" sx={{ color: "#991b1b", fontWeight: 800 }}>
                                    Failed Reason: {stop.failedReason}
                                  </Typography>
                                ) : null}
                              </Box>

                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, alignItems: { xs: "stretch", md: "flex-end" } }}>
                                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: { md: "flex-end" } }}>
                                  <Button
                                    component="label"
                                    disabled={uploadBusy}
                                    startIcon={uploadBusy ? <CircularProgress size={16} /> : <UploadFileIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: 999,
                                      px: 1.7,
                                      fontWeight: 900,
                                      border: "1px solid rgba(16,185,129,0.28)",
                                      color: "#047857",
                                      background: "#fff",
                                      "&:hover": { background: "rgba(16,185,129,0.06)" },
                                    }}
                                  >
                                    {uploadBusy
                                      ? "Uploading..."
                                      : stop.proofPhotos?.length
                                        ? `Add Photos (${formatNumber2(stop.proofPhotos.length)})`
                                        : "Take Photos"}
                                    <Box
                                      component="input"
                                      type="file"
                                      accept="image/*"
                                      capture="environment"
                                      multiple
                                      sx={{ display: "none" }}
                                      onChange={(event) => {
                                        const nextFiles = event.target?.files;
                                        if (nextFiles?.length) {
                                          void handleDeliveryDriverPhotoUpload(stop, nextFiles);
                                        }
                                        event.target.value = "";
                                      }}
                                    />
                                  </Button>
                                  <Button
                                    onClick={() => openExternalUrl(buildGoogleMapsUrl(stop.address))}
                                    disabled={!stop.address}
                                    startIcon={<MapOutlinedIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: 999,
                                      px: 1.7,
                                      fontWeight: 900,
                                      border: "1px solid rgba(2,132,199,0.28)",
                                      color: "#0369a1",
                                      background: "#fff",
                                      "&:hover": { background: "rgba(14,165,233,0.06)" },
                                    }}
                                  >
                                    Google Maps
                                  </Button>
                                  <Button
                                    onClick={() => openExternalUrl(buildAppleMapsUrl(stop.address))}
                                    disabled={!stop.address}
                                    startIcon={<MapOutlinedIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: 999,
                                      px: 1.7,
                                      fontWeight: 900,
                                      border: "1px solid rgba(107,114,128,0.28)",
                                      color: "#374151",
                                      background: "#fff",
                                      "&:hover": { background: "rgba(148,163,184,0.08)" },
                                    }}
                                  >
                                    Apple Maps
                                  </Button>
                                </Box>
                                {stop.proofPhotos?.length ? (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "grid",
                                      gridTemplateColumns: "repeat(auto-fill, minmax(88px, 1fr))",
                                      gap: 0.75,
                                      mt: 0.15,
                                    }}
                                  >
                                    {stop.proofPhotos.map((photo, photoIndex) => (
                                      <Box
                                        key={`${stop.key}-photo-${photoIndex}-${photo.url}`}
                                        onClick={() => openExternalUrl(photo.url)}
                                        sx={{
                                          cursor: "pointer",
                                          borderRadius: 1.8,
                                          overflow: "hidden",
                                          border: "1px solid rgba(226,232,240,0.95)",
                                          background: "#f8fafc",
                                        }}
                                      >
                                        <Box
                                          component="img"
                                          src={photo.url}
                                          alt={photo.fileName || `${stop.name} delivery proof`}
                                          sx={{
                                            display: "block",
                                            width: "100%",
                                            height: 88,
                                            objectFit: "cover",
                                          }}
                                        />
                                        <Box sx={{ px: 0.75, py: 0.55 }}>
                                          <Typography variant="caption" sx={{ display: "block", color: "#475569", fontWeight: 800 }}>
                                            {fmtDate(photo.uploadedAtMs) || "Uploaded"}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    ))}
                                  </Box>
                                ) : null}
                                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: { md: "flex-end" } }}>
                                  <Button
                                    onClick={() => openDeliveryDriverActionModal(stop, "delivered")}
                                    disabled={stopBusy || stop.status === "delivered"}
                                    startIcon={stopBusy && stop.status !== "delivered" ? <CircularProgress size={14} /> : <TaskAltIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: 999,
                                      px: 1.8,
                                      fontWeight: 900,
                                      color: "#fff",
                                      background: stop.status === "delivered"
                                        ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                                        : "linear-gradient(90deg,#16a34a,#15803d)",
                                      "&:hover": {
                                        background: stop.status === "delivered"
                                          ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                                          : "linear-gradient(90deg,#15803d,#166534)",
                                      },
                                    }}
                                  >
                                    Delivered
                                  </Button>
                                  <Button
                                    onClick={() => openDeliveryDriverActionModal(stop, "failed")}
                                    disabled={stopBusy || stop.status === "failed"}
                                    startIcon={stopBusy && stop.status !== "failed" ? <CircularProgress size={14} /> : <ErrorOutlineIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: 999,
                                      px: 1.8,
                                      fontWeight: 900,
                                      color: "#fff",
                                      background: stop.status === "failed"
                                        ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                                        : "linear-gradient(90deg,#dc2626,#b91c1c)",
                                      "&:hover": {
                                        background: stop.status === "failed"
                                          ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                                          : "linear-gradient(90deg,#b91c1c,#991b1b)",
                                      },
                                    }}
                                  >
                                    Failed Delivery
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </Paper>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 2.5, py: 2, backgroundColor: "#f8fafc", borderTop: "1px solid #e5e7eb" }}>
                <Button
                  onClick={closeDeliveryDriverDialog}
                  sx={{
                    textTransform: "none",
                    borderRadius: 999,
                    px: 3,
                    fontWeight: 900,
                    color: "#fff",
                    background: "linear-gradient(90deg,#6b7280,#4b5563)",
                    "&:hover": { background: "linear-gradient(90deg,#4b5563,#374151)" },
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={deliveryDriverActionModal.open}
              onClose={closeDeliveryDriverActionModal}
              maxWidth="sm"
              fullWidth
              PaperProps={{ sx: { borderRadius: 3 } }}
            >
              <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
                {deliveryDriverActionModal.type === "failed" ? "Failed Delivery Reason" : "Confirm Delivered"}
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: "#f8fafc" }}>
                <Box sx={{ display: "grid", gap: 1.15 }}>
                  {deliveryDriverActionStop ? (
                    <Box
                      sx={{
                        p: 1.2,
                        borderRadius: 2.2,
                        border: "1px solid rgba(226,232,240,0.95)",
                        background: "#fff",
                      }}
                    >
                      <Typography sx={{ fontWeight: 900, color: "#111827" }}>
                        {deliveryDriverActionStop.name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#475569", mt: 0.35 }}>
                        {deliveryDriverActionStop.address || "No address"}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#64748b", display: "block", mt: 0.5, fontWeight: 700 }}>
                        Transaction ID: {deliveryDriverActionStop.transactionId || "—"}
                      </Typography>
                    </Box>
                  ) : null}

                  {deliveryDriverActionModal.type === "failed" ? (
                    <>
                      <Alert severity="warning" sx={{ borderRadius: 2 }}>
                        Add a short reason so the team and bidder history show why this stop failed.
                      </Alert>
                      <TextField
                        label="Failed delivery reason"
                        value={deliveryDriverActionModal.failedReason}
                        onChange={(event) =>
                          setDeliveryDriverActionModal((prev) => ({
                            ...prev,
                            failedReason: String(event.target.value || ""),
                          }))
                        }
                        placeholder="No answer, bad address, access issue, customer unavailable..."
                        multiline
                        minRows={3}
                        fullWidth
                        autoFocus
                        sx={{ background: "#fff", borderRadius: 2 }}
                      />
                    </>
                  ) : (
                    <>
                      <Alert severity="success" sx={{ borderRadius: 2 }}>
                        Please take a proof photo if possible before marking this delivery complete.
                      </Alert>
                      <Box
                        sx={{
                          p: 1.2,
                          borderRadius: 2.2,
                          border: "1px dashed rgba(16,185,129,0.32)",
                          background: "rgba(240,253,244,0.8)",
                          display: "grid",
                          gap: 0.85,
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                          <Typography variant="body2" sx={{ color: "#166534", fontWeight: 900 }}>
                            {deliveryDriverActionStop?.proofPhotos?.length
                              ? `${formatNumber2(deliveryDriverActionStop.proofPhotos.length)} proof photo${deliveryDriverActionStop.proofPhotos.length === 1 ? "" : "s"} added`
                              : "No proof photos added yet"}
                          </Typography>
                          <Button
                            component="label"
                            disabled={!deliveryDriverActionStop || !!deliveryDriverUploadBusyByKey?.[deliveryDriverActionStop.key]}
                            startIcon={
                              deliveryDriverActionStop && deliveryDriverUploadBusyByKey?.[deliveryDriverActionStop.key]
                                ? <CircularProgress size={16} />
                                : <UploadFileIcon />
                            }
                            sx={{
                              textTransform: "none",
                              borderRadius: 999,
                              px: 1.8,
                              fontWeight: 900,
                              color: "#047857",
                              border: "1px solid rgba(16,185,129,0.28)",
                              background: "#fff",
                              "&:hover": { background: "rgba(16,185,129,0.06)" },
                            }}
                          >
                            {deliveryDriverActionStop && deliveryDriverUploadBusyByKey?.[deliveryDriverActionStop.key]
                              ? "Uploading..."
                              : "Take Image"}
                            <Box
                              component="input"
                              type="file"
                              accept="image/*"
                              capture="environment"
                              multiple
                              sx={{ display: "none" }}
                              onChange={(event) => {
                                const nextFiles = event.target?.files;
                                if (deliveryDriverActionStop && nextFiles?.length) {
                                  void handleDeliveryDriverPhotoUpload(deliveryDriverActionStop, nextFiles);
                                }
                                event.target.value = "";
                              }}
                            />
                          </Button>
                        </Box>
                        {deliveryDriverActionStop?.proofPhotos?.length ? (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(84px, 1fr))",
                              gap: 0.7,
                            }}
                          >
                            {deliveryDriverActionStop.proofPhotos.map((photo, index) => (
                              <Box
                                key={`${deliveryDriverActionStop.key}-modal-photo-${index}-${photo.url}`}
                                onClick={() => openExternalUrl(photo.url)}
                                sx={{
                                  cursor: "pointer",
                                  borderRadius: 1.6,
                                  overflow: "hidden",
                                  border: "1px solid rgba(167,243,208,0.9)",
                                  background: "#fff",
                                }}
                              >
                                <Box
                                  component="img"
                                  src={photo.url}
                                  alt={photo.fileName || "Delivery proof"}
                                  sx={{ display: "block", width: "100%", height: 84, objectFit: "cover" }}
                                />
                              </Box>
                            ))}
                          </Box>
                        ) : null}
                      </Box>
                    </>
                  )}
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 2.5, py: 2, backgroundColor: "#f8fafc", borderTop: "1px solid #e5e7eb" }}>
                <Button
                  onClick={closeDeliveryDriverActionModal}
                  sx={{
                    textTransform: "none",
                    borderRadius: 999,
                    px: 2.5,
                    fontWeight: 900,
                    color: "#475569",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={async () => {
                    if (!deliveryDriverActionStop) return;
                    const nextType = deliveryDriverActionModal.type;
                    await handleDeliveryDriverStatusUpdate(
                      deliveryDriverActionStop,
                      nextType,
                      deliveryDriverActionModal.failedReason
                    );
                    closeDeliveryDriverActionModal();
                  }}
                  disabled={
                    !deliveryDriverActionStop ||
                    !!deliveryDriverStatusBusyByKey?.[deliveryDriverActionStop?.key] ||
                    (deliveryDriverActionModal.type === "failed" &&
                      !String(deliveryDriverActionModal.failedReason || "").trim())
                  }
                  startIcon={
                    deliveryDriverActionStop && deliveryDriverStatusBusyByKey?.[deliveryDriverActionStop.key]
                      ? <CircularProgress size={16} />
                      : deliveryDriverActionModal.type === "failed"
                        ? <ErrorOutlineIcon />
                        : <TaskAltIcon />
                  }
                  sx={{
                    textTransform: "none",
                    borderRadius: 999,
                    px: 2.6,
                    fontWeight: 900,
                    color: "#fff",
                    background: deliveryDriverActionModal.type === "failed"
                      ? "linear-gradient(90deg,#dc2626,#b91c1c)"
                      : "linear-gradient(90deg,#16a34a,#15803d)",
                    "&:hover": {
                      background: deliveryDriverActionModal.type === "failed"
                        ? "linear-gradient(90deg,#b91c1c,#991b1b)"
                        : "linear-gradient(90deg,#15803d,#166534)",
                    },
                  }}
                >
                  {deliveryDriverActionModal.type === "failed" ? "Save Failed Delivery" : "Mark Delivered"}
                </Button>
              </DialogActions>
            </Dialog>

            {!selectedAuctionId ? (
              <Box
                sx={{
                  p: 1.2,
                  borderRadius: 2.5,
                  border: "1px solid rgba(22,163,74,0.16)",
                  background: "linear-gradient(180deg,#fbfffc 0%,#f8fafc 100%)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  gridColumn: { lg: "1 / -1" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                  <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>Dashboard Tools</Typography>
                  <Typography variant="caption" sx={{ color: "#166534", fontWeight: 800 }}>
                    Auctions and setup
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-start" },
                    flexDirection: { xs: "column", sm: "row" },
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={openCreateAuctionDialog}
                    disabled={!orgReady || createAuctionBusy || uploadBusy || shipBusy}
                    startIcon={createAuctionBusy ? <CircularProgress size={16} /> : <GavelIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: "#fff",
                      background: "linear-gradient(90deg,#16a34a,#15803d)",
                      "&:hover": { background: "linear-gradient(90deg,#15803d,#166534)" },
                    }}
                  >
                    Create New Auction
                  </Button>

                  <Button
                    onClick={() => setOverallDashboardOpen(true)}
                    disabled={!auctions.length}
                    startIcon={<InsightsIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      border: "1px solid rgba(51,57,153,0.18)",
                      color: primary,
                      background: "#fff",
                      "&:hover": { background: "rgba(99,102,241,0.06)" },
                    }}
                  >
                    Overall Dashboard
                  </Button>

                  <Button
                    onClick={openCompareAuctionsDialog}
                    disabled={!overallAuctionCompareOptions.length}
                    startIcon={<CompareArrowsIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      border: "1px solid rgba(51,57,153,0.18)",
                      color: primary,
                      background: "#fff",
                      "&:hover": { background: "rgba(99,102,241,0.06)" },
                    }}
                  >
                    Compare Auctions
                  </Button>

                  <Button
                    onClick={() => setAuctionWeeklyStatsOpen(true)}
                    disabled={!auctionHibidViewRows.length}
                    startIcon={<TodayIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      border: "1px solid rgba(51,57,153,0.18)",
                      color: primary,
                      background: "#fff",
                      "&:hover": { background: "rgba(99,102,241,0.06)" },
                    }}
                  >
                    Auction Weekly Stats
                  </Button>
                  <Button
                    onClick={() => setLocationsManagerOpen(true)}
                    startIcon={<ListAltIcon />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      border: "1px solid rgba(51,57,153,0.18)",
                      color: primary,
                      background: "#fff",
                      "&:hover": { background: "rgba(99,102,241,0.06)" },
                    }}
                  >
                    Manage Locations
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>

          {!selectedAuctionId ? (
            <>
              <Divider sx={{ my: 2 }} />
              <Paper
                sx={{
                  p: { xs: 1.25, md: 1.6 },
                  borderRadius: 3,
                  border: "1px solid rgba(51,57,153,0.18)",
                  background: "linear-gradient(180deg,#eef2ff 0%, #f8fafc 18%, #f8fafc 100%)",
                }}
              >
                <Typography
                  sx={{
                    textAlign: "center",
                    mb: 1.25,
                    color: "#0f172a",
                    fontWeight: 900,
                    fontSize: 14,
                    letterSpacing: 0.7,
                  }}
                >
                  EXISITING AUCTIONS
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 1, flexWrap: "wrap" }}>
                  <TextField
                    size="small"
                    value={auctionHibidSearch}
                    onChange={(e) => setAuctionHibidSearch(e.target.value)}
                    placeholder="Search auction name or location..."
                    sx={{
                      flex: 1,
                      minWidth: 260,
                      background: "#fff",
                      borderRadius: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        "& fieldset": { borderColor: "rgba(51,57,153,0.22)" },
                        "&:hover fieldset": { borderColor: "rgba(51,57,153,0.42)" },
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 220,
                      background: "#fff",
                      borderRadius: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        "& fieldset": { borderColor: "rgba(51,57,153,0.22)" },
                        "&:hover fieldset": { borderColor: "rgba(51,57,153,0.42)" },
                      },
                    }}
                  >
                    <InputLabel id="auction-location-filter-label">Location</InputLabel>
                    <Select
                      labelId="auction-location-filter-label"
                      label="Location"
                      value={auctionLocationFilter}
                      onChange={(e) => setAuctionLocationFilter(String(e.target.value || "all"))}
                    >
                      <MenuItem value="all">All Locations</MenuItem>
                      {auctionLocationFilterOptions.map((loc) => (
                        <MenuItem key={loc} value={loc}>
                          {loc}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                    <FormControlLabel
                      sx={{ m: 0, mr: 0.35 }}
                      control={
                        <Switch
                          checked={auctionListLayout !== "cards"}
                          onChange={(e) => setAuctionListLayout(e.target.checked ? "table" : "cards")}
                          size="small"
                        />
                      }
                      label={
                        <Typography variant="caption" sx={{ fontWeight: 900, color: "#334155" }}>
                          Table View
                        </Typography>
                      }
                    />
                    <Chip
                      size="small"
                      label={`${formatNumber2(toAbsInt(filteredAuctionHibidViewRows.length))} / ${formatNumber2(
                        toAbsInt(locationScopedAuctionHibidViewRows.length)
                      )} / ${formatNumber2(toAbsInt(auctionHibidViewRows.length))} auctions`}
                      sx={{
                        borderRadius: 999,
                        fontWeight: 900,
                        color: primary,
                        border: "1px solid rgba(51,57,153,0.22)",
                        background: "#fff",
                      }}
                    />
                  </Box>
                </Box>
                <Typography variant="body2" sx={{ color: "#475569", mb: 1.1, fontWeight: 700 }}>
                  Click an auction title to open Auction Summary.
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b", mb: 1.1, display: "block", fontWeight: 700 }}>
                  P = previous auction, A = average across all other auctions in selected location.
                </Typography>
                {auctionHibidViewRows.length === 0 ? (
                  <Alert severity="info" sx={{ borderRadius: 2 }}>
                    No auctions loaded yet.
                  </Alert>
                ) : filteredAuctionHibidViewRows.length === 0 ? (
                  <Alert severity="info" sx={{ borderRadius: 2 }}>
                    No auctions match your filters.
                  </Alert>
                ) : auctionListLayout !== "cards" ? (
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      border: "1px solid rgba(148,163,184,0.28)",
                      background: "#fff",
                      maxHeight: "68vh",
                    }}
                  >
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow sx={{ "& .MuiTableCell-root": { background: "#e2e8f0", color: "#0f172a", fontWeight: 900 } }}>
                          <TableCell>
                            <TableSortLabel
                              active={auctionTableSortKey === "auctionName"}
                              direction={auctionTableSortKey === "auctionName" ? auctionTableSortDir : "asc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "auctionName", "asc")}
                            >
                              Auction
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={auctionTableSortKey === "status"}
                              direction={auctionTableSortKey === "status" ? auctionTableSortDir : "asc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "status", "asc")}
                            >
                              Status
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={auctionTableSortKey === "files"}
                              direction={auctionTableSortKey === "files" ? auctionTableSortDir : "desc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "files", "desc")}
                            >
                              Files
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalRegistrations"}
                              direction={auctionTableSortKey === "totalRegistrations" ? auctionTableSortDir : "desc"}
                              onClick={() =>
                                applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalRegistrations", "desc")
                              }
                            >
                              Registrations
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalLots"}
                              direction={auctionTableSortKey === "totalLots" ? auctionTableSortDir : "desc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalLots", "desc")}
                            >
                              Lots
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalLotsWon"}
                              direction={auctionTableSortKey === "totalLotsWon" ? auctionTableSortDir : "desc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalLotsWon", "desc")}
                            >
                              Bought / Passed
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalViews"}
                              direction={auctionTableSortKey === "totalViews" ? auctionTableSortDir : "desc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalViews", "desc")}
                            >
                              Views
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalUniqueBidders"}
                              direction={auctionTableSortKey === "totalUniqueBidders" ? auctionTableSortDir : "desc"}
                              onClick={() =>
                                applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalUniqueBidders", "desc")
                              }
                            >
                              Unique Bidders
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalBids"}
                              direction={auctionTableSortKey === "totalBids" ? auctionTableSortDir : "desc"}
                              onClick={() => applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalBids", "desc")}
                            >
                              Total Bids
                            </TableSortLabel>
                          </TableCell>
                          <TableCell align="right">
                            <TableSortLabel
                              active={auctionTableSortKey === "totalHighValue"}
                              direction={auctionTableSortKey === "totalHighValue" ? auctionTableSortDir : "desc"}
                              onClick={() =>
                                applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "totalHighValue", "desc")
                              }
                            >
                              Total Hammer Price
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            Seller
                          </TableCell>
                          <TableCell>
                            Lister
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={auctionTableSortKey === "fulfillmentShipping"}
                              direction={auctionTableSortKey === "fulfillmentShipping" ? auctionTableSortDir : "desc"}
                              onClick={() =>
                                applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "fulfillmentShipping", "desc")
                              }
                            >
                              Fulfillment
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={auctionTableSortKey === "location"}
                              direction={auctionTableSortKey === "location" ? auctionTableSortDir : "asc"}
                              onClick={() =>
                                applySortToggle(auctionTableSortKey, setAuctionTableSortKey, setAuctionTableSortDir, "location", "asc")
                              }
                            >
                              Auction Settings
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sortedFilteredAuctionHibidViewRows.map((row, idx) => {
                          const statusSx =
                            row.statusTone === "success"
                              ? { background: "linear-gradient(90deg,#16a34a,#15803d)", color: "#fff" }
                              : row.statusTone === "warning"
                                ? { background: "linear-gradient(90deg,#f59e0b,#d97706)", color: "#111827" }
                                : { background: "linear-gradient(90deg,#dc2626,#b91c1c)", color: "#fff" };
                          const rowTrend =
                            auctionHibidTrendByRowKey[String(row?.auctionId || row?.auctionName || idx)] || {};
                          const regsTrend = rowTrend.totalRegistrations || {};
                          const lotsTrend = rowTrend.totalLots || {};
                          const viewsTrend = rowTrend.totalViews || {};
                          const uniqueTrend = rowTrend.totalUniqueBidders || {};
                          const bidsTrend = rowTrend.totalBids || {};
                          const highBidTrend = rowTrend.totalHighValue || {};
                          const shipCountTrend = rowTrend.fulfillmentShippingCount || {};
                          const pickupCountTrend = rowTrend.fulfillmentPickupCount || {};
                          const newUsersCountTrend = rowTrend.fulfillmentNewUsersCount || {};
                          const newShipCountTrend = rowTrend.fulfillmentNewShippingCount || {};
                          const newShareOfShippersTrend = rowTrend.fulfillmentNewShareOfShippersPct || {};
                          const newShipPctOfTotalTrend = rowTrend.fulfillmentNewShippingPctOfTotalRegs || {};
                          const shipCount = toAbsInt(row?.fulfillmentStats?.shippingRequestedCount ?? 0);
                          const pickupCount = toAbsInt(row?.fulfillmentStats?.pickupCount ?? 0);
                          const newCount = toAbsInt(row?.fulfillmentStats?.newUsersCount ?? 0);
                          const newShipCount = toAbsInt(row?.fulfillmentStats?.newUsersShippingRequestedCount ?? 0);
                          const totalRegistrations = toAbsInt(row?.fulfillmentStats?.totalRegistrations ?? row?.totalRegistrations ?? 0);
                          const shipPct = safeNum(row?.fulfillmentStats?.shippingRequestedPct ?? 0);
                          const pickupPct = safeNum(row?.fulfillmentStats?.pickupPct ?? 0);
                          const newUsersPct = safeNum(row?.fulfillmentStats?.newUsersPct ?? 0);
                          const newShipPctOfNew = safeNum(row?.fulfillmentStats?.newUsersShippingRequestedPct ?? 0);
                          const newShareOfShippersPct = shipCount > 0 ? (newShipCount / shipCount) * 100 : 0;
                          const newShipPctOfTotalRegs = totalRegistrations > 0 ? (newShipCount / totalRegistrations) * 100 : 0;
                          const boughtLots = toAbsInt(row?.totalLotsWon ?? 0);
                          const passedLots = toAbsInt(row?.totalLotsPassed ?? Math.max(0, toAbsInt(row?.totalLots) - boughtLots));
                          const boughtLotsPct = safeNum(
                            row?.boughtLotsPct ??
                            (toAbsInt(row?.totalLots) > 0 ? (boughtLots / toAbsInt(row?.totalLots)) * 100 : 0)
                          );
                          const passedLotsPct = safeNum(
                            row?.passedLotsPct ??
                            (toAbsInt(row?.totalLots) > 0 ? (passedLots / toAbsInt(row?.totalLots)) * 100 : 0)
                          );
                          const inlineDraft = getAuctionInlineInfoDraft(row);
                          const inlineLocationInput = getAuctionInlineLocationInput(row);
                          const inlineLocationOptions = getAuctionInlineLocationOptions(row);
                          return (
                            <TableRow
                              key={row.auctionId || row.auctionName}
                              hover
                              sx={{ "& td": { background: idx % 2 ? "#f8fafc" : "#fff", verticalAlign: "top" } }}
                            >
                              <TableCell sx={{ minWidth: 280 }}>
                                <Button
                                  onClick={() => {
                                    void openAuctionFromHibidView(row.row);
                                  }}
                                  sx={{
                                    px: 1.2,
                                    py: 0.25,
                                    minWidth: 0,
                                    textTransform: "none",
                                    borderRadius: 999,
                                    justifyContent: "flex-start",
                                    fontWeight: 900,
                                    color: primary,
                                    border: "1px solid rgba(51,57,153,0.22)",
                                    background: "rgba(99,102,241,0.08)",
                                    "&:hover": { background: "rgba(99,102,241,0.14)" },
                                  }}
                                >
                                  {row.auctionName}
                                </Button>
                                <Typography variant="caption" sx={{ display: "block", mt: 0.35, color: "#475569", fontWeight: 700 }}>
                                  {row.endLabel === "—" ? "End Date —" : `End ${row.endLabel}`}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ minWidth: 220 }}>
                                <Chip size="small" label={row.statusLabel} sx={{ borderRadius: 999, fontWeight: 900, ...statusSx }} />
                                {row.needsLatestAfterEnd ? (
                                  <Typography
                                    variant="caption"
                                    sx={{ display: "block", mt: 0.4, color: "#991b1b", fontWeight: 900 }}
                                  >
                                    Ended. Upload latest files.
                                  </Typography>
                                ) : null}
                              </TableCell>
                              <TableCell sx={{ minWidth: 180 }}>
                                <Typography variant="caption" sx={{ display: "block", color: row.hasShippingUpload ? "#166534" : "#991b1b", fontWeight: 800 }}>
                                  Shipping XLSX: {row.hasShippingUpload ? "Uploaded" : "Not Uploaded"}
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#475569" }}>
                                  {row.shippingUploadAtMs ? `Last ${fmtDate(row.shippingUploadAtMs)}` : "No upload yet"}
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", mt: 0.25, color: row.hasLotsUpload ? "#166534" : "#991b1b", fontWeight: 800 }}>
                                  Lots: {row.hasLotsUpload ? "Uploaded" : "Not Uploaded"}
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#475569" }}>
                                  {row.lotsUploadAtMs ? `Last ${fmtDate(row.lotsUploadAtMs)}` : "No upload yet"}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ display: "block", mt: 0.25, color: row.listernautUploadStatusColor || (row.hasListernautUpload ? "#166534" : "#991b1b"), fontWeight: 800 }}
                                >
                                  Listernaut: {row.listernautUploadStatusLabel || (row.hasListernautUpload ? "Uploaded" : "Not Uploaded")}
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#475569" }}>
                                  {row.listernautUploadAtMs ? `Last ${fmtDate(row.listernautUploadAtMs)}` : "No upload yet"}
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#334155", fontWeight: 800 }}>
                                  {formatNumber2(toAbsInt(row.listernautUpdatedLots || 0))} updated • {formatNumber2(toAbsInt(row.listernautMatchedLots || 0))} matched • {formatNumber2(toAbsInt(row.listernautRows || 0))} rows
                                </Typography>
                                {row.listernautUploadStatusNote ? (
                                  <Typography variant="caption" sx={{ display: "block", color: row.listernautUploadStatusColor || "#92400e", fontWeight: 700 }}>
                                    {row.listernautUploadStatusNote}
                                  </Typography>
                                ) : null}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 135 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>{formatNumber2(toAbsInt(row.totalRegistrations))}</Typography>
                                {renderTrendDeltaPair(row.totalRegistrations, regsTrend.previous, regsTrend.avg)}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 115 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>{formatNumber2(toAbsInt(row.totalLots))}</Typography>
                                {renderTrendDeltaPair(row.totalLots, lotsTrend.previous, lotsTrend.avg)}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 185 }}>
                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  Bought: {formatNumber2(boughtLots)} ({formatPercent2(boughtLotsPct)})
                                </Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  Passed: {formatNumber2(passedLots)} ({formatPercent2(passedLotsPct)})
                                </Typography>
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 120 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>{formatNumber2(toAbsInt(row.totalViews))}</Typography>
                                {renderTrendDeltaPair(row.totalViews, viewsTrend.previous, viewsTrend.avg)}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 135 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>{formatNumber2(toAbsInt(row.totalUniqueBidders))}</Typography>
                                {renderTrendDeltaPair(row.totalUniqueBidders, uniqueTrend.previous, uniqueTrend.avg)}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 120 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>{formatNumber2(toAbsInt(row.totalBids))}</Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#475569", fontWeight: 800 }}>
                                  Avg Bid / Won Lot: {safeNum(row.avgBidsPerWonLot || 0).toFixed(2)}
                                </Typography>
                                {renderTrendDeltaPair(row.totalBids, bidsTrend.previous, bidsTrend.avg)}
                              </TableCell>
                              <TableCell align="right" sx={{ minWidth: 135 }}>
                                <Typography sx={{ fontWeight: 900, color: "#111827" }}>${moneyPlain(row.totalHighValue || 0)}</Typography>
                                {renderTrendDeltaPair(row.totalHighValue, highBidTrend.previous, highBidTrend.avg, { money: true })}
                              </TableCell>
                              <TableCell sx={{ minWidth: 280 }}>
                                {renderAuctionShareMiniTable(row.sellerShareRows, "#047857", {
                                  showRevenue: true,
                                  consignorRows: row.consignorRows,
                                  showDisposition: true,
                                  showHammer: true,
                                })}
                              </TableCell>
                              <TableCell sx={{ minWidth: 280 }}>
                                {renderAuctionShareMiniTable(row.listerShareRows, "#1d4ed8", {
                                  showDisposition: true,
                                  showHammer: true,
                                })}
                              </TableCell>
                              <TableCell sx={{ minWidth: 430 }}>
                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(shipCount)} out of {formatNumber2(totalRegistrations)} are shippers ({formatPercent2(shipPct)}).
                                </Typography>
                                {renderTrendDeltaPair(shipCount, shipCountTrend.previous, shipCountTrend.avg)}

                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(pickupCount)} out of {formatNumber2(totalRegistrations)} are pickup ({formatPercent2(pickupPct)}).
                                </Typography>
                                {renderTrendDeltaPair(pickupCount, pickupCountTrend.previous, pickupCountTrend.avg)}

                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(newCount)} out of {formatNumber2(totalRegistrations)} are new users ({formatPercent2(newUsersPct)}).
                                </Typography>
                                {renderTrendDeltaPair(newCount, newUsersCountTrend.previous, newUsersCountTrend.avg)}

                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(newShipCount)} out of {formatNumber2(newCount)} new users are shippers ({formatPercent2(newShipPctOfNew)} of new).
                                </Typography>
                                {renderTrendDeltaPair(newShipCount, newShipCountTrend.previous, newShipCountTrend.avg)}

                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(newShipCount)} out of {formatNumber2(shipCount)} shippers are new users ({formatPercent2(newShareOfShippersPct)}).
                                </Typography>
                                {renderTrendDeltaPair(newShareOfShippersPct, newShareOfShippersTrend.previous, newShareOfShippersTrend.avg, { percent: true })}

                                <Typography variant="caption" sx={{ display: "block", color: "#0f172a", fontWeight: 800 }}>
                                  {formatNumber2(newShipCount)} out of {formatNumber2(totalRegistrations)} total registrations are new-user shippers (
                                  {formatPercent2(newShipPctOfTotalRegs)}).
                                </Typography>
                                {renderTrendDeltaPair(newShipPctOfTotalRegs, newShipPctOfTotalTrend.previous, newShipPctOfTotalTrend.avg, { percent: true })}
                              </TableCell>
                              <TableCell sx={{ minWidth: 235 }}>
                                <TextField
                                  type="datetime-local"
                                  label="End"
                                  size="small"
                                  fullWidth
                                  value={inlineDraft.endAtLocal}
                                  onChange={(e) => setAuctionInlineInfoField(row, "endAtLocal", e.target.value)}
                                  onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                  InputLabelProps={{ shrink: true }}
                                  sx={{ mb: 0.55 }}
                                />
                                <Autocomplete
                                  multiple
                                  size="small"
                                  options={auctionAccountManagerOptions}
                                  value={getAuctionInlineAccountManagerRows(row)}
                                  isOptionEqualToValue={(option, value) => option.id === value.id}
                                  getOptionLabel={(option) => String(option?.label || option?.id || "").trim()}
                                  onChange={(_, value) => {
                                    setAuctionInlineAccountManagerIds(
                                      row,
                                      (Array.isArray(value) ? value : []).map((item) => item?.id || "")
                                    );
                                  }}
                                  sx={{ mb: 0.55 }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Account Managers"
                                      placeholder="Select manager(s)"
                                      onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                    />
                                  )}
                                />
                                <FormControl size="small" fullWidth sx={{ mb: 0.55 }}>
                                  <InputLabel>Pickup Locations</InputLabel>
                                  <Select
                                    multiple
                                    value={getAuctionInlinePickupLocations(row)}
                                    label="Pickup Locations"
                                    onChange={(e) => {
                                      setAuctionInlinePickupLocations(row, e.target.value || []);
                                    }}
                                    onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                    renderValue={(selected) => {
                                      const values = Array.isArray(selected) ? selected.filter(Boolean) : [];
                                      return values.length ? values.join(", ") : "Select pickup location(s)";
                                    }}
                                  >
                                    {getPickupLocationSelectOptions(getAuctionInlinePickupLocations(row)).map((location) => {
                                      const current = getAuctionInlinePickupLocations(row);
                                      const checked = current.includes(location);
                                      const locationAddress = getLocationAddress(location);
                                      return (
                                        <MenuItem key={location} value={location}>
                                          <Checkbox checked={checked} size="small" />
                                          <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body2">{location}</Typography>
                                            {locationAddress ? (
                                              <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                                {locationAddress}
                                              </Typography>
                                            ) : null}
                                          </Box>
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                                {renderPickupLocationSelectedDetails(getAuctionInlinePickupLocations(row))}
                                <Box
                                  sx={{
                                    mb: 0.55,
                                    p: 0.75,
                                    borderRadius: 1.5,
                                    border: "1px solid rgba(226,232,240,0.95)",
                                    background: "#f8fafc",
                                  }}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 0.6 }}>
                                    <Typography variant="caption" sx={{ color: "#475569", fontWeight: 900, textTransform: "uppercase" }}>
                                      Pickup Slots
                                    </Typography>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() => addAuctionInlinePickupSlot(row)}
                                      sx={{ borderRadius: 999, fontWeight: 800, minWidth: 0, px: 1.1, textTransform: "none" }}
                                    >
                                      Add Slot
                                    </Button>
                                  </Box>
                                  <Box sx={{ display: "grid", gap: 0.55 }}>
                                    {getAuctionInlinePickupSlots(row).length ? (
                                      getAuctionInlinePickupSlots(row).map((slot) => (
                                        <Box
                                          key={String(slot?.slotId || "")}
                                          sx={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                            gap: 0.45,
                                          }}
                                        >
                                          <FormControl size="small" fullWidth>
                                            <InputLabel>Pickup Location</InputLabel>
                                            <Select
                                              value={String(slot?.location || "")}
                                              label="Pickup Location"
                                              onChange={(e) =>
                                                updateAuctionInlinePickupSlot(row, slot?.slotId, "location", e.target.value)
                                              }
                                              onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                              sx={{ background: "#fff", borderRadius: 2 }}
                                            >
                                              <MenuItem value="">
                                                <em>Select location</em>
                                              </MenuItem>
                                              {getAuctionInlinePickupLocations(row).map((location) => (
                                                <MenuItem key={location} value={location}>
                                                  {location}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                          <TextField
                                            size="small"
                                            label="Pickup Start"
                                            type="datetime-local"
                                            value={String(slot?.startAtLocal || "")}
                                            onChange={(e) => updateAuctionInlinePickupSlot(row, slot?.slotId, "startAtLocal", e.target.value)}
                                            onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 900 }}
                                          />
                                          <TextField
                                            size="small"
                                            label="Pickup End"
                                            type="datetime-local"
                                            value={String(slot?.endAtLocal || "")}
                                            onChange={(e) => updateAuctionInlinePickupSlot(row, slot?.slotId, "endAtLocal", e.target.value)}
                                            onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 900 }}
                                          />
                                          <Button
                                            size="small"
                                            color="error"
                                            variant="text"
                                            onClick={() => removeAuctionInlinePickupSlot(row, slot?.slotId)}
                                            sx={{ borderRadius: 999, fontWeight: 800, minWidth: 0, px: 0, justifyContent: "flex-start", textTransform: "none" }}
                                          >
                                            Remove
                                          </Button>
                                        </Box>
                                      ))
                                    ) : (
                                      <Typography variant="caption" sx={{ color: "#64748b" }}>
                                        No pickup slots
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                                {auctionInlineInfoSavingById[String(row?.auctionId || row?.id || "").trim()] ? (
                                  <Typography variant="caption" sx={{ display: "block", color: "#2563eb", fontWeight: 800 }}>
                                    Saving...
                                  </Typography>
                                ) : null}
                                <Divider sx={{ my: 0.8 }} />
                                <Typography variant="caption" sx={{ display: "block", color: "#475569", fontWeight: 900, textTransform: "uppercase" }}>
                                  Account Managers
                                </Typography>
                                <Box sx={{ mt: 0.4 }}>
                                  {renderAuctionManagerSummary(row.auctionAccountManagerNames)}
                                </Box>
                                <Typography variant="caption" sx={{ display: "block", mt: 0.8, color: "#475569", fontWeight: 900, textTransform: "uppercase" }}>
                                  Pickup Slots
                                </Typography>
                                <Box sx={{ mt: 0.4 }}>
                                  {renderAuctionPickupSlotSummary(row.pickupSlots)}
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box
                    sx={{
                      display: "grid",
                      gap: 1.1,
                    }}
                  >
                    {filteredAuctionHibidViewRows.map((row) => {
                      const rowKey = row.auctionId || row.auctionName;
                      const currentIndex = locationScopedAuctionHibidViewRows.findIndex(
                        (x) => (x.auctionId || x.auctionName) === rowKey
                      );
                      const previousAuction =
                        currentIndex >= 0 ? locationScopedAuctionHibidViewRows[currentIndex + 1] || null : null;
                      const peerRows =
                        currentIndex >= 0
                          ? locationScopedAuctionHibidViewRows.filter((_, idx) => idx !== currentIndex)
                          : [];
                      const avgOf = (key) => {
                        if (!peerRows.length) return null;
                        const total = peerRows.reduce(
                          (sum, item) => sum + safeNum(item?.[key] || 0),
                          0
                        );
                        return total / peerRows.length;
                      };

                      const formatMetricValue = (value, isMoney) =>
                        isMoney
                          ? `$${moneyPlain(value || 0)}`
                          : formatNumber2(toAbsInt(value));
                      const formatBaselineValue = (value, isMoney) =>
                        isMoney
                          ? `$${moneyPlain(value || 0)}`
                          : formatNumber2(toAbsInt(Math.round(value || 0)));
                      const formatDelta = (value, isMoney) => {
                        const num = safeNum(value);
                        if (Math.abs(num) < 1e-9) {
                          return isMoney ? "$0.00" : "0.00";
                        }
                        if (isMoney) {
                          return `${num > 0 ? "+" : "-"}$${moneyPlain(Math.abs(num))}`;
                        }
                        return `${num > 0 ? "+" : "-"}${formatNumber2(toAbsInt(Math.round(Math.abs(num))))}`;
                      };
                      const buildTrend = (current, baseline, isMoney, missingLabel) => {
                        if (baseline == null) {
                          return {
                            baselineText: missingLabel,
                            delta: null,
                            deltaText: "",
                          };
                        }
                        const delta = safeNum(current) - safeNum(baseline);
                        return {
                          baselineText: formatBaselineValue(baseline, isMoney),
                          delta,
                          deltaText: formatDelta(delta, isMoney),
                        };
                      };
                      const gridTotalRegistrations = toAbsInt(row?.fulfillmentStats?.totalRegistrations ?? row?.totalRegistrations ?? 0);
                      const gridShipCount = toAbsInt(row?.fulfillmentStats?.shippingRequestedCount ?? 0);
                      const gridPickupCount = toAbsInt(row?.fulfillmentStats?.pickupCount ?? 0);
                      const gridNewUsersCount = toAbsInt(row?.fulfillmentStats?.newUsersCount ?? 0);
                      const gridNewShipCount = toAbsInt(row?.fulfillmentStats?.newUsersShippingRequestedCount ?? 0);
                      const gridShipPct = safeNum(row?.fulfillmentStats?.shippingRequestedPct ?? 0);
                      const gridPickupPct = safeNum(row?.fulfillmentStats?.pickupPct ?? 0);
                      const gridNewUsersPctOfTotal =
                        gridTotalRegistrations > 0 ? (gridNewUsersCount / gridTotalRegistrations) * 100 : 0;
                      const gridNewShipPctOfNew = safeNum(row?.fulfillmentStats?.newUsersShippingRequestedPct ?? 0);
                      const gridNewShipPctOfTotalRegs =
                        gridTotalRegistrations > 0 ? (gridNewShipCount / gridTotalRegistrations) * 100 : 0;
                      const gridNewPickupCount = Math.max(0, gridNewUsersCount - gridNewShipCount);
                      const gridNewPickupPctOfNew = gridNewUsersCount > 0 ? (gridNewPickupCount / gridNewUsersCount) * 100 : 0;
                      const prevRow = previousAuction || {};
                      const gridShipPrev = previousAuction ? safeNum(prevRow?.fulfillmentShippingCount ?? prevRow?.fulfillmentStats?.shippingRequestedCount ?? 0) : null;
                      const gridShipAvg = avgOf("fulfillmentShippingCount");
                      const gridPickupPrev = previousAuction ? safeNum(prevRow?.fulfillmentPickupCount ?? prevRow?.fulfillmentStats?.pickupCount ?? 0) : null;
                      const gridPickupAvg = avgOf("fulfillmentPickupCount");
                      const gridNewUsersAvg = avgOf("fulfillmentNewUsersCount");
                      const gridNewShipPrev =
                        previousAuction ? safeNum(prevRow?.fulfillmentNewShippingCount ?? prevRow?.fulfillmentStats?.newUsersShippingRequestedCount ?? 0) : null;
                      const gridNewShipAvg = avgOf("fulfillmentNewShippingCount");
                      const gridNewPickupPrev = previousAuction
                        ? Math.max(
                          0,
                          safeNum(prevRow?.fulfillmentNewUsersCount ?? prevRow?.fulfillmentStats?.newUsersCount ?? 0) -
                          safeNum(prevRow?.fulfillmentNewShippingCount ?? prevRow?.fulfillmentStats?.newUsersShippingRequestedCount ?? 0)
                        )
                        : null;
                      const gridNewPickupAvg =
                        gridNewUsersAvg == null || gridNewShipAvg == null
                          ? null
                          : Math.max(0, safeNum(gridNewUsersAvg) - safeNum(gridNewShipAvg));
                      const gridNewShipPctOfTotalPrev = previousAuction ? safeNum(prevRow?.fulfillmentNewShippingPctOfTotalRegs ?? 0) : null;
                      const gridNewShipPctOfTotalAvg = avgOf("fulfillmentNewShippingPctOfTotalRegs");
                      const boughtLotsCount = toAbsInt(row?.totalLotsWon ?? 0);
                      const passedLotsCount = toAbsInt(row?.totalLotsPassed ?? Math.max(0, toAbsInt(row?.totalLots) - boughtLotsCount));
                      const boughtLotsPctValue = safeNum(
                        row?.boughtLotsPct ?? (toAbsInt(row?.totalLots) > 0 ? (boughtLotsCount / toAbsInt(row?.totalLots)) * 100 : 0)
                      );
                      const passedLotsPctValue = safeNum(
                        row?.passedLotsPct ?? (toAbsInt(row?.totalLots) > 0 ? (passedLotsCount / toAbsInt(row?.totalLots)) * 100 : 0)
                      );

                      const metricCards = [
                        {
                          label: "Total Registrations",
                          value: formatMetricValue(row.totalRegistrations, false),
                          previous: buildTrend(
                            row.totalRegistrations,
                            previousAuction ? previousAuction.totalRegistrations : null,
                            false,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.totalRegistrations,
                            avgOf("totalRegistrations"),
                            false,
                            "No average auction"
                          ),
                        },
                        {
                          label: "Total Views",
                          value: formatMetricValue(row.totalViews, false),
                          previous: buildTrend(
                            row.totalViews,
                            previousAuction ? previousAuction.totalViews : null,
                            false,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.totalViews,
                            avgOf("totalViews"),
                            false,
                            "No average auction"
                          ),
                        },
                        {
                          label: "Total Watches",
                          value: formatMetricValue(row.totalWatches, false),
                          previous: buildTrend(
                            row.totalWatches,
                            previousAuction ? previousAuction.totalWatches : null,
                            false,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.totalWatches,
                            avgOf("totalWatches"),
                            false,
                            "No average auction"
                          ),
                        },
                        {
                          label: "Total Bids",
                          value: formatMetricValue(row.totalBids, false),
                          subValue: `Avg Bid / Won Lot: ${safeNum(row.avgBidsPerWonLot || 0).toFixed(2)}`,
                          previous: buildTrend(
                            row.totalBids,
                            previousAuction ? previousAuction.totalBids : null,
                            false,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.totalBids,
                            avgOf("totalBids"),
                            false,
                            "No average auction"
                          ),
                        },
                        {
                          label: "Bought vs Passed Lots",
                          value: `${formatNumber2(boughtLotsCount)} / ${formatNumber2(passedLotsCount)}`,
                          subValue: `Bought ${formatPercent2(boughtLotsPctValue)} • Passed ${formatPercent2(passedLotsPctValue)}`,
                          previous: buildTrend(
                            boughtLotsCount,
                            previousAuction ? previousAuction.totalLotsWon : null,
                            false,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            boughtLotsCount,
                            avgOf("totalLotsWon"),
                            false,
                            "No average auction"
                          ),
                        },
                        {
                          label: "Total Hammer Price",
                          value: formatMetricValue(row.totalHighValue || 0, true),
                          previous: buildTrend(
                            row.totalHighValue || 0,
                            previousAuction ? previousAuction.totalHighValue || 0 : null,
                            true,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.totalHighValue || 0,
                            avgOf("totalHighValue"),
                            true,
                            "No average auction"
                          ),
                        },
                        {
                          label: "AF Revenue / Total Lots",
                          value: formatMetricValue(row.afGainPerLot || 0, true),
                          subValue: `Total Revenue: $${moneyPlain(row.afGain || 0)}`,
                          previous: buildTrend(
                            row.afGainPerLot || 0,
                            previousAuction ? previousAuction.afGainPerLot || 0 : null,
                            true,
                            "No previous auction"
                          ),
                          avg: buildTrend(
                            row.afGainPerLot || 0,
                            avgOf("afGainPerLot"),
                            true,
                            "No average auction"
                          ),
                        },
                      ];
                      const statusSx =
                        row.statusTone === "success"
                          ? { background: "linear-gradient(90deg,#16a34a,#15803d)", color: "#fff" }
                          : row.statusTone === "warning"
                            ? { background: "linear-gradient(90deg,#f59e0b,#d97706)", color: "#111827" }
                            : { background: "linear-gradient(90deg,#dc2626,#b91c1c)", color: "#fff" };
                      const inlineDraft = getAuctionInlineInfoDraft(row);
                      const inlineLocationInput = getAuctionInlineLocationInput(row);
                      const inlineLocationOptions = getAuctionInlineLocationOptions(row);
                      return (
                        <Paper
                          key={row.auctionId || row.auctionName}
                          sx={{
                            p: 1.35,
                            borderRadius: 2.4,
                            border: "1px solid rgba(148,163,184,0.35)",
                            boxShadow: "0 10px 22px rgba(15,23,42,0.06)",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                            <Button
                              onClick={() => {
                                void openAuctionFromHibidView(row.row);
                              }}
                              sx={{
                                px: 1.2,
                                py: 0.35,
                                minWidth: 0,
                                textTransform: "none",
                                borderRadius: 999,
                                justifyContent: "flex-start",
                                fontWeight: 900,
                                color: primary,
                                border: "1px solid rgba(51,57,153,0.22)",
                                background: "rgba(99,102,241,0.08)",
                                "&:hover": { background: "rgba(99,102,241,0.14)" },
                              }}
                            >
                              {row.auctionName}
                            </Button>
                            <Chip
                              size="small"
                              label={row.endLabel === "—" ? "End Date —" : `End ${row.endLabel}`}
                              sx={{ borderRadius: 999, fontWeight: 800, background: "#eef2ff", color: "#1e3a8a" }}
                            />
                          </Box>
                          <Box sx={{ mt: 0.75, display: "flex", gap: 0.7, flexWrap: "wrap", alignItems: "center" }}>
                            <Chip
                              size="small"
                              label={row.statusLabel}
                              sx={{ borderRadius: 999, fontWeight: 900, ...statusSx }}
                            />
                            {row.needsLatestAfterEnd ? (
                              <Typography
                                variant="caption"
                                sx={{ color: "#991b1b", fontWeight: 900, background: "#fee2e2", px: 0.8, py: 0.25, borderRadius: 1 }}
                              >
                                Your auction has ended, please upload the latest files from MyHiBid.
                              </Typography>
                            ) : null}
                          </Box>
                          <Box sx={{ mt: 0.85, display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr auto" }, gap: 0.8, alignItems: "end" }}>
                            <TextField
                              type="datetime-local"
                              label="End"
                              size="small"
                              value={inlineDraft.endAtLocal}
                              onChange={(e) => setAuctionInlineInfoField(row, "endAtLocal", e.target.value)}
                              onBlur={() => flushAuctionInlineInfoAutosave(row)}
                              InputLabelProps={{ shrink: true }}
                              fullWidth
                            />
                            {auctionInlineInfoSavingById[String(row?.auctionId || row?.id || "").trim()] ? (
                              <Typography variant="caption" sx={{ color: "#2563eb", fontWeight: 800, justifySelf: "end" }}>
                                Saving...
                              </Typography>
                            ) : null}
                          </Box>
                          <Box
                            sx={{
                              mt: 0.8,
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                              gap: 0.8,
                            }}
                          >
                            <Autocomplete
                              multiple
                              size="small"
                              options={auctionAccountManagerOptions}
                              value={getAuctionInlineAccountManagerRows(row)}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              getOptionLabel={(option) => String(option?.label || option?.id || "").trim()}
                              onChange={(_, value) => {
                                setAuctionInlineAccountManagerIds(
                                  row,
                                  (Array.isArray(value) ? value : []).map((item) => item?.id || "")
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Account Managers"
                                  placeholder="Select manager(s)"
                                  onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                />
                              )}
                            />
                            <FormControl size="small" fullWidth>
                              <InputLabel>Pickup Locations</InputLabel>
                              <Select
                                multiple
                                value={getAuctionInlinePickupLocations(row)}
                                label="Pickup Locations"
                                onChange={(e) => {
                                  setAuctionInlinePickupLocations(row, e.target.value || []);
                                }}
                                onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                renderValue={(selected) => {
                                  const values = Array.isArray(selected) ? selected.filter(Boolean) : [];
                                  return values.length ? values.join(", ") : "Select pickup location(s)";
                                }}
                              >
                                {getPickupLocationSelectOptions(getAuctionInlinePickupLocations(row)).map((location) => {
                                  const current = getAuctionInlinePickupLocations(row);
                                  const checked = current.includes(location);
                                  const locationAddress = getLocationAddress(location);
                                  return (
                                    <MenuItem key={location} value={location}>
                                      <Checkbox checked={checked} size="small" />
                                      <Box sx={{ minWidth: 0 }}>
                                        <Typography variant="body2">{location}</Typography>
                                        {locationAddress ? (
                                          <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                            {locationAddress}
                                          </Typography>
                                        ) : null}
                                      </Box>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                            {renderPickupLocationSelectedDetails(getAuctionInlinePickupLocations(row))}
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: "#f8fafc",
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 0.55 }}>
                                <Typography variant="caption" sx={{ color: "#475569", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                  Pickup Slots
                                </Typography>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => addAuctionInlinePickupSlot(row)}
                                  sx={{ borderRadius: 999, fontWeight: 800, minWidth: 0, px: 1.1, textTransform: "none" }}
                                >
                                  Add Slot
                                </Button>
                              </Box>
                              <Box sx={{ display: "grid", gap: 0.55 }}>
                                {getAuctionInlinePickupSlots(row).length ? (
                                  getAuctionInlinePickupSlots(row).map((slot) => (
                                    <Box key={String(slot?.slotId || "")} sx={{ display: "grid", gap: 0.45 }}>
                                      <FormControl size="small" fullWidth>
                                        <InputLabel>Pickup Location</InputLabel>
                                        <Select
                                          value={String(slot?.location || "")}
                                          label="Pickup Location"
                                          onChange={(e) => updateAuctionInlinePickupSlot(row, slot?.slotId, "location", e.target.value)}
                                          onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                          sx={{ background: "#fff", borderRadius: 2 }}
                                        >
                                          <MenuItem value="">
                                            <em>Select location</em>
                                          </MenuItem>
                                          {getAuctionInlinePickupLocations(row).map((location) => (
                                            <MenuItem key={location} value={location}>
                                              <Box sx={{ minWidth: 0 }}>
                                                <Typography variant="body2">{location}</Typography>
                                                {getLocationAddress(location) ? (
                                                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                                    {getLocationAddress(location)}
                                                  </Typography>
                                                ) : null}
                                              </Box>
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      <TextField
                                        size="small"
                                        label="Pickup Start"
                                        type="datetime-local"
                                        value={String(slot?.startAtLocal || "")}
                                        onChange={(e) => updateAuctionInlinePickupSlot(row, slot?.slotId, "startAtLocal", e.target.value)}
                                        onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 900 }}
                                      />
                                      <TextField
                                        size="small"
                                        label="Pickup End"
                                        type="datetime-local"
                                        value={String(slot?.endAtLocal || "")}
                                        onChange={(e) => updateAuctionInlinePickupSlot(row, slot?.slotId, "endAtLocal", e.target.value)}
                                        onBlur={() => flushAuctionInlineInfoAutosave(row)}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 900 }}
                                      />
                                      <Button
                                        size="small"
                                        color="error"
                                        variant="text"
                                        onClick={() => removeAuctionInlinePickupSlot(row, slot?.slotId)}
                                        sx={{ borderRadius: 999, fontWeight: 800, minWidth: 0, px: 0, justifyContent: "flex-start", textTransform: "none" }}
                                      >
                                        Remove
                                      </Button>
                                    </Box>
                                  ))
                                ) : (
                                  <Typography variant="caption" sx={{ color: "#64748b" }}>
                                    No pickup slots
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              mt: 0.8,
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "repeat(3,minmax(0,1fr))" },
                              gap: 0.8,
                            }}
                          >
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: row.hasShippingUpload ? "#ecfdf5" : "#fef2f2",
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                Shipping XLSX File
                              </Typography>
                              <Typography sx={{ fontWeight: 900, color: row.hasShippingUpload ? "#166534" : "#991b1b" }}>
                                {row.hasShippingUpload ? "Uploaded" : "Not Uploaded"}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#475569" }}>
                                {row.shippingUploadAtMs ? `Last ${fmtDate(row.shippingUploadAtMs)}` : "No upload yet"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: row.hasLotsUpload ? "#ecfdf5" : "#fef2f2",
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                Lot Stats File
                              </Typography>
                              <Typography sx={{ fontWeight: 900, color: row.hasLotsUpload ? "#166534" : "#991b1b" }}>
                                {row.hasLotsUpload ? "Uploaded" : "Not Uploaded"}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#475569" }}>
                                {row.lotsUploadAtMs ? `Last ${fmtDate(row.lotsUploadAtMs)}` : "No upload yet"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: row.listernautUploadStatusBg || (row.hasListernautUpload ? "#ecfdf5" : "#fef2f2"),
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                Listernaut File
                              </Typography>
                              <Typography sx={{ fontWeight: 900, color: row.listernautUploadStatusColor || (row.hasListernautUpload ? "#166534" : "#991b1b") }}>
                                {row.listernautUploadStatusLabel || (row.hasListernautUpload ? "Uploaded" : "Not Uploaded")}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#475569", display: "block" }}>
                                {row.listernautUploadAtMs ? `Last ${fmtDate(row.listernautUploadAtMs)}` : "No upload yet"}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#334155", fontWeight: 800, display: "block", mt: 0.25 }}>
                                {formatNumber2(toAbsInt(row.listernautUpdatedLots || 0))} updated • {formatNumber2(toAbsInt(row.listernautMatchedLots || 0))} matched • {formatNumber2(toAbsInt(row.listernautRows || 0))} rows
                              </Typography>
                              {row.listernautUploadStatusNote ? (
                                <Typography variant="caption" sx={{ color: row.listernautUploadStatusColor || "#92400e", fontWeight: 700, display: "block", mt: 0.25 }}>
                                  {row.listernautUploadStatusNote}
                                </Typography>
                              ) : null}
                            </Box>
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: "#f8fafc",
                              }}
                            >
                              {gridTotalRegistrations > 0 ? (
                                <Box sx={{ mt: 0.2, display: "grid", gap: 0.6 }}>
                                  <TableContainer
                                    component={Paper}
                                    sx={{
                                      borderRadius: 1.2,
                                      border: "1px solid #e2e8f0",
                                      overflow: "hidden",
                                      boxShadow: "none",
                                    }}
                                  >
                                    <Table
                                      size="small"
                                      sx={{
                                        "& .MuiTableCell-root": {
                                          px: 0.7,
                                          py: 0.5,
                                          verticalAlign: "top",
                                          borderBottom: "1px solid #e2e8f0",
                                        },
                                      }}
                                    >
                                      <TableHead>
                                        <TableRow sx={{ "& .MuiTableCell-root": { backgroundColor: "#f8fafc" } }}>
                                          <TableCell sx={{ color: "#475569", fontWeight: 900 }} />
                                          <TableCell sx={{ color: "#475569", fontWeight: 900 }}>
                                            <Typography variant="caption" sx={{ display: "block", color: "#475569", fontWeight: 900 }}>
                                              Total Registrations
                                            </Typography>
                                            <Typography sx={{ color: "#0f172a", fontWeight: 900, fontSize: 12 }}>
                                              {formatNumber2(gridTotalRegistrations)}
                                            </Typography>
                                          </TableCell>
                                          <TableCell sx={{ color: "#475569", fontWeight: 900 }}>
                                            <Typography variant="caption" sx={{ display: "block", color: "#475569", fontWeight: 900 }}>
                                              New Users
                                            </Typography>
                                            <Typography sx={{ color: "#0f172a", fontWeight: 900, fontSize: 12 }}>
                                              {formatNumber2(gridNewUsersCount)} ({formatPercent2(gridNewUsersPctOfTotal)})
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell sx={{ color: "#0f172a", fontWeight: 900 }}>Shipper</TableCell>
                                          <TableCell>
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.25 }}>
                                              <Typography variant="caption" sx={{ color: "#0f172a", fontWeight: 800 }}>
                                                {formatNumber2(gridShipCount)} ({formatPercent2(gridShipPct)})
                                              </Typography>
                                              {renderTrendDeltaPair(gridShipCount, gridShipPrev, gridShipAvg)}
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.25 }}>
                                              <Typography variant="caption" sx={{ color: "#0f172a", fontWeight: 800 }}>
                                                {formatNumber2(gridNewShipCount)} ({formatPercent2(gridNewShipPctOfNew)})
                                              </Typography>
                                              {renderTrendDeltaPair(gridNewShipCount, gridNewShipPrev, gridNewShipAvg)}
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell sx={{ color: "#0f172a", fontWeight: 900, borderBottom: "none" }}>Pickup</TableCell>
                                          <TableCell sx={{ borderBottom: "none" }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.25 }}>
                                              <Typography variant="caption" sx={{ color: "#0f172a", fontWeight: 800 }}>
                                                {formatNumber2(gridPickupCount)} ({formatPercent2(gridPickupPct)})
                                              </Typography>
                                              {renderTrendDeltaPair(gridPickupCount, gridPickupPrev, gridPickupAvg)}
                                            </Box>
                                          </TableCell>
                                          <TableCell sx={{ borderBottom: "none" }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.25 }}>
                                              <Typography variant="caption" sx={{ color: "#0f172a", fontWeight: 800 }}>
                                                {formatNumber2(gridNewPickupCount)} ({formatPercent2(gridNewPickupPctOfNew)})
                                              </Typography>
                                              {renderTrendDeltaPair(gridNewPickupCount, gridNewPickupPrev, gridNewPickupAvg)}
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>

                                  <Box
                                    sx={{
                                      p: 0.55,
                                      borderRadius: 1.1,
                                      border: "1px solid rgba(37,99,235,0.24)",
                                      background: "rgba(239,246,255,0.9)",
                                    }}
                                  >
                                    <Typography variant="caption" sx={{ color: "#1e3a8a", fontWeight: 900 }}>
                                      Total New-User Shippers: {formatNumber2(gridNewShipCount)} of {formatNumber2(gridTotalRegistrations)} (
                                      {formatPercent2(gridNewShipPctOfTotalRegs)} of all registrations)
                                    </Typography>
                                    {renderTrendDeltaPair(
                                      gridNewShipPctOfTotalRegs,
                                      gridNewShipPctOfTotalPrev,
                                      gridNewShipPctOfTotalAvg,
                                      { percent: true }
                                    )}
                                  </Box>
                                </Box>
                              ) : (
                                <Typography variant="caption" sx={{ color: "#475569" }}>
                                  No registrations yet
                                </Typography>
                              )}
                            </Box>
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: "rgba(236,253,245,0.9)",
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#047857", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                Seller
                              </Typography>
                              <Box sx={{ mt: 0.55 }}>
                                {renderAuctionShareMiniTable(row.sellerShareRows, "#047857", {
                                  showRevenue: true,
                                  consignorRows: row.consignorRows,
                                  showDisposition: true,
                                  showHammer: true,
                                })}
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                p: 0.78,
                                borderRadius: 1.5,
                                border: "1px solid #e2e8f0",
                                background: "rgba(239,246,255,0.92)",
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#1d4ed8", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                Lister
                              </Typography>
                              <Box sx={{ mt: 0.55 }}>
                                {renderAuctionShareMiniTable(row.listerShareRows, "#1d4ed8", {
                                  showDisposition: true,
                                  showHammer: true,
                                })}
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              mt: 1.05,
                              display: "grid",
                              gridTemplateColumns: { xs: "repeat(2,minmax(0,1fr))", lg: "repeat(6,minmax(0,1fr))" },
                              gap: 0.8,
                            }}
                          >
                            {metricCards.map((metric) => (
                              <Box
                                key={`${row.auctionId}-${metric.label}`}
                                sx={{
                                  p: 0.78,
                                  borderRadius: 1.5,
                                  background: "#fff",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}>
                                  {metric.label}
                                </Typography>
                                <Typography sx={{ color: "#0f172a", fontWeight: 900 }}>{metric.value}</Typography>
                                {metric.subValue ? (
                                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 800 }}>
                                    {metric.subValue}
                                  </Typography>
                                ) : null}
                                <Box sx={{ mt: 0.25 }}>
                                  {renderTrendDeltaPairFromTrend(metric.previous, metric.avg)}
                                </Box>
                              </Box>
                            ))}
                          </Box>
                        </Paper>
                      );
                    })}
                  </Box>
                )}
              </Paper>
            </>
          ) : null}

          {selectedAuctionId ? <Divider sx={{ my: 2 }} /> : null}
          {selectedAuctionId ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1.25,
                  flexWrap: "wrap",
                  mb: 2,
                }}
              >
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: 900, color: "#334155", mr: 0.5 }}>View</Typography>
                  <Button
                    onClick={() => setAuctionViewMode("stats")}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: auctionViewMode === "stats" ? "#fff" : primary,
                      border:
                        auctionViewMode === "stats" ? "1px solid transparent" : "1px solid rgba(51,57,153,0.18)",
                      background:
                        auctionViewMode === "stats"
                          ? "linear-gradient(90deg,#6366f1,#4f46e5)"
                          : "#fff",
                      "&:hover": {
                        background:
                          auctionViewMode === "stats"
                            ? "linear-gradient(90deg,#4f46e5,#4338ca)"
                            : "rgba(99,102,241,0.06)",
                      },
                    }}
                  >
                    Stats
                  </Button>
                  <Button
                    onClick={() => setAuctionViewMode("registrations")}
                    sx={{
                      textTransform: "none",
                      borderRadius: 999,
                      px: 2,
                      fontWeight: 900,
                      color: auctionViewMode === "registrations" ? "#fff" : primary,
                      border:
                        auctionViewMode === "registrations"
                          ? "1px solid transparent"
                          : "1px solid rgba(51,57,153,0.18)",
                      background:
                        auctionViewMode === "registrations"
                          ? "linear-gradient(90deg,#0ea5e9,#0284c7)"
                          : "#fff",
                      "&:hover": {
                        background:
                          auctionViewMode === "registrations"
                            ? "linear-gradient(90deg,#0284c7,#0369a1)"
                            : "rgba(99,102,241,0.06)",
                      },
                    }}
                  >
                    Registrations + Lots
                  </Button>
                </Box>
                <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 700 }}>
                  Stats is the default view.
                </Typography>
              </Box>
              {auctionViewMode === "stats" ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Paper sx={{ borderRadius: 3, p: 2, border: "1px solid rgba(51,57,153,0.10)" }}>
                    <Typography sx={{ fontWeight: 900, color: "#111827" }}>Auction Summary</Typography>
                    <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.25 }}>
                      Lots upload drives totals. Snapshots use auction data.
                    </Typography>

                    <Divider sx={{ my: 1.5 }} />

                    {!selectedAuctionId ? (
                      <Alert severity="info" sx={{ borderRadius: 2 }}>
                        Select an auction.
                      </Alert>
                    ) : (
                      <>
                        <input
                          ref={shippingFileInputRef}
                          type="file"
                          accept=".xlsx,.xls"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const f = e.target.files?.[0];
                            e.target.value = "";
                            if (f) onShippingFileSelected(f);
                          }}
                        />
                        <input
                          ref={lotsFileInputRef}
                          type="file"
                          accept=".csv,text/csv,.tsv,text/tab-separated-values"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const f = e.target.files?.[0];
                            e.target.value = "";
                            if (f) uploadLotsCsv(f);
                          }}
                        />
                        <input
                          ref={listernautFileInputRef}
                          type="file"
                          accept=".csv,text/csv,.tsv,text/tab-separated-values,.xlsx,.xls"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const f = e.target.files?.[0];
                            e.target.value = "";
                            if (f) uploadListernautFile(f);
                          }}
                        />
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                          <Chip
                            size="small"
                            label={selectedAuctionLabel}
                            sx={{ borderRadius: 999, fontWeight: 900, maxWidth: "100%" }}
                          />
                          <Tooltip title="Copy auctionId">
                            <IconButton size="small" onClick={() => copyText(selectedAuctionId)}>
                              <ContentCopyIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                        <Paper
                          sx={{
                            mt: 1.5,
                            p: 1.25,
                            borderRadius: 2,
                            border: "1px solid rgba(229,231,235,0.95)",
                            background: "#fff",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: { xs: "flex-start", md: "center" },
                              justifyContent: "space-between",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            <Box>
                              <Typography sx={{ fontWeight: 900, color: "#111827" }}>Auction Settings</Typography>
                              <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                Changes save automatically.
                              </Typography>
                            </Box>
                            <Chip
                              size="small"
                              color={auctionEndSaving ? "warning" : "success"}
                              label={auctionEndSaving ? "Saving..." : "Autosave On"}
                              sx={{ borderRadius: 999, fontWeight: 900 }}
                            />
                          </Box>
                          <Divider sx={{ my: 1 }} />
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "1fr" },
                              gap: 1,
                              alignItems: "start",
                            }}
                          >
                            <TextField
                              label="Auction End"
                              type="datetime-local"
                              value={auctionEndAtLocal}
                              onChange={(e) => setAuctionEndAtLocal(e.target.value)}
                              onBlur={flushAuctionSettingsAutosave}
                              size="small"
                              fullWidth
                              sx={{ background: "#fff", borderRadius: 2 }}
                              InputLabelProps={{ shrink: true }}
                            />
                          </Box>
                          <Box sx={{ mt: 1, display: "grid", gap: 1 }}>
                            <Autocomplete
                              multiple
                              size="small"
                              options={auctionAccountManagerOptions}
                              value={selectedAuctionAccountManagerRows}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              getOptionLabel={(option) => String(option?.label || option?.id || "").trim()}
                              onChange={(_, value) => {
                                setAuctionAccountManagerIds(
                                  sanitizeAuctionAccountManagerIds(
                                    (Array.isArray(value) ? value : []).map((item) => item?.id || ""),
                                    accountManagers
                                  )
                                );
                              }}
                              onBlur={flushAuctionSettingsAutosave}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Account Managers"
                                  placeholder="Select one or more account managers"
                                  helperText="Multiple account managers can be assigned to the auction."
                                  sx={{ background: "#fff", borderRadius: 2 }}
                                />
                              )}
                            />
                            <FormControl size="small" fullWidth>
                              <InputLabel>Pickup Locations</InputLabel>
                              <Select
                                multiple
                                value={sanitizeAuctionPickupLocations(auctionPickupLocations)}
                                label="Pickup Locations"
                                onChange={(e) => updateAuctionPickupLocations(e.target.value || [])}
                                onBlur={flushAuctionSettingsAutosave}
                                renderValue={(selected) => {
                                  const values = Array.isArray(selected) ? selected.filter(Boolean) : [];
                                  return values.length ? values.join(", ") : "Select pickup location(s)";
                                }}
                                sx={{ background: "#fff", borderRadius: 2 }}
                              >
                                {getPickupLocationSelectOptions(sanitizeAuctionPickupLocations(auctionPickupLocations)).map((location) => {
                                  const current = sanitizeAuctionPickupLocations(auctionPickupLocations);
                                  const checked = current.includes(location);
                                  const locationAddress = getLocationAddress(location);
                                  return (
                                    <MenuItem key={location} value={location}>
                                      <Checkbox checked={checked} size="small" />
                                      <Box sx={{ minWidth: 0 }}>
                                        <Typography variant="body2">{location}</Typography>
                                        {locationAddress ? (
                                          <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                            {locationAddress}
                                          </Typography>
                                        ) : null}
                                      </Box>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              <Typography variant="caption" sx={{ color: "#64748b", mt: 0.5, px: 1.75 }}>
                                Pickup appointments will use these location choices.
                              </Typography>
                            </FormControl>
                            {renderPickupLocationSelectedDetails(sanitizeAuctionPickupLocations(auctionPickupLocations))}
                            <Box
                              sx={{
                                p: 1,
                                borderRadius: 2,
                                border: "1px solid rgba(229,231,235,0.95)",
                                background: "#f8fafc",
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                                <Box>
                                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>Pickup Slots</Typography>
                                  <Typography variant="caption" sx={{ color: "#64748b" }}>
                                    Add one or more pickup windows for this auction.
                                  </Typography>
                                </Box>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={addAuctionPickupSlot}
                                  sx={{ borderRadius: 999, fontWeight: 800, textTransform: "none" }}
                                >
                                  Add Slot
                                </Button>
                              </Box>
                              <Box sx={{ mt: 1, display: "grid", gap: 0.9 }}>
                                {auctionPickupSlots.length ? (
                                  auctionPickupSlots.map((slot, idx) => (
                                    <Box
                                      key={String(slot?.slotId || `slot-${idx}`)}
                                      sx={{
                                        display: "grid",
                                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr auto" },
                                        gap: 0.9,
                                        alignItems: "start",
                                      }}
                                    >
                                      <FormControl size="small" fullWidth>
                                        <InputLabel>Pickup Location</InputLabel>
                                        <Select
                                          value={String(slot?.location || "")}
                                          label="Pickup Location"
                                          onChange={(e) => updateAuctionPickupSlot(slot?.slotId, "location", e.target.value)}
                                          onBlur={flushAuctionSettingsAutosave}
                                          sx={{ background: "#fff", borderRadius: 2 }}
                                        >
                                          <MenuItem value="">
                                            <em>Select location</em>
                                          </MenuItem>
                                          {sanitizeAuctionPickupLocations(auctionPickupLocations).map((location) => (
                                            <MenuItem key={location} value={location}>
                                              <Box sx={{ minWidth: 0 }}>
                                                <Typography variant="body2">{location}</Typography>
                                                {getLocationAddress(location) ? (
                                                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                                                    {getLocationAddress(location)}
                                                  </Typography>
                                                ) : null}
                                              </Box>
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      <TextField
                                        label="Pickup Start"
                                        type="datetime-local"
                                        size="small"
                                        value={String(slot?.startAtLocal || "")}
                                        onChange={(e) => updateAuctionPickupSlot(slot?.slotId, "startAtLocal", e.target.value)}
                                        onBlur={flushAuctionSettingsAutosave}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 900 }}
                                        sx={{ background: "#fff", borderRadius: 2 }}
                                      />
                                      <TextField
                                        label="Pickup End"
                                        type="datetime-local"
                                        size="small"
                                        value={String(slot?.endAtLocal || "")}
                                        onChange={(e) => updateAuctionPickupSlot(slot?.slotId, "endAtLocal", e.target.value)}
                                        onBlur={flushAuctionSettingsAutosave}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 900 }}
                                        sx={{ background: "#fff", borderRadius: 2 }}
                                      />
                                      <Button
                                        color="error"
                                        variant="text"
                                        onClick={() => removeAuctionPickupSlot(slot?.slotId)}
                                        sx={{ borderRadius: 999, fontWeight: 800, textTransform: "none", minWidth: 0 }}
                                      >
                                        Remove
                                      </Button>
                                    </Box>
                                  ))
                                ) : (
                                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                    No pickup slots added yet.
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Paper>
                        <Box
                          sx={{
                            mt: 1.5,
                            display: "flex",
                            gap: 1,
                            flexWrap: "wrap",
                            alignItems: "stretch",
                          }}
                        >
                          {[
                            {
                              key: "step1",
                              label: "Step 1 Upload Shipping XLSX File",
                              onClick: requestShippingUploadFile,
                              busy: shipBusy,
                              uploaded: !!selectedAuctionViewRow?.hasShippingUpload,
                              uploadedAtMs: selectedAuctionViewRow?.shippingUploadAtMs || 0,
                              tone: "linear-gradient(90deg,#2563eb,#1d4ed8)",
                            },
                            {
                              key: "step2",
                              label: "Step 2 Upload Lot Stats File",
                              onClick: () => lotsFileInputRef.current?.click(),
                              busy: uploadBusy,
                              uploaded: !!selectedAuctionViewRow?.hasLotsUpload,
                              uploadedAtMs: selectedAuctionViewRow?.lotsUploadAtMs || 0,
                              tone: "linear-gradient(90deg,#6366f1,#4f46e5)",
                            },
                            {
                              key: "step3",
                              label: "Step 3 Upload Listernaut File",
                              onClick: requestListernautUploadFile,
                              busy: listernautUploadBusy,
                              uploaded: !!selectedAuctionViewRow?.hasListernautUpload,
                              statusLabel: selectedAuctionViewRow?.listernautUploadStatusLabel || "Not Uploaded",
                              statusColor: selectedAuctionViewRow?.listernautUploadStatusColor || "#991b1b",
                              statusNote: selectedAuctionViewRow?.listernautUploadStatusNote || "",
                              uploadedAtMs: selectedAuctionViewRow?.listernautUploadAtMs || 0,
                              stats: selectedAuctionViewRow
                                ? `${formatNumber2(toAbsInt(selectedAuctionViewRow?.listernautUpdatedLots || 0))} updated • ${formatNumber2(
                                  toAbsInt(selectedAuctionViewRow?.listernautMatchedLots || 0)
                                )} matched • ${formatNumber2(toAbsInt(selectedAuctionViewRow?.listernautRows || 0))} rows`
                                : "",
                              tone: "linear-gradient(90deg,#0f766e,#0d9488)",
                            },
                          ].map((item) => (
                            <Paper
                              key={item.key}
                              sx={{
                                p: 1.1,
                                borderRadius: 2,
                                border: "1px solid rgba(148,163,184,0.22)",
                                background: "#fff",
                                flex: "1 1 260px",
                                minWidth: { xs: "100%", md: 260 },
                              }}
                            >
                              <Button
                                onClick={item.onClick}
                                disabled={!selectedAuctionId || item.busy}
                                startIcon={item.busy ? <CircularProgress size={16} /> : <UploadFileIcon />}
                                sx={{
                                  textTransform: "none",
                                  borderRadius: 999,
                                  px: 2.25,
                                  fontWeight: 900,
                                  color: "#fff",
                                  background: item.tone,
                                  "&:hover": { background: item.tone },
                                  width: "100%",
                                }}
                              >
                                {item.label}
                              </Button>
                              <Typography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  mt: 0.8,
                                  color: item.statusColor || (item.uploaded ? "#166534" : "#991b1b"),
                                  fontWeight: 900,
                                }}
                              >
                                {item.statusLabel || (item.uploaded ? "Uploaded" : "Not Uploaded")}
                              </Typography>
                              <Typography variant="caption" sx={{ display: "block", color: "#475569" }}>
                                {item.uploadedAtMs ? `Last ${fmtDate(item.uploadedAtMs)}` : "No upload yet"}
                              </Typography>
                              {item.stats ? (
                                <Typography variant="caption" sx={{ display: "block", mt: 0.35, color: "#334155", fontWeight: 800 }}>
                                  {item.stats}
                                </Typography>
                              ) : null}
                              {item.statusNote ? (
                                <Typography
                                  variant="caption"
                                  sx={{ display: "block", mt: 0.35, color: item.statusColor || "#92400e", fontWeight: 700 }}
                                >
                                  {item.statusNote}
                                </Typography>
                              ) : null}
                            </Paper>
                          ))}
                        </Box>
                        <Box
                          sx={{
                            mt: 1.5,
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            gap: 1.5,
                            alignItems: "start",
                          }}
                        >
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr",
                              gap: 1.25,
                            }}
                          >
                            <Paper
                              sx={{
                                p: 1.25,
                                borderRadius: 2,
                                border: "1px solid rgba(229,231,235,0.95)",
                                background: "#fff",
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                                <Box>
                                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>Auction Summary</Typography>
                                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                    Browse auction stats by section instead of one long dashboard.
                                  </Typography>
                                </Box>
                                <Chip
                                  size="small"
                                  label={`${formatNumber2(toAbsInt(auctionKpiCards.length))} overview metrics`}
                                  sx={{ borderRadius: 999, fontWeight: 900 }}
                                />
                              </Box>
                              <Tabs
                                value={selectedAuctionStatsTab}
                                onChange={(_, value) => setSelectedAuctionStatsTab(String(value || "overview"))}
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                sx={{
                                  mt: 1.1,
                                  minHeight: 44,
                                  "& .MuiTabs-flexContainer": { gap: 0.6 },
                                  "& .MuiTab-root": {
                                    textTransform: "none",
                                    minHeight: 44,
                                    borderRadius: 999,
                                    px: 1.7,
                                    py: 0.4,
                                    fontWeight: 900,
                                    color: "#4b5563",
                                    border: "1px solid rgba(148,163,184,0.22)",
                                    background: "#f8fafc",
                                  },
                                  "& .Mui-selected": {
                                    color: "#fff !important",
                                    background: "linear-gradient(90deg,#4f46e5,#4338ca)",
                                    borderColor: "transparent",
                                  },
                                  "& .MuiTabs-indicator": { display: "none" },
                                }}
                              >
                                <Tab value="overview" label="Overall Dashboard" />
                                <Tab value="registrationTrend" label="Registration Trend" />
                                <Tab value="participation" label="Participation + New Users" />
                                <Tab value="lotsStats" label="Lots Stats" />
                                <Tab value="sellerLister" label="Consignor + Lister Info" />
                              </Tabs>
                              <Divider sx={{ my: 1.2 }} />

                              {selectedAuctionStatsTab === "overview" ? (
                                <Box sx={{ display: "grid", gap: 1.25 }}>
                                  <Box
                                    sx={{
                                      display: "grid",
                                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", xl: "repeat(3,minmax(0,1fr))" },
                                      gap: 1,
                                    }}
                                  >
                                    {auctionKpiCards.map((card) => (
                                      <Paper
                                        key={card.key}
                                        sx={{
                                          p: 1.25,
                                          borderRadius: 2,
                                          border: "1px solid rgba(148,163,184,0.22)",
                                          background: card.bg,
                                        }}
                                      >
                                        <Typography
                                          variant="caption"
                                          sx={{ color: card.accent, fontWeight: 900, textTransform: "uppercase", letterSpacing: 0.2 }}
                                        >
                                          {card.label}
                                        </Typography>
                                        <Typography sx={{ color: "#0f172a", fontWeight: 900, fontSize: 24, lineHeight: 1.05, mt: 0.5 }}>
                                          {card.value}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: "#334155", mt: 0.35, fontWeight: 700 }}>
                                          {card.helper}
                                        </Typography>
                                      </Paper>
                                    ))}
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "grid",
                                      gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
                                      gap: 1,
                                    }}
                                  >
                                    <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                                      <Typography sx={{ fontWeight: 900, color: "#111827" }}>Sell-through Split</Typography>
                                      <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                        Won vs passed lots
                                      </Typography>
                                      <Box sx={{ mt: 1, width: "100%", height: 220 }}>
                                        {auctionChartData.sellThrough.some((d) => d.value > 0) ? (
                                          <ResponsiveContainer width="100%" height="100%">
                                            <PieChart>
                                              <Pie
                                                data={auctionChartData.sellThrough}
                                                dataKey="value"
                                                nameKey="name"
                                                innerRadius={48}
                                                outerRadius={80}
                                                paddingAngle={2}
                                              >
                                                {auctionChartData.sellThrough.map((entry) => (
                                                  <Cell key={entry.name} fill={entry.color} />
                                                ))}
                                              </Pie>
                                              <Legend />
                                              <RechartsTooltip formatter={(v) => formatNumber2(toAbsInt(v))} />
                                            </PieChart>
                                          </ResponsiveContainer>
                                        ) : (
                                          <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <Typography variant="body2" sx={{ color: "#64748b" }}>
                                              No lot stats yet.
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    </Paper>

                                    <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                                      <Typography sx={{ fontWeight: 900, color: "#111827" }}>Participation Funnel</Typography>
                                      <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                        Registrations to winning bidders
                                      </Typography>
                                      <Box sx={{ mt: 1, width: "100%", height: 220 }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                          <BarChart data={auctionChartData.funnel} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                            <XAxis dataKey="stage" tick={{ fill: "#334155", fontSize: 12 }} />
                                            <YAxis tick={{ fill: "#334155", fontSize: 12 }} />
                                            <RechartsTooltip formatter={(v) => formatNumber2(toAbsInt(v))} />
                                            <Bar dataKey="value" fill="#4f46e5" radius={[8, 8, 0, 0]} />
                                          </BarChart>
                                        </ResponsiveContainer>
                                      </Box>
                                    </Paper>
                                  </Box>
                                </Box>
                              ) : null}

                              {selectedAuctionStatsTab === "registrationTrend" ? (
                                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                                    <Box>
                                      <Typography sx={{ fontWeight: 900, color: "#111827" }}>Registration Trend</Typography>
                                      <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                        Registrations by day or hour for this auction.
                                      </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
                                      <FormControl size="small" sx={{ minWidth: 140, background: "#fff", borderRadius: 2 }}>
                                        <InputLabel id="auction-reg-trend-type-label">Chart</InputLabel>
                                        <Select
                                          labelId="auction-reg-trend-type-label"
                                          value={auctionRegTrendChartType}
                                          label="Chart"
                                          onChange={(e) => setAuctionRegTrendChartType(String(e.target.value || "line"))}
                                          sx={{ borderRadius: 2 }}
                                        >
                                          <MenuItem value="line">Line Chart</MenuItem>
                                          <MenuItem value="bar">Bar Chart</MenuItem>
                                        </Select>
                                      </FormControl>
                                      <FormControl size="small" sx={{ minWidth: 130, background: "#fff", borderRadius: 2 }}>
                                        <InputLabel id="auction-reg-trend-viewby-label">View By</InputLabel>
                                        <Select
                                          labelId="auction-reg-trend-viewby-label"
                                          value={auctionRegTrendViewBy}
                                          label="View By"
                                          onChange={(e) => setAuctionRegTrendViewBy(String(e.target.value || "day"))}
                                          sx={{ borderRadius: 2 }}
                                        >
                                          {auctionRegTrendViewByOptions.map((opt) => (
                                            <MenuItem key={opt.value} value={opt.value}>
                                              {opt.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      <FormControl size="small" sx={{ minWidth: 168, background: "#fff", borderRadius: 2 }}>
                                        <InputLabel id="auction-reg-trend-datemode-label">Date Selection</InputLabel>
                                        <Select
                                          labelId="auction-reg-trend-datemode-label"
                                          value={auctionRegTrendDateMode}
                                          label="Date Selection"
                                          onChange={(e) => setAuctionRegTrendDateMode(String(e.target.value || "range"))}
                                          sx={{ borderRadius: 2 }}
                                        >
                                          {auctionRegTrendDateModeOptions.map((opt) => (
                                            <MenuItem key={opt.value} value={opt.value}>
                                              {opt.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      {auctionRegTrendDateMode === "single" ? (
                                        <TextField
                                          type="date"
                                          size="small"
                                          label="Date"
                                          value={auctionRegTrendStartDate}
                                          onChange={(e) => {
                                            const minDateKey = auctionRegTrendAvailableRange.minDateKey;
                                            const maxDateKey = auctionRegTrendAvailableRange.maxDateKey;
                                            const rawDate = String(e.target.value || "");
                                            setAuctionRegTrendStartDate(
                                              clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                            );
                                          }}
                                          InputLabelProps={{ shrink: true }}
                                          inputProps={{
                                            min: auctionRegTrendAvailableRange.minDateKey || undefined,
                                            max: auctionRegTrendAvailableRange.maxDateKey || undefined,
                                          }}
                                          sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                                        />
                                      ) : (
                                        <>
                                          <TextField
                                            type="date"
                                            size="small"
                                            label="Start Date"
                                            value={auctionRegTrendStartDate}
                                            onChange={(e) => {
                                              const minDateKey = auctionRegTrendAvailableRange.minDateKey;
                                              const maxDateKey = auctionRegTrendAvailableRange.maxDateKey;
                                              const rawDate = String(e.target.value || "");
                                              setAuctionRegTrendStartDate(
                                                clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                              );
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                              min: auctionRegTrendAvailableRange.minDateKey || undefined,
                                              max: auctionRegTrendAvailableRange.maxDateKey || undefined,
                                            }}
                                            sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                                          />
                                          <TextField
                                            type="date"
                                            size="small"
                                            label="End Date"
                                            value={auctionRegTrendEndDate}
                                            onChange={(e) => {
                                              const minDateKey = auctionRegTrendAvailableRange.minDateKey;
                                              const maxDateKey = auctionRegTrendAvailableRange.maxDateKey;
                                              const rawDate = String(e.target.value || "");
                                              setAuctionRegTrendEndDate(
                                                clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                              );
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                              min: auctionRegTrendAvailableRange.minDateKey || undefined,
                                              max: auctionRegTrendAvailableRange.maxDateKey || undefined,
                                            }}
                                            sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                                          />
                                        </>
                                      )}
                                    </Box>
                                  </Box>
                                  <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                                    <Chip
                                      size="small"
                                      label={`Range ${auctionRegTrendResolvedRange.label || "No Dates"}`}
                                      sx={{ borderRadius: 999, fontWeight: 900 }}
                                    />
                                    <Chip
                                      size="small"
                                      label={`View By ${auctionRegTrendViewBy === "hour" ? "Hours" : "Day"}`}
                                      sx={{ borderRadius: 999, fontWeight: 900 }}
                                    />
                                    <Chip
                                      size="small"
                                      label={`Registered ${formatNumber2(toAbsInt(auctionRegistrationTrendTotalInRange))}`}
                                      sx={{ borderRadius: 999, fontWeight: 900 }}
                                    />
                                    <Chip
                                      size="small"
                                      label={`Auction Dates ${formatDateKeyRangeShortUTC(
                                        auctionRegTrendAvailableRange.minDateKey,
                                        auctionRegTrendAvailableRange.maxDateKey
                                      ) || "No Dates"
                                        }`}
                                      sx={{ borderRadius: 999, fontWeight: 900 }}
                                    />
                                  </Box>
                                  <Box sx={{ mt: 1, width: "100%", height: 250 }}>
                                    {auctionRegistrationTrendHasData ? (
                                      <ResponsiveContainer width="100%" height="100%">
                                        {auctionRegTrendChartType === "line" ? (
                                          <LineChart data={auctionRegistrationTrendData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                            <XAxis dataKey="xLabel" tick={{ fill: "#334155", fontSize: 12 }} minTickGap={auctionRegTrendViewBy === "hour" ? 24 : 14} />
                                            <YAxis tick={{ fill: "#334155", fontSize: 12 }} allowDecimals={false} />
                                            <RechartsTooltip content={renderRegistrationTrendTooltip} />
                                            <Legend />
                                            <Line
                                              type="monotone"
                                              dataKey="shippingRequestedCount"
                                              name="Shippers"
                                              stroke="#2563eb"
                                              strokeWidth={2.5}
                                              dot={false}
                                            />
                                            <Line
                                              type="monotone"
                                              dataKey="pickupCount"
                                              name="Pickups"
                                              stroke="#ec4899"
                                              strokeWidth={2.5}
                                              dot={false}
                                            />
                                          </LineChart>
                                        ) : (
                                          <BarChart data={auctionRegistrationTrendData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                            <XAxis dataKey="xLabel" tick={{ fill: "#334155", fontSize: 12 }} minTickGap={auctionRegTrendViewBy === "hour" ? 24 : 14} />
                                            <YAxis tick={{ fill: "#334155", fontSize: 12 }} allowDecimals={false} />
                                            <RechartsTooltip content={renderRegistrationTrendTooltip} />
                                            <Legend />
                                            <Bar dataKey="shippingRequestedCount" name="Shippers" stackId="registrations" fill="#2563eb" radius={[6, 6, 0, 0]} />
                                            <Bar dataKey="pickupCount" name="Pickups" stackId="registrations" fill="#ec4899" radius={[6, 6, 0, 0]} />
                                          </BarChart>
                                        )}
                                      </ResponsiveContainer>
                                    ) : (
                                      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Typography variant="body2" sx={{ color: "#64748b" }}>
                                          {auctionRegTrendAvailableRange.hasData
                                            ? `No registrations in ${auctionRegTrendResolvedRange.label}.`
                                            : "No registration dates available yet."}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </Paper>
                              ) : null}

                              {selectedAuctionStatsTab === "participation" ? (
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", xl: "1fr 1fr" },
                                    gap: 1.25,
                                  }}
                                >
                                  {auctionParticipationSections.map((section) => (
                                    <Paper
                                      key={section.key}
                                      sx={{
                                        p: 1.25,
                                        borderRadius: 2,
                                        border: "1px solid rgba(229,231,235,0.95)",
                                        background: `linear-gradient(180deg,rgba(255,255,255,0.98),${section.tone}12)`,
                                      }}
                                    >
                                      <Typography sx={{ fontWeight: 900, color: section.tone }}>{section.title}</Typography>
                                      <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                        {section.subtitle}
                                      </Typography>
                                      <Divider sx={{ my: 1 }} />
                                      <Box
                                        sx={{
                                          display: "grid",
                                          gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, minmax(0,1fr))" },
                                          gap: 0.75,
                                        }}
                                      >
                                        {section.items.map((item) => (
                                          <Box
                                            key={`${section.key}-${item.label}`}
                                            sx={{
                                              p: 0.9,
                                              borderRadius: 1.5,
                                              border: "1px solid rgba(229,231,235,0.95)",
                                              background: "#fff",
                                            }}
                                          >
                                            <Typography
                                              variant="caption"
                                              sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}
                                            >
                                              {item.label}
                                            </Typography>
                                            <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 17, mt: 0.35 }}>
                                              {item.value}
                                            </Typography>
                                            {item.subValue ? (
                                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 800 }}>
                                                {item.subValue}
                                              </Typography>
                                            ) : null}
                                          </Box>
                                        ))}
                                      </Box>
                                    </Paper>
                                  ))}
                                </Box>
                              ) : null}

                              {selectedAuctionStatsTab === "lotsStats" ? (
                                <Box sx={{ display: "grid", gap: 1.25 }}>
                                  <Box
                                    sx={{
                                      display: "grid",
                                      gridTemplateColumns: { xs: "1fr", xl: "1fr 1fr 1fr" },
                                      gap: 1.25,
                                    }}
                                  >
                                    {auctionLotStatsSections.map((section) => (
                                      <Paper
                                        key={section.key}
                                        sx={{
                                          p: 1.25,
                                          borderRadius: 2,
                                          border: "1px solid rgba(229,231,235,0.95)",
                                          background: `linear-gradient(180deg,rgba(255,255,255,0.98),${section.tone}12)`,
                                        }}
                                      >
                                        <Typography sx={{ fontWeight: 900, color: section.tone }}>{section.title}</Typography>
                                        <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                          {section.subtitle}
                                        </Typography>
                                        <Divider sx={{ my: 1 }} />
                                        <Box
                                          sx={{
                                            display: "grid",
                                            gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, minmax(0,1fr))" },
                                            gap: 0.75,
                                          }}
                                        >
                                          {section.items.map((item) => (
                                            <Box
                                              key={`${section.key}-${item.label}`}
                                              sx={{
                                                p: 0.9,
                                                borderRadius: 1.5,
                                                border: "1px solid rgba(229,231,235,0.95)",
                                                background: "#fff",
                                              }}
                                            >
                                              <Typography
                                                variant="caption"
                                                sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase", lineHeight: 1.2 }}
                                              >
                                                {item.label}
                                              </Typography>
                                              <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 17, mt: 0.35 }}>
                                                {item.value}
                                              </Typography>
                                              {item.subValue ? (
                                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 800 }}>
                                                  {item.subValue}
                                                </Typography>
                                              ) : null}
                                            </Box>
                                          ))}
                                        </Box>
                                      </Paper>
                                    ))}
                                  </Box>

                                  <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                                    <Typography sx={{ fontWeight: 900, color: "#111827" }}>Engagement Mix</Typography>
                                    <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                      Totals split into bought vs passed
                                    </Typography>
                                    <Box sx={{ mt: 1, width: "100%", height: 260 }}>
                                      {auctionChartData.engagement.some((d) => toAbsInt(d?.total) > 0) ? (
                                        <ResponsiveContainer width="100%" height="100%">
                                          <BarChart data={auctionChartData.engagement} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                            <XAxis dataKey="metric" tick={{ fill: "#334155", fontSize: 12 }} />
                                            <YAxis tick={{ fill: "#334155", fontSize: 12 }} />
                                            <RechartsTooltip
                                              formatter={(v, name) => [formatNumber2(toAbsInt(v)), formatEngagementSeriesName(name)]}
                                              labelFormatter={(label, payload) => {
                                                const total = formatNumber2(toAbsInt(payload?.[0]?.payload?.total || 0));
                                                return `${label} (Total ${total})`;
                                              }}
                                            />
                                            <Legend />
                                            <Bar dataKey="bought" name="Bought" stackId="total" fill="#2563eb" radius={[6, 6, 0, 0]} />
                                            <Bar dataKey="floor" name="Passed" stackId="total" fill="#f97316" radius={[6, 6, 0, 0]}>
                                              <LabelList
                                                dataKey="total"
                                                position="top"
                                                formatter={(value) => formatNumber2(toAbsInt(value))}
                                                fill="#334155"
                                                fontSize={11}
                                                fontWeight={700}
                                              />
                                            </Bar>
                                          </BarChart>
                                        </ResponsiveContainer>
                                      ) : (
                                        <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                          <Typography variant="body2" sx={{ color: "#64748b" }}>
                                            No engagement totals yet.
                                          </Typography>
                                        </Box>
                                      )}
                                    </Box>
                                  </Paper>
                                </Box>
                              ) : null}

                              {selectedAuctionStatsTab === "sellerLister" ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1.25,
                                  }}
                                >
                                  {auctionEntitySharePanels.map((panel) => (
                                    <Paper
                                      key={panel.key}
                                      sx={{
                                        p: 1.25,
                                        borderRadius: 2,
                                        border: "1px solid rgba(229,231,235,0.95)",
                                        background: `linear-gradient(180deg,rgba(255,255,255,0.98),${panel.tone}12)`,
                                      }}
                                    >
                                      <Typography sx={{ fontWeight: 900, color: panel.tone }}>{panel.title}</Typography>
                                      <Typography variant="caption" sx={{ color: "#6b7280" }}>
                                        {panel.subtitle}
                                      </Typography>
                                      <Divider sx={{ my: 1 }} />
                                      {panel.rows.length ? (
                                        <TableContainer component={Paper} sx={{ borderRadius: 1.5, border: "1px solid rgba(229,231,235,0.95)", boxShadow: "none" }}>
                                          <Table size="small">
                                            <TableHead>
                                              <TableRow sx={{ "& .MuiTableCell-root": { backgroundColor: "#f8fafc" } }}>
                                                <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Name</TableCell>
                                                {panel.key === "listerShare" || panel.key === "sellerShare" ? (
                                                  <>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Total Lots</TableCell>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Sold Lots</TableCell>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Passed Lots</TableCell>
                                                    {panel.key === "listerShare" && <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Total Hammer Price</TableCell>}
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Avg Hammer / Sold</TableCell>
                                                  </>
                                                ) : (
                                                  <>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Lots</TableCell>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Lots %</TableCell>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Total Hammer Price</TableCell>
                                                    <TableCell sx={{ fontWeight: 900, color: panel.tone }}>Hammer %</TableCell>
                                                  </>
                                                )}
                                                {panel.key === "sellerShare" && <TableCell sx={{ fontWeight: 900, color: "#047857" }}>Revenue</TableCell>}
                                                {panel.key === "sellerShare" && <TableCell sx={{ fontWeight: 900, color: "#047857" }}>Rev/Lot</TableCell>}
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {panel.rows.map((row) => {
                                                const rev = panel.key === "sellerShare" ? computeSellerRowRevenue(row, { consignorRows: auctionSummary?.consignorRows }) : null;
                                                return (
                                                  <TableRow key={`${panel.key}-${row?.name || "row"}`} hover>
                                                    <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                      {String(row?.name || "Unassigned").trim() || "Unassigned"}
                                                    </TableCell>
                                                    {panel.key === "listerShare" || panel.key === "sellerShare" ? (
                                                      <>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatNumber2(toAbsInt(row?.lotsCount || 0))}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatNumber2(toAbsInt(row?.soldLotsCount || 0))}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatNumber2(toAbsInt(row?.passedLotsCount || 0))}
                                                        </TableCell>
                                                        {panel.key === "listerShare" && (
                                                          <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                            ${moneyPlain(row?.hammerTotal || 0)}
                                                          </TableCell>
                                                        )}
                                                        <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                          {toAbsInt(row?.soldLotsCount || 0) > 0 ? `$${moneyPlain(row?.avgHammerPerSoldLot || 0)}` : "—"}
                                                        </TableCell>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatNumber2(toAbsInt(row?.lotsCount || 0))}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatPercent2(row?.lotsSharePct || 0)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                          ${moneyPlain(row?.hammerTotal || 0)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151" }}>
                                                          {formatPercent2(row?.hammerSharePct || 0)}
                                                        </TableCell>
                                                      </>
                                                    )}
                                                    {panel.key === "sellerShare" && (
                                                      <TableCell sx={{ color: "#047857", fontWeight: 900 }}>
                                                        ${moneyPlain(rev?.revenue || 0)}
                                                      </TableCell>
                                                    )}
                                                    {panel.key === "sellerShare" && (
                                                      <TableCell sx={{ color: "#047857", fontWeight: 700 }}>
                                                        ${moneyPlain(rev?.revenuePerLot || 0)}
                                                      </TableCell>
                                                    )}
                                                  </TableRow>
                                                );
                                              })}
                                              {(() => {
                                                const totals = computeAuctionShareTotals(panel.rows, {
                                                  showRevenue: panel.key === "sellerShare",
                                                  consignorRows: auctionSummary?.consignorRows,
                                                  showDisposition: panel.key === "listerShare" || panel.key === "sellerShare",
                                                });
                                                return (
                                                  <TableRow
                                                    sx={{
                                                      "& .MuiTableCell-root": {
                                                        backgroundColor: "#e5e7eb",
                                                        borderBottom: "1px solid #cbd5e1",
                                                      },
                                                    }}
                                                  >
                                                    <TableCell sx={{ color: "#111827", fontWeight: 900 }}>Total</TableCell>
                                                    {panel.key === "listerShare" || panel.key === "sellerShare" ? (
                                                      <>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatNumber2(totals.lotsCount)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatNumber2(totals.soldLotsCount)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatNumber2(totals.passedLotsCount)}
                                                        </TableCell>
                                                        {panel.key === "listerShare" && (
                                                          <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                            ${moneyPlain(totals.hammerTotal || 0)}
                                                          </TableCell>
                                                        )}
                                                        <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                          {totals.soldLotsCount > 0 ? `$${moneyPlain(totals.avgHammerPerSoldLot || 0)}` : "—"}
                                                        </TableCell>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatNumber2(totals.lotsCount)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatPercent2(totals.lotsSharePct || 0)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#111827", fontWeight: 900 }}>
                                                          ${moneyPlain(totals.hammerTotal || 0)}
                                                        </TableCell>
                                                        <TableCell sx={{ color: "#374151", fontWeight: 900 }}>
                                                          {formatPercent2(totals.hammerSharePct || 0)}
                                                        </TableCell>
                                                      </>
                                                    )}
                                                    {panel.key === "sellerShare" && (
                                                      <TableCell sx={{ color: "#047857", fontWeight: 900 }}>
                                                        ${moneyPlain(totals.revenue || 0)}
                                                      </TableCell>
                                                    )}
                                                    {panel.key === "sellerShare" && (
                                                      <TableCell sx={{ color: "#047857", fontWeight: 900 }}>
                                                        ${moneyPlain(totals.revenuePerLot || 0)}
                                                      </TableCell>
                                                    )}
                                                  </TableRow>
                                                );
                                              })()}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      ) : (
                                        <Box sx={{ p: 2, textAlign: "center", color: "#64748b" }}>
                                          No {panel.title.toLowerCase()} data yet.
                                        </Box>
                                      )}
                                    </Paper>
                                  ))}
                                </Box>
                              ) : null}
                            </Paper>
                          </Box>
                        </Box>
                      </>
                    )}
                  </Paper>
                </Box>
              ) : null}
              {isRegistrationsViewActive && !selectedAuctionId ? (
                <Alert severity="info" sx={{ borderRadius: 2 }}>
                  Select an auction to see registrations and upload shipping XLSX files.
                </Alert>
              ) : null}
              {shouldMountRegistrationsView ? (
                <Box sx={{ display: isRegistrationsViewActive ? "block" : "none" }}>
                  {registrationsViewReady ? (
                    <>
                      <input
                        ref={shippingFileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const f = e.target.files?.[0];
                          e.target.value = "";
                          if (f) onShippingFileSelected(f);
                        }}
                      />
                      <Box sx={{ display: "flex", gap: 1.25, alignItems: "center", flexWrap: "wrap", justifyContent: "space-between", mt: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, flex: 1, minWidth: { xs: "100%", md: 640 } }}>
                          <Box>
                            <Typography sx={{ fontWeight: 900, color: "#111827" }}>Auction Summary</Typography>
                            <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.2 }}>
                              {selectedAuctionLabel || selectedAuctionId}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              p: 1.1,
                              borderRadius: 2,
                              border: "1px solid rgba(51,57,153,0.16)",
                              background: "rgba(241,245,249,0.75)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            <Box>
                              <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>
                                Registration Filters
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                Hidden by default to keep the page cleaner.
                              </Typography>
                            </Box>
                            <Button
                              onClick={() => setShowRegistrationFilters((prev) => !prev)}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                border: "1px solid rgba(51,57,153,0.18)",
                                color: primary,
                                background: "#fff",
                                "&:hover": { background: "rgba(99,102,241,0.06)" },
                              }}
                            >
                              {showRegistrationFilters ? "Hide Filters" : "Show Filters"}
                            </Button>
                          </Box>

                          {showRegistrationFilters ? (
                            <Box
                              sx={{
                                p: 1.25,
                                borderRadius: 2,
                                background: "rgba(241,245,249,0.75)",
                              }}
                            >
                              <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", alignItems: "stretch" }}>
                                <Box
                                  sx={{
                                    flex: "1 1 240px",
                                    minWidth: { xs: "100%", md: 220 },
                                    p: 1.1,
                                    borderRadius: 2,
                                    border: "1px solid rgba(51,57,153,0.16)",
                                    background: "#fff",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  <Typography sx={{ fontWeight: 900, color: primary, fontSize: 13 }}>User</Typography>
                                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                    <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Users</Typography>
                                    <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                      <Select
                                        value={aregNewUserFilter}
                                        onChange={(e) => setAregNewUserFilter(String(e.target.value || "all"))}
                                        sx={{ borderRadius: 2 }}
                                      >
                                        <MenuItem value="all">All</MenuItem>
                                        <MenuItem value="new">New Users</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Box>
                                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                    <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Consignor</Typography>
                                    <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                      <Select
                                        value={aregConsignorFilter}
                                        onChange={(e) => setAregConsignorFilter(String(e.target.value || "all"))}
                                        sx={{ borderRadius: 2 }}
                                      >
                                        <MenuItem value="all">All</MenuItem>
                                        {registrationConsignorOptions.map((option) => (
                                          <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                            {option.value &&
                                              option.value !== AUCTION_CONSIGNOR_FILTER_UNASSIGNED &&
                                              normalize(option.label) !== normalize(option.value)
                                              ? ` (${option.value})`
                                              : ""}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Box>
                                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                    <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Chargeback / Pickup Mail Sent</Typography>
                                    <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                      <Select
                                        value={chargebackEmailAlreadySentFilter}
                                        onChange={(e) => setChargebackEmailAlreadySentFilter(String(e.target.value || "all"))}
                                        sx={{ borderRadius: 2 }}
                                      >
                                        <MenuItem value="all">All</MenuItem>
                                        <MenuItem value="not_sent">Not Sent</MenuItem>
                                        <MenuItem value="sent">Already Sent</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Box>
                                </Box>

                                <Box
                                  sx={{
                                    flex: "1 1 320px",
                                    minWidth: { xs: "100%", md: 300 },
                                    p: 1.1,
                                    borderRadius: 2,
                                    border: "1px solid rgba(59,130,246,0.18)",
                                    background: "#fff",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  <Typography sx={{ fontWeight: 900, color: "#1d4ed8", fontSize: 13 }}>Fulfillment</Typography>
                                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                    <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Fulfillment Method</Typography>
                                    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                                      {fulfillmentFilterOptions.map((option) => {
                                        const active = aregFulfillmentFilter === option.value;
                                        return (
                                          <Button
                                            key={option.value}
                                            size="small"
                                            onClick={() => handleFulfillmentFilterChange(option.value)}
                                            sx={{
                                              textTransform: "none",
                                              borderRadius: 999,
                                              px: 1.6,
                                              py: 0.55,
                                              fontWeight: 900,
                                              minWidth: 0,
                                              width: { xs: "calc(50% - 6px)", sm: "auto" },
                                              color: active ? "#fff" : "#1d4ed8",
                                              background: active ? "#1d4ed8" : "rgba(59,130,246,0.08)",
                                              border: active
                                                ? "1px solid rgba(29,78,216,0.9)"
                                                : "1px solid rgba(59,130,246,0.18)",
                                              "&:hover": {
                                                background: active ? "#1e40af" : "rgba(59,130,246,0.14)",
                                              },
                                            }}
                                          >
                                            {option.label}
                                          </Button>
                                        );
                                      })}
                                    </Box>
                                  </Box>

                                  {aregFulfillmentFilter === "shipping" ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                      <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Shipping Status</Typography>
                                      <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                        <Select
                                          value={aregShippedFilter}
                                          onChange={(e) => setAregShippedFilter(String(e.target.value || "all"))}
                                          sx={{ borderRadius: 2 }}
                                        >
                                          <MenuItem value="all">All</MenuItem>
                                          <MenuItem value="complete">Shipped</MenuItem>
                                          <MenuItem value="none">Hasn&apos;t Shipped Yet</MenuItem>
                                          <MenuItem value="partial">Partially Shipped</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  ) : null}

                                  {aregFulfillmentFilter === "pickup" || aregFulfillmentFilter === "delivery" ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                        <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Location</Typography>
                                        <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                          <Select
                                            value={aregFulfillmentFilter === "pickup" ? aregPickupLocationFilter : aregDeliveryLocationFilter}
                                            onChange={(e) => {
                                              const nextValue = String(e.target.value || "all");
                                              if (aregFulfillmentFilter === "pickup") setAregPickupLocationFilter(nextValue);
                                              else setAregDeliveryLocationFilter(nextValue);
                                            }}
                                            sx={{ borderRadius: 2 }}
                                          >
                                            <MenuItem value="all">All</MenuItem>
                                            {(aregFulfillmentFilter === "pickup"
                                              ? registrationPickupLocationOptions
                                              : registrationDeliveryLocationOptions
                                            ).map((option) => (
                                              <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </Box>

                                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                        <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>
                                          {aregFulfillmentFilter === "pickup" ? "Pickup Status" : "Delivery Status"}
                                        </Typography>
                                        <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                          <Select
                                            value={aregFulfillmentFilter === "pickup" ? aregPickupFilter : aregDeliveryFilter}
                                            onChange={(e) => {
                                              const nextValue = String(e.target.value || "all");
                                              if (aregFulfillmentFilter === "pickup") setAregPickupFilter(nextValue);
                                              else setAregDeliveryFilter(nextValue);
                                            }}
                                            sx={{ borderRadius: 2 }}
                                          >
                                            <MenuItem value="all">All</MenuItem>
                                            {aregFulfillmentFilter === "pickup" ? (
                                              [
                                                <MenuItem key="pickup-complete" value="complete">Picked Up</MenuItem>,
                                                <MenuItem key="pickup-none" value="none">Hasn&apos;t Picked Up Yet</MenuItem>,
                                                <MenuItem key="pickup-partial" value="partial">Partially Picked Up</MenuItem>,
                                              ]
                                            ) : (
                                              [
                                                <MenuItem key="delivery-delivered" value="delivered">Delivered</MenuItem>,
                                                <MenuItem key="delivery-not-delivered" value="not_delivered">Not Delivered</MenuItem>,
                                              ]
                                            )}
                                          </Select>
                                        </FormControl>
                                      </Box>

                                      {aregFulfillmentFilter === "pickup" ? (
                                        <>
                                          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.45 }}>
                                            <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Pickup Email Selection</Typography>
                                            <FormControl size="small" sx={{ background: "#fff", borderRadius: 2 }}>
                                              <Select
                                                value={aregPickupSelectionFilter}
                                                onChange={(e) => setAregPickupSelectionFilter(String(e.target.value || "all"))}
                                                sx={{ borderRadius: 2 }}
                                              >
                                                <MenuItem value="all">All</MenuItem>
                                                <MenuItem value="jeff">Jeff</MenuItem>
                                                <MenuItem value="email">Email</MenuItem>
                                                <MenuItem value="not_selected">Not selected</MenuItem>
                                              </Select>
                                            </FormControl>
                                          </Box>
                                          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
                                            <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Date Time Start</Typography>
                                            <TextField
                                              type="datetime-local"
                                              size="small"
                                              value={aregPickupDateStart}
                                              onChange={(e) => setAregPickupDateStart(String(e.target.value || ""))}
                                              InputLabelProps={{ shrink: true }}
                                              sx={{ background: "#fff", borderRadius: 2 }}
                                            />
                                            <Typography sx={{ ...filterLabelSx, minWidth: 0 }}>Date Time End</Typography>
                                            <TextField
                                              type="datetime-local"
                                              size="small"
                                              value={aregPickupDateEnd}
                                              onChange={(e) => setAregPickupDateEnd(String(e.target.value || ""))}
                                              InputLabelProps={{ shrink: true }}
                                              sx={{ background: "#fff", borderRadius: 2 }}
                                            />
                                          </Box>
                                        </>
                                      ) : null}
                                    </Box>
                                  ) : null}
                                </Box>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>


                      </Box>

                      {aregLoading ? (
                        <Box sx={{ mt: 2 }}>
                          <LinearProgress />
                        </Box>
                      ) : null}
                      {selectedAuctionId && aregFulfillmentFilter === "pickup" ? (
                        <Box
                          sx={{
                            mt: 2,
                            minWidth: 0,
                            p: 1.2,
                            borderRadius: 2.5,
                            border: "1px solid rgba(124,58,237,0.16)",
                            background: "linear-gradient(180deg,#fcfaff 0%,#f8fafc 100%)",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                            <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>Pickup Exports</Typography>
                            <Typography variant="caption" sx={{ color: "#6d28d9", fontWeight: 800 }}>
                              Picklists and lots
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                            <Button
                              onClick={exportSelectedPickupPicklistExcel}
                              disabled={!getSelectedRegRows().length || pickupPicklistExcelBusy}
                              startIcon={pickupPicklistExcelBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#0891b2,#0e7490)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#0e7490,#155e75)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {pickupPicklistExcelBusy ? "Preparing Picklist Excel..." : "Download Picklist Excel"}
                            </Button>

                            <Button
                              onClick={exportSelectedPickupPicklistPdf}
                              disabled={!getSelectedRegRows().length || pickupPicklistPdfBusy}
                              startIcon={pickupPicklistPdfBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#7c3aed,#6d28d9)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#6d28d9,#5b21b6)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {pickupPicklistPdfBusy ? "Preparing Picklist PDF..." : "Download Picklist PDF"}
                            </Button>

                            <Button
                              onClick={exportSelectedPickupPicklistLotsPdf}
                              disabled={!getSelectedRegRows().length || pickupPicklistLotsPdfBusy}
                              startIcon={pickupPicklistLotsPdfBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#0f766e,#0d9488)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#0d9488,#0f766e)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {pickupPicklistLotsPdfBusy ? "Preparing Picklist + Lots..." : "Download Picklist + Lots PDF"}
                            </Button>
                          </Box>
                        </Box>
                      ) : null}
                      {selectedAuctionId && aregFulfillmentFilter === "delivery" ? (
                        <Box
                          sx={{
                            mt: 2,
                            minWidth: 0,
                            p: 1.2,
                            borderRadius: 2.5,
                            border: "1px solid rgba(245,158,11,0.18)",
                            background: "linear-gradient(180deg,#fffaf5 0%,#f8fafc 100%)",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                            <Typography sx={{ fontWeight: 900, color: "#0f172a", fontSize: 14 }}>Delivery Exports</Typography>
                            <Typography variant="caption" sx={{ color: "#b45309", fontWeight: 800 }}>
                              Manifests and lots
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                            <Button
                              onClick={exportSelectedDeliveryManifestExcel}
                              disabled={!getSelectedRegRows().length || deliveryManifestExcelBusy}
                              startIcon={deliveryManifestExcelBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#d97706,#b45309)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#b45309,#92400e)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {deliveryManifestExcelBusy ? "Preparing Delivery Excel..." : "Download Delivery Excel"}
                            </Button>

                            <Button
                              onClick={exportSelectedDeliveryManifestPdf}
                              disabled={!getSelectedRegRows().length || deliveryManifestPdfBusy}
                              startIcon={deliveryManifestPdfBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#f59e0b,#d97706)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#d97706,#b45309)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {deliveryManifestPdfBusy ? "Preparing Delivery PDF..." : "Download Delivery PDF"}
                            </Button>

                            <Button
                              onClick={exportSelectedDeliveryManifestLotsPdf}
                              disabled={!getSelectedRegRows().length || deliveryManifestLotsPdfBusy}
                              startIcon={deliveryManifestLotsPdfBusy ? <CircularProgress size={16} /> : <DownloadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 999,
                                px: 2,
                                fontWeight: 900,
                                color: "#fff",
                                background: getSelectedRegRows().length
                                  ? "linear-gradient(90deg,#f97316,#ea580c)"
                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                "&:hover": {
                                  background: getSelectedRegRows().length
                                    ? "linear-gradient(90deg,#ea580c,#c2410c)"
                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                },
                              }}
                            >
                              {deliveryManifestLotsPdfBusy ? "Preparing Delivery + Lots..." : "Download Delivery + Lots PDF"}
                            </Button>
                          </Box>
                        </Box>
                      ) : null}
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", mt: 2 }}>
                        <FormControlLabel
                          sx={{ m: 0 }}
                          control={
                            <Switch
                              size="small"
                              checked={chargebackEmailWonLotFilter === "won_lots"}
                              onChange={(e) =>
                                setChargebackEmailWonLotFilter(e.target.checked ? "won_lots" : "all")
                              }
                            />
                          }
                          label={
                            <Typography variant="caption" sx={{ fontWeight: 900, color: "#334155" }}>
                              Only winners
                            </Typography>
                          }
                        />
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center", justifyContent: "end" }}>
                          <Chip
                            size="small"
                            label={`Selected: ${(aregSelected && aregSelected.size) || 0}`}
                            sx={{
                              borderRadius: 999,
                              fontWeight: 900,
                              backgroundColor: "rgba(99,102,241,0.10)",
                              color: primary,
                              border: "1px solid rgba(51,57,153,0.15)",
                            }}
                          />
                          <Chip
                            size="small"
                            label={`Filtered: ${formatNumber2(chargebackFilteredAuctionRegs.length)}`}
                            sx={{
                              borderRadius: 999,
                              fontWeight: 900,
                              backgroundColor: "rgba(14,165,233,0.10)",
                              color: "#0369a1",
                              border: "1px solid rgba(14,165,233,0.20)",
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", alignItems: "flex-end", mt: 1.5 }}>
                        <TextField
                          value={aregSearch}
                          onChange={(e) => setAregSearch(e.target.value)}
                          size="small"
                          placeholder="Search registrations (name, email, shipping, status...)"
                          sx={{ minWidth: { xs: "100%", md: 420 }, background: "#fff", borderRadius: 2, flex: 1 }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            ),
                            endAdornment: aregSearch ? (
                              <InputAdornment position="end">
                                <IconButton size="small" onClick={clearRegsSearch}>
                                  ✕
                                </IconButton>
                              </InputAdornment>
                            ) : null,
                          }}
                        />

                      </Box>
                      {!isMobileDevice ? (
                        <Box sx={{ mt: 2 }}>
                          <TableContainer component={Paper} sx={{ borderRadius: 3, border: "1px solid rgba(51,57,153,0.10)", maxHeight: "68vh", overflowY: "auto" }}>
                            <Table size="small" stickyHeader>
                              <TableHead>
                                <TableRow sx={{ "& .MuiTableCell-root": { backgroundColor: "#f8fafc" } }}>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <Checkbox
                                      checked={(() => {
                                        const visible = chargebackFilteredAuctionRegs
                                          .map((r) => normalize(r?.bidderEmail || r?.email))
                                          .filter((em) => isEmail(em));
                                        if (!visible.length) return false;
                                        return visible.every((em) => aregSelected?.has?.(em));
                                      })()}
                                      indeterminate={(() => {
                                        const visible = chargebackFilteredAuctionRegs
                                          .map((r) => normalize(r?.bidderEmail || r?.email))
                                          .filter((em) => isEmail(em));
                                        if (!visible.length) return false;
                                        const selectedCount = visible.filter((em) => aregSelected?.has?.(em)).length;
                                        return selectedCount > 0 && selectedCount < visible.length;
                                      })()}
                                      onChange={toggleSelectAllRegs}
                                      size="small"
                                    />
                                  </TableCell>

                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "bidderName"}
                                      direction={aregSortKey === "bidderName" ? aregSortDir : "asc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "bidderName", "asc")}
                                    >
                                      First Name
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "bidderLastName"}
                                      direction={aregSortKey === "bidderLastName" ? aregSortDir : "asc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "bidderLastName", "asc")}
                                    >
                                      Last Name
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "isNewUser"}
                                      direction={aregSortKey === "isNewUser" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "isNewUser", "desc")}
                                    >
                                      New
                                    </TableSortLabel>
                                  </TableCell>

                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "registeredAt"}
                                      direction={aregSortKey === "registeredAt" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "registeredAt", "desc")}
                                    >
                                      Registered
                                    </TableSortLabel>
                                  </TableCell>

                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "lotsCount"}
                                      direction={aregSortKey === "lotsCount" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "lotsCount", "desc")}
                                    >
                                      Lots
                                    </TableSortLabel>
                                  </TableCell>

                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "totalHighBid"}
                                      direction={aregSortKey === "totalHighBid" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "totalHighBid", "desc")}
                                    >
                                      HighBid
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>Fulfilled</TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>Fulfillment</TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    Shelf
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    Amount Due
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "shipping"}
                                      direction={aregSortKey === "shipping" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "shipping", "desc")}
                                    >
                                      Shipping
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "chargebackEmailSent"}
                                      direction={aregSortKey === "chargebackEmailSent" ? aregSortDir : "desc"}
                                      onClick={() =>
                                        applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "chargebackEmailSent", "desc")
                                      }
                                    >
                                      Chargeback / Pickup Mail Sent
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>
                                    <TableSortLabel
                                      active={aregSortKey === "signed"}
                                      direction={aregSortKey === "signed" ? aregSortDir : "desc"}
                                      onClick={() => applySortToggle(aregSortKey, setAregSortKey, setAregSortDir, "signed", "desc")}
                                    >
                                      Signed
                                    </TableSortLabel>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 900, color: primary }}>View Sign</TableCell>
                                  <TableCell align="center" sx={{ fontWeight: 900, color: primary }}>Action</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {chargebackFilteredAuctionRegs.length === 0 ? (
                                  <TableRow>
                                    <TableCell colSpan={16}>
                                      <Box sx={{ p: 5, textAlign: "center", color: "#6b7280" }}>
                                        No registrations found.
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  chargebackFilteredAuctionRegs.map((r, idx) => {
                                    const emailLower = normalize(r?.bidderEmail || r?.email);
                                    const { firstName, lastName } = getFirstLastNameParts(getDisplayBidderName(r));
                                    const displayUsername = getDisplayUsername(r);
                                    const cached = lotsAgg[emailLower];
                                    const lotsCount = safeNum(r?.lotsCount || cached?.lotsCount || 0);
                                    const totalHighBid = safeNum(r?.totalHighBid || cached?.totalHighBid || 0);
                                    const shippingRequested = isShippingRequested(r);
                                    const delivery = getRegistrationDelivery(r);
                                    const fulfillmentMode = getFulfillmentMode({
                                      row: r,
                                      shippingRequested,
                                      delivery,
                                    });
                                    const fulfillmentButtonMeta = getFulfillmentButtonMeta(fulfillmentMode);
                                    const isFloorRegistration = !!r?.isFloorBidder || isFloorBidderEmail(emailLower);
                                    const pickupDetails = getLotPickupCounts({
                                      lotsCount,
                                      pickedUpLotsCount: r?.pickedUpLotsCount ?? cached?.pickedUpLotsCount,
                                      pickedUp: r?.pickedUp ?? cached?.pickedUp,
                                    });
                                    const shippedDetails = getLotShippedCounts({
                                      lotsCount,
                                      shippedLotsCount: r?.shippedLotsCount ?? cached?.shippedLotsCount,
                                      shipped: r?.shipped ?? cached?.shipped,
                                    });
                                    const checked = aregSelected?.has?.(emailLower);
                                    const chargebackEmailSent = isChargebackEmailSent(r);
                                    const signDetails = getChargebackSignDetails(r);
                                    const isNewUser = isAuctionRegistrationNewUser(r);
                                    const shelfValue =
                                      aregShelfDraftByEmail[emailLower] !== undefined
                                        ? String(aregShelfDraftByEmail[emailLower] || "")
                                        : String(r?.shelf || r?.pickupShelf || "").trim();
                                    const shelfSaving = !!aregShelfSavingByEmail[emailLower];
                                    const amountDueValue =
                                      aregAmountDueDraftByEmail[emailLower] !== undefined
                                        ? String(aregAmountDueDraftByEmail[emailLower] || "")
                                        : String(r?.amountDue || r?.amount_due || "").trim();
                                    const shelfBoxLabels = parseShelfBoxLabels(shelfValue);
                                    const boxLabelRowKey = getRegistrationBoxLabelRowKey(r, idx);
                                    const boxLabelRowBusy = registrationBoxLabelsBusy || !!registrationBoxLabelsBusyByKey[boxLabelRowKey];
                                    const fulfillmentChecked =
                                      fulfillmentMode === "shipping"
                                        ? shippedDetails.shipped
                                        : fulfillmentMode === "delivery"
                                          ? delivery.delivered
                                          : pickupDetails.pickedUp;
                                    const fulfillmentStatusLabel =
                                      fulfillmentMode === "shipping"
                                        ? shippedDetails.shippedStatusLabel
                                        : fulfillmentMode === "delivery"
                                          ? delivery.deliveredStatusLabel || `${delivery.delivered ? lotsCount : 0}/${lotsCount || 0}`
                                          : pickupDetails.pickupStatusLabel;
                                    const fulfillmentCheckboxDisabled =
                                      !isEmail(emailLower) ||
                                      lotsCount <= 0 ||
                                      (fulfillmentMode === "shipping" && shippedDetails.totalLotsCount === 0) ||
                                      (fulfillmentMode === "pickup" && pickupDetails.totalLotsCount === 0);

                                    return (
                                      <TableRow
                                        key={r.id || r.gmailMessageId || `${emailLower}-${idx}`}
                                        hover
                                      >
                                        <TableCell>
                                          <Checkbox
                                            size="small"
                                            checked={!!checked}
                                            disabled={!isEmail(emailLower)}
                                            onChange={() => toggleSelectReg(r)}
                                          />
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 900, color: "#111827" }}>
                                          {isEmail(emailLower) ? (
                                            <Button
                                              size="small"
                                              onClick={() => openAuctionUserDetailsModal(r)}
                                              sx={{
                                                textTransform: "none",
                                                minWidth: 0,
                                                px: 0,
                                                py: 0,
                                                fontWeight: 900,
                                                color: primary,
                                                "&:hover": { background: "transparent", textDecoration: "underline" },
                                              }}
                                            >
                                              {firstName || "—"}
                                            </Button>
                                          ) : (
                                            firstName || "—"
                                          )}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 900, color: "#111827" }}>
                                          {isEmail(emailLower) ? (
                                            <Button
                                              size="small"
                                              onClick={() => openAuctionUserDetailsModal(r)}
                                              sx={{
                                                textTransform: "none",
                                                minWidth: 0,
                                                px: 0,
                                                py: 0,
                                                fontWeight: 900,
                                                color: primary,
                                                "&:hover": { background: "transparent", textDecoration: "underline" },
                                              }}
                                            >
                                              {lastName || "—"}
                                            </Button>
                                          ) : (
                                            lastName || "—"
                                          )}
                                          {displayUsername ? (
                                            <Typography variant="caption" sx={{ display: "block", color: "#6b7280" }}>
                                              {displayUsername}
                                            </Typography>
                                          ) : null}
                                        </TableCell>
                                        <TableCell>
                                          {isNewUser ? (
                                            <Box
                                              sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                px: 1,
                                                py: 0.35,
                                                borderRadius: 1,
                                                background: "linear-gradient(90deg,#3b82f6,#2563eb)",
                                                color: "#fff",
                                                fontWeight: 900,
                                                fontSize: 11,
                                                textTransform: "uppercase",
                                                letterSpacing: 0.3,
                                              }}
                                            >
                                              New
                                            </Box>
                                          ) : (
                                            <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                                              —
                                            </Typography>
                                          )}
                                        </TableCell>

                                        <TableCell sx={{ color: "#374151" }}>
                                          {fmtDate(r.registeredAt || r.emailSentAt)}
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 900, color: "#111827" }}>
                                          {lotsCount > 0 ? (
                                            formatNumber2(lotsCount)
                                          ) : (
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 800 }}>
                                              Not won anything
                                            </Typography>
                                          )}
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 900, color: "#111827" }}>
                                          {totalHighBid > 0 ? `$${moneyPlain(totalHighBid)}` : "—"}
                                        </TableCell>

                                        <TableCell>
                                          {isFloorRegistration || lotsCount <= 0 ? (
                                            <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: 800 }}>—</Typography>
                                          ) : (
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.45 }}>
                                              <Checkbox
                                                size="small"
                                                checked={fulfillmentChecked}
                                                disabled={fulfillmentCheckboxDisabled}
                                                onChange={(e) =>
                                                  openRegistrationFulfillmentConfirm({
                                                    type: fulfillmentMode === "shipping" ? "shipped" : fulfillmentMode === "delivery" ? "delivery" : "pickup",
                                                    row: r,
                                                    nextValue: e.target.checked,
                                                  })
                                                }
                                              />
                                              <Typography variant="caption" sx={{ color: "#475569", fontWeight: 800 }}>
                                                {fulfillmentStatusLabel || "—"}
                                              </Typography>
                                            </Box>
                                          )}
                                        </TableCell>

                                        <TableCell>
                                          <Button
                                            size="small"
                                            onClick={() => openRegistrationFulfillmentDetails(r)}
                                            sx={{
                                              textTransform: "none",
                                              borderRadius: 999,
                                              px: 1.5,
                                              fontWeight: 900,
                                              color: fulfillmentButtonMeta.color,
                                              background: fulfillmentButtonMeta.background,
                                              border: fulfillmentButtonMeta.border,
                                              "&:hover": { background: fulfillmentButtonMeta.background },
                                            }}
                                          >
                                            {fulfillmentButtonMeta.label}
                                          </Button>
                                        </TableCell>

                                        <TableCell sx={{ minWidth: 180 }}>
                                          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.35 }}>
                                            <TextField
                                              size="small"
                                              value={shelfValue}
                                              disabled={!isEmail(emailLower) || shelfSaving}
                                              onChange={(e) => {
                                                const nextShelf = String(e.target.value || "");
                                                setAregShelfDraftByEmail((prev) => ({
                                                  ...prev,
                                                  [emailLower]: nextShelf,
                                                }));
                                              }}
                                              onBlur={() => {
                                                void updateRegistrationShelf({
                                                  auctionId: selectedAuctionId,
                                                  email: r?.bidderEmail || r?.email,
                                                  shelf: shelfValue,
                                                });
                                              }}
                                              placeholder="Number of Boxes (e.g. 3)"
                                              sx={{ background: "#fff", borderRadius: 2 }}
                                            />
                                            {shelfSaving ? (
                                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                                Saving...
                                              </Typography>
                                            ) : shelfBoxLabels.length > 1 ? (
                                              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                                {formatNumber2(shelfBoxLabels.length)} boxes
                                              </Typography>
                                            ) : null}
                                          </Box>
                                        </TableCell>

                                        <TableCell sx={{ minWidth: 180 }}>
                                          <TextField
                                            size="small"
                                            value={amountDueValue}
                                            disabled={!isEmail(emailLower)}
                                            onChange={(e) => {
                                              const nextAmountDue = String(e.target.value || "");
                                              setAregAmountDueDraftByEmail((prev) => ({
                                                ...prev,
                                                [emailLower]: nextAmountDue,
                                              }));
                                            }}
                                            placeholder="Amount Due"
                                            sx={{ background: "#fff", borderRadius: 2 }}
                                          />
                                        </TableCell>

                                        <TableCell>
                                          <FormControl size="small" sx={{ minWidth: 110 }}>
                                            <Select
                                              value={String(shippingRequested)}
                                              onChange={(e) =>
                                                updateRegistrationShipping({
                                                  auctionId: selectedAuctionId,
                                                  email: r?.bidderEmail || r?.email,
                                                  shipping: String(e.target.value) === "true",
                                                })
                                              }
                                              sx={{ borderRadius: 2, background: "#fff" }}
                                            >
                                              <MenuItem value="false">No</MenuItem>
                                              <MenuItem value="true">Yes</MenuItem>
                                            </Select>
                                          </FormControl>
                                        </TableCell>

                                        <TableCell>
                                          <Chip
                                            size="small"
                                            label={chargebackEmailSent ? "True" : "False"}
                                            sx={{
                                              borderRadius: 999,
                                              fontWeight: 900,
                                              color: chargebackEmailSent ? "#166534" : "#991b1b",
                                              background: chargebackEmailSent ? "rgba(22,163,74,0.14)" : "rgba(248,113,113,0.14)",
                                              border: chargebackEmailSent ? "1px solid rgba(22,163,74,0.25)" : "1px solid rgba(220,38,38,0.25)",
                                            }}
                                          />
                                        </TableCell>

                                        <TableCell>
                                          <Chip
                                            size="small"
                                            label={signDetails.signed ? "True" : "False"}
                                            sx={{
                                              borderRadius: 999,
                                              fontWeight: 900,
                                              color: signDetails.signed ? "#166534" : "#991b1b",
                                              background: signDetails.signed ? "rgba(22,163,74,0.14)" : "rgba(248,113,113,0.14)",
                                              border: signDetails.signed ? "1px solid rgba(22,163,74,0.25)" : "1px solid rgba(220,38,38,0.25)",
                                            }}
                                          />
                                        </TableCell>

                                        <TableCell>
                                          <Button
                                            onClick={() => openChargebackSignModal(r)}
                                            size="small"
                                            variant="outlined"
                                            sx={{ textTransform: "none", borderRadius: 999, fontWeight: 900 }}
                                          >
                                            View Sign
                                          </Button>
                                        </TableCell>

                                        <TableCell align="center">
                                          <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flexWrap: "wrap" }}>
                                            <Button
                                              onClick={() => openLotsModal(r)}
                                              disabled={!isEmail(emailLower)}
                                              startIcon={<ListAltIcon />}
                                              sx={{
                                                textTransform: "none",
                                                borderRadius: 999,
                                                px: 2,
                                                fontWeight: 900,
                                                color: "#fff",
                                                background: isEmail(emailLower)
                                                  ? "linear-gradient(90deg,#6366f1,#4f46e5)"
                                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                "&:hover": {
                                                  background: isEmail(emailLower)
                                                    ? "linear-gradient(90deg,#4f46e5,#4338ca)"
                                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                },
                                              }}
                                            >
                                              Lots
                                            </Button>

                                            <Button
                                              onClick={() => openEmailForAuctionSelection([r])}
                                              disabled={!isEmail(emailLower)}
                                              startIcon={<MailOutlineIcon />}
                                              sx={{
                                                textTransform: "none",
                                                borderRadius: 999,
                                                px: 2,
                                                fontWeight: 900,
                                                color: "#fff",
                                                background: isEmail(emailLower)
                                                  ? "linear-gradient(90deg,#0ea5e9,#0284c7)"
                                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                "&:hover": {
                                                  background: isEmail(emailLower)
                                                    ? "linear-gradient(90deg,#0284c7,#0369a1)"
                                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                },
                                              }}
                                            >
                                              Email
                                            </Button>

                                            <Button
                                              onClick={() => exportRegistrationRowBoxLabelsPdf(r)}
                                              disabled={!shelfBoxLabels.length || boxLabelRowBusy}
                                              startIcon={boxLabelRowBusy ? <CircularProgress size={14} /> : <LocalPrintshopOutlinedIcon />}
                                              sx={{
                                                textTransform: "none",
                                                borderRadius: 999,
                                                px: 2,
                                                fontWeight: 900,
                                                color: "#fff",
                                                background: shelfBoxLabels.length
                                                  ? "linear-gradient(90deg,#f97316,#ea580c)"
                                                  : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                "&:hover": {
                                                  background: shelfBoxLabels.length
                                                    ? "linear-gradient(90deg,#ea580c,#c2410c)"
                                                    : "linear-gradient(90deg,#9ca3af,#6b7280)",
                                                },
                                              }}
                                            >
                                              {boxLabelRowBusy ? "Printing..." : "Print Boxes"}
                                            </Button>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      ) : (
                        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1.1 }}>
                          {chargebackFilteredAuctionRegs.length === 0 ? (
                            <Paper
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                border: "1px solid rgba(51,57,153,0.10)",
                                textAlign: "center",
                                color: "#6b7280",
                              }}
                            >
                              No registrations found.
                            </Paper>
                          ) : (
                            chargebackFilteredAuctionRegs.map((r, idx) => renderAuctionRegistrationMobileCard(r, idx))
                          )}
                        </Box>
                      )}
                    </>
                  ) : (
                    <Paper
                      sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: 3,
                        border: "1px solid rgba(51,57,153,0.10)",
                        background: "#fff",
                      }}
                    >
                      <Typography sx={{ fontWeight: 900, color: "#111827" }}>
                        Preparing registrations view...
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
                        Loading the registration screen for this auction.
                      </Typography>
                      <LinearProgress sx={{ mt: 1.5, borderRadius: 999 }} />
                    </Paper>
                  )}
                </Box>
              ) : null}
            </>
          ) : null}
        </Paper>


      </Box>

      <Dialog
        open={auctionWeeklyStatsOpen}
        onClose={() => setAuctionWeeklyStatsOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Auction Weekly Stats
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            Ordered by auction end date ({formatNumber2(toAbsInt(auctionHibidViewRows.length))} auctions)
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f8fafc" }}>
          <AuctionWeeklyStatsPanel
            rows={auctionHibidViewRows}
            primary={primary}
            locationMetadataRows={locationMetadataRows}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, py: 1.5 }}>
          <Button
            onClick={() => setAuctionWeeklyStatsOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 2.25,
              fontWeight: 900,
              border: "1px solid rgba(51,57,153,0.18)",
              color: primary,
              background: "#fff",
              "&:hover": { background: "rgba(99,102,241,0.06)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={locationsManagerOpen}
        onClose={() => setLocationsManagerOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Manage Locations
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            Add and manage reusable location metadata for pickup locations.
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f8fafc", p: 0 }}>
          <Location
            userId={userId}
            subscriptionId={subscriptionId}
            onLocationsChanged={applyLocationMetadataRows}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, py: 1.5 }}>
          <Button
            onClick={() => setLocationsManagerOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 2.25,
              fontWeight: 900,
              border: "1px solid rgba(51,57,153,0.18)",
              color: primary,
              background: "#fff",
              "&:hover": { background: "rgba(99,102,241,0.06)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={overallDashboardOpen}
        onClose={() => setOverallDashboardOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Overall Auctions Dashboard
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            Aggregated from loaded auction records ({formatNumber2(toAbsInt(auctions.length))} auctions)
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f8fafc" }}>
          {!auctions.length ? (
            <Alert severity="info" sx={{ borderRadius: 2 }}>
              No auctions are loaded yet. Click Refresh in Auctions first.
            </Alert>
          ) : (
            <>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4,minmax(0,1fr))" },
                  gap: 1,
                }}
              >
                {overallKpiCards.map((card) => (
                  <Paper
                    key={card.key}
                    sx={{
                      p: 1.25,
                      borderRadius: 2,
                      border: "1px solid rgba(148,163,184,0.22)",
                      background: card.bg,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ color: card.accent, fontWeight: 900, textTransform: "uppercase", letterSpacing: 0.2 }}
                    >
                      {card.label}
                    </Typography>
                    <Typography sx={{ color: "#0f172a", fontWeight: 900, fontSize: 24, lineHeight: 1.05, mt: 0.5 }}>
                      {card.value}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#334155", mt: 0.35, fontWeight: 700 }}>
                      {card.helper}
                    </Typography>
                  </Paper>
                ))}
              </Box>

              <Box
                sx={{
                  mt: 1.25,
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", lg: "repeat(3,minmax(0,1fr))" },
                  gap: 1,
                }}
              >
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>Sell-through Split</Typography>
                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                    Won vs passed lots (all loaded auctions)
                  </Typography>
                  <Box sx={{ mt: 1, width: "100%", height: 240 }}>
                    {overallChartData.sellThrough.some((d) => d.value > 0) ? (
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie data={overallChartData.sellThrough} dataKey="value" nameKey="name" innerRadius={54} outerRadius={88}>
                            {overallChartData.sellThrough.map((entry) => (
                              <Cell key={entry.name} fill={entry.color} />
                            ))}
                          </Pie>
                          <Legend />
                          <RechartsTooltip formatter={(v) => formatNumber2(toAbsInt(v))} />
                        </PieChart>
                      </ResponsiveContainer>
                    ) : (
                      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography variant="body2" sx={{ color: "#64748b" }}>
                          No lot stats available.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>

                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>Participation Funnel</Typography>
                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                    Summed registration and bidder counts
                  </Typography>
                  <Box sx={{ mt: 1, width: "100%", height: 240 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={overallChartData.funnel} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis dataKey="stage" tick={{ fill: "#334155", fontSize: 12 }} />
                        <YAxis tick={{ fill: "#334155", fontSize: 12 }} />
                        <RechartsTooltip formatter={(v) => formatNumber2(toAbsInt(v))} />
                        <Bar dataKey="value" fill="#4f46e5" radius={[8, 8, 0, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                </Paper>

                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>Engagement Mix</Typography>
                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                    Combined totals split into bought vs passed
                  </Typography>
                  <Box sx={{ mt: 1, width: "100%", height: 240 }}>
                    {overallChartData.engagement.some((d) => toAbsInt(d?.total) > 0) ? (
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={overallChartData.engagement} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                          <XAxis dataKey="metric" tick={{ fill: "#334155", fontSize: 12 }} />
                          <YAxis tick={{ fill: "#334155", fontSize: 12 }} />
                          <RechartsTooltip
                            formatter={(v, name) => [formatNumber2(toAbsInt(v)), formatEngagementSeriesName(name)]}
                            labelFormatter={(label, payload) => {
                              const total = formatNumber2(toAbsInt(payload?.[0]?.payload?.total || 0));
                              return `${label} (Total ${total})`;
                            }}
                          />
                          <Legend />
                          <Bar dataKey="bought" name="Bought" stackId="total" fill="#2563eb" radius={[6, 6, 0, 0]} />
                          <Bar dataKey="floor" name="Passed" stackId="total" fill="#f97316" radius={[6, 6, 0, 0]}>
                            <LabelList
                              dataKey="total"
                              position="top"
                              formatter={(value) => formatNumber2(toAbsInt(value))}
                              fill="#334155"
                              fontSize={11}
                              fontWeight={700}
                            />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    ) : (
                      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography variant="body2" sx={{ color: "#64748b" }}>
                          No engagement totals available.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>

              <Paper sx={{ mt: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", overflow: "hidden" }}>
                <Box
                  sx={{
                    px: 1.5,
                    py: 1.1,
                    background: "linear-gradient(90deg,#eef2ff,#f8fafc)",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                  }}
                >
                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>All Auctions</Typography>
                  <TextField
                    size="small"
                    placeholder="Search auctions"
                    value={overallAuctionSearch}
                    onChange={(e) => setOverallAuctionSearch(e.target.value)}
                    sx={{
                      minWidth: { xs: "100%", sm: 280 },
                      background: "#fff",
                      borderRadius: 999,
                      "& .MuiOutlinedInput-root": { borderRadius: 999 },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#64748b", fontSize: 18 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <TableContainer sx={{ maxHeight: "68vh", overflowY: "auto" }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow sx={{ "& .MuiTableCell-root": { backgroundColor: "#f8fafc" } }}>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "auctionEndDate"}
                            direction={overallAuctionSortKey === "auctionEndDate" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "auctionEndDate",
                                "desc"
                              )
                            }
                          >
                            Close Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "auctionName"}
                            direction={overallAuctionSortKey === "auctionName" ? overallAuctionSortDir : "asc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "auctionName",
                                "asc"
                              )
                            }
                          >
                            Auction Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "location"}
                            direction={overallAuctionSortKey === "location" ? overallAuctionSortDir : "asc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "location",
                                "asc"
                              )
                            }
                          >
                            Location
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "status"}
                            direction={overallAuctionSortKey === "status" ? overallAuctionSortDir : "asc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "status",
                                "asc"
                              )
                            }
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "salesTotalHammer"}
                            direction={overallAuctionSortKey === "salesTotalHammer" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "salesTotalHammer",
                                "desc"
                              )
                            }
                          >
                            Total Hammer Price
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "newUsers"}
                            direction={overallAuctionSortKey === "newUsers" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "newUsers",
                                "desc"
                              )
                            }
                          >
                            New Users
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "newShippers"}
                            direction={overallAuctionSortKey === "newShippers" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "newShippers",
                                "desc"
                              )
                            }
                          >
                            New Shippers
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "totalShippers"}
                            direction={overallAuctionSortKey === "totalShippers" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "totalShippers",
                                "desc"
                              )
                            }
                          >
                            Total Shippers
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "totalPickups"}
                            direction={overallAuctionSortKey === "totalPickups" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "totalPickups",
                                "desc"
                              )
                            }
                          >
                            Total Pickups
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "totalRegistrations"}
                            direction={overallAuctionSortKey === "totalRegistrations" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "totalRegistrations",
                                "desc"
                              )
                            }
                          >
                            Registrations
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "bidsPerLot"}
                            direction={overallAuctionSortKey === "bidsPerLot" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "bidsPerLot",
                                "desc"
                              )
                            }
                          >
                            Bids/Lot
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "revenuePerLot"}
                            direction={overallAuctionSortKey === "revenuePerLot" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "revenuePerLot",
                                "desc"
                              )
                            }
                          >
                            Revenue p/lot
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "totalLots"}
                            direction={overallAuctionSortKey === "totalLots" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "totalLots",
                                "desc"
                              )
                            }
                          >
                            Total Lots
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "passedLots"}
                            direction={overallAuctionSortKey === "passedLots" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "passedLots",
                                "desc"
                              )
                            }
                          >
                            Passed Lots
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 900, color: primary }}>
                          <TableSortLabel
                            active={overallAuctionSortKey === "passedPct"}
                            direction={overallAuctionSortKey === "passedPct" ? overallAuctionSortDir : "desc"}
                            onClick={() =>
                              applySortToggle(
                                overallAuctionSortKey,
                                setOverallAuctionSortKey,
                                setOverallAuctionSortDir,
                                "passedPct",
                                "desc"
                              )
                            }
                          >
                            Passed Lot %
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedOverallAuctionTableRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={15}>
                            <Box sx={{ p: 3, textAlign: "center", color: "#6b7280" }}>
                              {overallAuctionSearch ? "No auctions match this search." : "No auction totals available yet."}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : (
                        sortedOverallAuctionTableRows.map((row) => (
                          <TableRow key={row.auctionId || `${row.location}-${row.auctionEndDate}`} hover>
                            <TableCell sx={{ color: "#334155" }}>{row.auctionEndDate}</TableCell>
                            <TableCell sx={{ minWidth: 220 }}>
                              <Button
                                onClick={() => {
                                  setOverallDashboardOpen(false);
                                  void openAuctionFromHibidView(row.sourceAuction);
                                }}
                                sx={{
                                  p: 0,
                                  minWidth: 0,
                                  textTransform: "none",
                                  fontWeight: 900,
                                  justifyContent: "flex-start",
                                  color: primary,
                                  "&:hover": { background: "transparent", textDecoration: "underline" },
                                }}
                              >
                                {row.auctionName}
                              </Button>
                            </TableCell>
                            <TableCell sx={{ color: "#334155" }}>{row.location}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>
                              <Chip
                                size="small"
                                label={row.status}
                                sx={{
                                  fontWeight: 900,
                                  backgroundColor: row.status === "Completed" ? "#dcfce7" : "#fef3c7",
                                  color: row.status === "Completed" ? "#166534" : "#92400e",
                                  border: `1px solid ${row.status === "Completed" ? "#86efac" : "#fde68a"}`,
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 900, color: "#111827" }}>${moneyPlain(row.salesTotalHammer)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>
                              {row.newUsers > 0 ? (
                                <Button
                                  onClick={() => {
                                    setOverallDashboardOpen(false);
                                    void openAuctionNewUsersFromOverall(row.sourceAuction);
                                  }}
                                  sx={{
                                    p: 0,
                                    minWidth: 0,
                                    textTransform: "none",
                                    fontWeight: 800,
                                    color: primary,
                                    "&:hover": { background: "transparent", textDecoration: "underline" },
                                  }}
                                >
                                  {formatNumber2(row.newUsers)}
                                </Button>
                              ) : (
                                formatNumber2(row.newUsers)
                              )}
                            </TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.newShippers)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.totalShippers)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.totalPickups)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.totalRegistrations)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.bidsPerLot)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>${moneyPlain(row.revenuePerLot)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.totalLots)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatNumber2(row.passedLots)}</TableCell>
                            <TableCell sx={{ color: "#334155" }}>{formatPercent2(row.passedPct)}</TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>

              <Typography variant="caption" sx={{ color: "#64748b", mt: 1, display: "block" }}>
                Unique bidder counts in this overall view are summed per auction and may include repeat bidders.
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b", mt: 0.5, display: "block" }}>
                Revenue p/lot uses the AF gain model and does break out house seller versus consignor revenue when seller-share data is available.
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb", px: 2.5, py: 2 }}>
          <Button
            onClick={() => setOverallDashboardOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#6b7280,#4b5563)",
              "&:hover": { background: "linear-gradient(90deg,#4b5563,#374151)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={compareAuctionsOpen}
        onClose={() => setCompareAuctionsOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Compare Auctions
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            Compare up to 5 loaded auctions side by side using the same fields from the overall dashboard.
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f8fafc" }}>
          {!overallAuctionCompareOptions.length ? (
            <Alert severity="info" sx={{ borderRadius: 2 }}>
              No auctions are loaded yet. Refresh Auctions first, then compare them here.
            </Alert>
          ) : (
            <Box sx={{ display: "grid", gap: 1.25 }}>
              <Paper
                sx={{
                  p: 1.25,
                  borderRadius: 2,
                  border: "1px solid rgba(51,57,153,0.18)",
                  background: "linear-gradient(180deg,#eef2ff 0%,#f8fafc 100%)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 1,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 900, color: "#111827" }}>Select Auctions</Typography>
                    <Typography variant="caption" sx={{ color: "#475569", fontWeight: 700 }}>
                      Start with one auction, then add up to 5 total for a side-by-side comparison.
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                    <Chip
                      size="small"
                      label={`${formatNumber2(selectedCompareAuctionRows.length)} / 5 selected`}
                      sx={{
                        borderRadius: 999,
                        fontWeight: 900,
                        color: primary,
                        background: "#fff",
                        border: "1px solid rgba(51,57,153,0.18)",
                      }}
                    />
                    <Button
                      onClick={addCompareAuctionSlot}
                      disabled={
                        compareAuctionIds.length >= 5 ||
                        compareAuctionIds.some((id) => !String(id || "").trim())
                      }
                      sx={{
                        textTransform: "none",
                        borderRadius: 999,
                        px: 2,
                        fontWeight: 900,
                        color: "#fff",
                        background:
                          compareAuctionIds.length >= 5 || compareAuctionIds.some((id) => !String(id || "").trim())
                            ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                            : "linear-gradient(90deg,#2563eb,#1d4ed8)",
                        "&:hover": {
                          background:
                            compareAuctionIds.length >= 5 || compareAuctionIds.some((id) => !String(id || "").trim())
                              ? "linear-gradient(90deg,#9ca3af,#6b7280)"
                              : "linear-gradient(90deg,#1d4ed8,#1e40af)",
                        },
                      }}
                    >
                      + Add Auction
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gap: 1 }}>
                  {compareAuctionIds.map((auctionId, index) => {
                    const selectedOption =
                      overallAuctionCompareOptions.find((option) => option.id === String(auctionId || "").trim()) || null;
                    return (
                      <Box
                        key={`compare-auction-slot-${index}`}
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "minmax(0,1fr) auto" },
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <Autocomplete
                          options={overallAuctionCompareOptions}
                          value={selectedOption}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => option?.label || ""}
                          getOptionDisabled={(option) =>
                            compareAuctionIds.some(
                              (selectedId, selectedIndex) =>
                                selectedIndex !== index && String(selectedId || "").trim() === option.id
                            )
                          }
                          onChange={(_, nextOption) => updateCompareAuctionSlot(index, nextOption?.id || "")}
                          renderOption={(props, option) => (
                            <Box component="li" {...props} sx={{ display: "block" }}>
                              <Typography sx={{ fontWeight: 800, color: "#111827" }}>{option.label}</Typography>
                              {option.subLabel ? (
                                <Typography variant="caption" sx={{ color: "#64748b", display: "block", mt: 0.2 }}>
                                  {option.subLabel}
                                </Typography>
                              ) : null}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={`Auction ${index + 1}`}
                              placeholder="Select auction to compare"
                              size="small"
                              sx={{
                                background: "#fff",
                                borderRadius: 2,
                                "& .MuiOutlinedInput-root": { borderRadius: 2 },
                              }}
                            />
                          )}
                        />

                        {compareAuctionIds.length > 1 ? (
                          <Button
                            onClick={() => removeCompareAuctionSlot(index)}
                            startIcon={<CloseIcon />}
                            sx={{
                              textTransform: "none",
                              borderRadius: 999,
                              px: 2,
                              fontWeight: 900,
                              border: "1px solid rgba(239,68,68,0.22)",
                              color: "#b91c1c",
                              background: "#fff",
                              "&:hover": { background: "#fef2f2" },
                            }}
                          >
                            Remove
                          </Button>
                        ) : (
                          <Box />
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Paper>

              {selectedCompareAuctionRows.length === 0 ? (
                <Alert severity="info" sx={{ borderRadius: 2 }}>
                  Select at least one auction to start comparing it side by side.
                </Alert>
              ) : (
                <>
                  <Paper
                    sx={{
                      p: 1.25,
                      borderRadius: 2,
                      border: "1px solid rgba(51,57,153,0.18)",
                      background: "#fff",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                      <Box>
                        <Typography sx={{ fontWeight: 900, color: "#111827" }}>Compare View</Typography>
                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                          Switch between auction field comparison and registration trend comparison.
                        </Typography>
                      </Box>
                      <FormControl size="small" sx={{ minWidth: 290, background: "#fff", borderRadius: 2 }}>
                        <InputLabel id="compare-auction-view-label">Compare View</InputLabel>
                        <Select
                          labelId="compare-auction-view-label"
                          value={compareAuctionView}
                          label="Compare View"
                          onChange={(e) => setCompareAuctionView(String(e.target.value || "data"))}
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="data">Compare Auction Data</MenuItem>
                          <MenuItem value="registrationTrend">Compare Auction Registration Trend</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </Paper>

                  {compareAuctionView === "registrationTrend" ? (
                    <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", background: "#fff" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                        <Box>
                          <Typography sx={{ fontWeight: 900, color: "#111827" }}>Compare Auction Registration Trend</Typography>
                          <Typography variant="caption" sx={{ color: "#6b7280" }}>
                            Registrations by day or hour for each selected auction, shown one below the other.
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
                          <FormControl size="small" sx={{ minWidth: 140, background: "#fff", borderRadius: 2 }}>
                            <InputLabel id="compare-auction-reg-trend-type-label">Chart</InputLabel>
                            <Select
                              labelId="compare-auction-reg-trend-type-label"
                              value={compareAuctionRegTrendChartType}
                              label="Chart"
                              onChange={(e) => setCompareAuctionRegTrendChartType(String(e.target.value || "line"))}
                              sx={{ borderRadius: 2 }}
                            >
                              <MenuItem value="line">Line Chart</MenuItem>
                              <MenuItem value="bar">Bar Chart</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl size="small" sx={{ minWidth: 130, background: "#fff", borderRadius: 2 }}>
                            <InputLabel id="compare-auction-reg-trend-viewby-label">View By</InputLabel>
                            <Select
                              labelId="compare-auction-reg-trend-viewby-label"
                              value={compareAuctionRegTrendViewBy}
                              label="View By"
                              onChange={(e) => setCompareAuctionRegTrendViewBy(String(e.target.value || "day"))}
                              sx={{ borderRadius: 2 }}
                            >
                              {auctionRegTrendViewByOptions.map((opt) => (
                                <MenuItem key={`compare-${opt.value}`} value={opt.value}>
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl size="small" sx={{ minWidth: 168, background: "#fff", borderRadius: 2 }}>
                            <InputLabel id="compare-auction-reg-trend-datemode-label">Date Selection</InputLabel>
                            <Select
                              labelId="compare-auction-reg-trend-datemode-label"
                              value={compareAuctionRegTrendDateMode}
                              label="Date Selection"
                              onChange={(e) => setCompareAuctionRegTrendDateMode(String(e.target.value || "range"))}
                              sx={{ borderRadius: 2 }}
                            >
                              {auctionRegTrendDateModeOptions.map((opt) => (
                                <MenuItem key={`compare-date-mode-${opt.value}`} value={opt.value}>
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {compareAuctionRegTrendDateMode === "single" ? (
                            <TextField
                              type="date"
                              size="small"
                              label="Date"
                              value={compareAuctionRegTrendStartDate}
                              onChange={(e) => {
                                const minDateKey = compareAuctionRegTrendAvailableRange.minDateKey;
                                const maxDateKey = compareAuctionRegTrendAvailableRange.maxDateKey;
                                const rawDate = String(e.target.value || "");
                                setCompareAuctionRegTrendStartDate(
                                  clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                );
                              }}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                min: compareAuctionRegTrendAvailableRange.minDateKey || undefined,
                                max: compareAuctionRegTrendAvailableRange.maxDateKey || undefined,
                              }}
                              sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                            />
                          ) : (
                            <>
                              <TextField
                                type="date"
                                size="small"
                                label="Start Date"
                                value={compareAuctionRegTrendStartDate}
                                onChange={(e) => {
                                  const minDateKey = compareAuctionRegTrendAvailableRange.minDateKey;
                                  const maxDateKey = compareAuctionRegTrendAvailableRange.maxDateKey;
                                  const rawDate = String(e.target.value || "");
                                  setCompareAuctionRegTrendStartDate(
                                    clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                  );
                                }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  min: compareAuctionRegTrendAvailableRange.minDateKey || undefined,
                                  max: compareAuctionRegTrendAvailableRange.maxDateKey || undefined,
                                }}
                                sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                              />
                              <TextField
                                type="date"
                                size="small"
                                label="End Date"
                                value={compareAuctionRegTrendEndDate}
                                onChange={(e) => {
                                  const minDateKey = compareAuctionRegTrendAvailableRange.minDateKey;
                                  const maxDateKey = compareAuctionRegTrendAvailableRange.maxDateKey;
                                  const rawDate = String(e.target.value || "");
                                  setCompareAuctionRegTrendEndDate(
                                    clampDateKeyToRangeUTC(rawDate, minDateKey, maxDateKey) || rawDate
                                  );
                                }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  min: compareAuctionRegTrendAvailableRange.minDateKey || undefined,
                                  max: compareAuctionRegTrendAvailableRange.maxDateKey || undefined,
                                }}
                                sx={{ minWidth: 170, background: "#fff", borderRadius: 2 }}
                              />
                            </>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Chip size="small" label={`Range ${compareAuctionRegTrendResolvedRange.label || "No Dates"}`} sx={{ borderRadius: 999, fontWeight: 900 }} />
                        <Chip size="small" label={`View By ${compareAuctionRegTrendViewBy === "hour" ? "Hours" : "Day"}`} sx={{ borderRadius: 999, fontWeight: 900 }} />
                        <Chip
                          size="small"
                          label={`Auction Dates ${formatDateKeyRangeShortUTC(
                            compareAuctionRegTrendAvailableRange.minDateKey,
                            compareAuctionRegTrendAvailableRange.maxDateKey
                          ) || "No Dates"}`}
                          sx={{ borderRadius: 999, fontWeight: 900 }}
                        />
                      </Box>

                      <Box sx={{ mt: 1.25, display: "grid", gap: 1.25 }}>
                        {compareAuctionRegTrendSeries.map((auction) => (
                          <Paper
                            key={`compare-auction-trend-${auction.auctionId}`}
                            sx={{
                              p: 1.25,
                              borderRadius: 2,
                              border: "1px solid rgba(229,231,235,0.95)",
                              background: "linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                              <Box>
                                <Typography sx={{ fontWeight: 900, color: primary }}>
                                  {auction.auctionName || auction.auctionId}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                                  {[auction.auctionEndDate].filter(Boolean).join(" • ") || "Registration trend"}
                                </Typography>
                              </Box>
                              <Chip
                                size="small"
                                label={`Registered ${formatNumber2(toAbsInt(auction.totalInRange || 0))}`}
                                sx={{ borderRadius: 999, fontWeight: 900 }}
                              />
                            </Box>
                            <Box sx={{ mt: 1, width: "100%", height: 250 }}>
                              {auction.loading ? (
                                <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <CircularProgress size={26} />
                                </Box>
                              ) : auction.error ? (
                                <Alert severity="error" sx={{ borderRadius: 2 }}>
                                  {auction.error}
                                </Alert>
                              ) : auction.hasData ? (
                                <ResponsiveContainer width="100%" height="100%">
                                  {compareAuctionRegTrendChartType === "line" ? (
                                    <LineChart data={auction.data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                      <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                      <XAxis dataKey="xLabel" tick={{ fill: "#334155", fontSize: 12 }} minTickGap={compareAuctionRegTrendViewBy === "hour" ? 24 : 14} />
                                      <YAxis tick={{ fill: "#334155", fontSize: 12 }} allowDecimals={false} />
                                      <RechartsTooltip content={renderRegistrationTrendTooltip} />
                                      <Legend />
                                      <Line type="monotone" dataKey="shippingRequestedCount" name="Shippers" stroke="#2563eb" strokeWidth={2.5} dot={false} />
                                      <Line type="monotone" dataKey="pickupCount" name="Pickups" stroke="#ec4899" strokeWidth={2.5} dot={false} />
                                    </LineChart>
                                  ) : (
                                    <BarChart data={auction.data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
                                      <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                      <XAxis dataKey="xLabel" tick={{ fill: "#334155", fontSize: 12 }} minTickGap={compareAuctionRegTrendViewBy === "hour" ? 24 : 14} />
                                      <YAxis tick={{ fill: "#334155", fontSize: 12 }} allowDecimals={false} />
                                      <RechartsTooltip content={renderRegistrationTrendTooltip} />
                                      <Legend />
                                      <Bar dataKey="shippingRequestedCount" name="Shippers" stackId="registrations" fill="#2563eb" radius={[6, 6, 0, 0]} />
                                      <Bar dataKey="pickupCount" name="Pickups" stackId="registrations" fill="#ec4899" radius={[6, 6, 0, 0]} />
                                    </BarChart>
                                  )}
                                </ResponsiveContainer>
                              ) : (
                                <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <Typography variant="body2" sx={{ color: "#64748b" }}>
                                    {compareAuctionRegTrendAvailableRange.hasData
                                      ? `No registrations in ${compareAuctionRegTrendResolvedRange.label}.`
                                      : "No registration dates available yet."}
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          </Paper>
                        ))}
                      </Box>
                    </Paper>
                  ) : (
                    <Paper sx={{ borderRadius: 2, border: "1px solid rgba(229,231,235,0.95)", overflow: "hidden" }}>
                      <Box
                        sx={{
                          px: 1.5,
                          py: 1.1,
                          background: "linear-gradient(90deg,#eef2ff,#f8fafc)",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <Typography sx={{ fontWeight: 900, color: "#111827" }}>Side-by-Side Comparison</Typography>
                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700 }}>
                          Fields are shown as rows, with each selected auction in its own column.
                        </Typography>
                      </Box>

                      <TableContainer sx={{ maxHeight: "68vh", overflow: "auto", background: "#fff" }}>
                        <Table stickyHeader size="small" sx={{ minWidth: 240 + selectedCompareAuctionRows.length * 220 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{
                                  minWidth: 220,
                                  fontWeight: 900,
                                  color: primary,
                                  backgroundColor: "#f8fafc",
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 3,
                                }}
                              >
                                Field
                              </TableCell>
                              {selectedCompareAuctionRows.map((row) => (
                                <TableCell
                                  key={`compare-auction-header-${row.auctionId}`}
                                  sx={{
                                    minWidth: 220,
                                    fontWeight: 900,
                                    color: primary,
                                    backgroundColor: "#f8fafc",
                                    verticalAlign: "top",
                                  }}
                                >
                                  <Typography sx={{ fontWeight: 900, color: "#111827" }}>{row.auctionName}</Typography>
                                  <Typography variant="caption" sx={{ color: "#64748b", display: "block", mt: 0.35 }}>
                                    {[row.location, row.auctionEndDate].filter(Boolean).join(" • ")}
                                  </Typography>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {overallAuctionCompareFields.map((field, rowIndex) => (
                              <TableRow
                                key={field.key}
                                sx={{
                                  "& .MuiTableCell-root": {
                                    backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#f8fafc",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    fontWeight: 900,
                                    color: "#0f172a",
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 2,
                                    backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#f8fafc",
                                  }}
                                >
                                  {field.label}
                                </TableCell>
                                {selectedCompareAuctionRows.map((row) => (
                                  <TableCell
                                    key={`${field.key}-${row.auctionId}`}
                                    sx={{
                                      color: field.key === "salesTotalHammer" || field.key === "avgHammerPrice" || field.key === "avgRevenue" ? "#111827" : "#334155",
                                      fontWeight:
                                        field.key === "salesTotalHammer" ||
                                          field.key === "avgHammerPrice" ||
                                          field.key === "avgRevenue" ||
                                          field.key === "totalLots" ||
                                          field.key === "soldLots"
                                          ? 800
                                          : 700,
                                    }}
                                  >
                                    {field.getValue(row)}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  )}
                </>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb", px: 2.5, py: 2 }}>
          <Button
            onClick={() => setCompareAuctionIds([""])}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 2.5,
              fontWeight: 900,
              border: "1px solid rgba(51,57,153,0.18)",
              color: primary,
              background: "#fff",
              "&:hover": { background: "rgba(99,102,241,0.06)" },
            }}
          >
            Clear
          </Button>
          <Button
            onClick={() => setCompareAuctionsOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#6b7280,#4b5563)",
              "&:hover": { background: "linear-gradient(90deg,#4b5563,#374151)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={createAuctionOpen}
        onClose={() => {
          if (createAuctionBusy) return;
          setCreateAuctionOpen(false);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>Create New Auction</DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f9fafb" }}>
          <Box sx={{ display: "grid", gap: 1.1 }}>
            <TextField
              autoFocus
              label="Auction Name"
              value={createAuctionName}
              onChange={(e) => setCreateAuctionName(e.target.value)}
              size="small"
              required
              fullWidth
              disabled={createAuctionBusy}
              sx={{ background: "#fff", borderRadius: 2 }}
            />
            <TextField
              label="Auction End (Optional)"
              type="datetime-local"
              value={createAuctionEndAtLocal}
              onChange={(e) => setCreateAuctionEndAtLocal(e.target.value)}
              size="small"
              fullWidth
              disabled={createAuctionBusy}
              sx={{ background: "#fff", borderRadius: 2 }}
              InputLabelProps={{ shrink: true }}
            />

            <Autocomplete
              freeSolo={!cityPlacesReady}
              size="small"
              options={createAuctionLocationOptions}
              value={createAuctionLocation}
              inputValue={createAuctionLocationInput}
              loading={cityPlacesReady && cityOptionsLoading}
              disabled={createAuctionBusy}
              onInputChange={(_, v, reason) => {
                const next = String(v || "");
                setCreateAuctionLocationInput(next);
                if (!cityPlacesReady) {
                  setCreateAuctionLocation(next);
                } else if (reason === "input") {
                  setCreateAuctionLocation("");
                  queueCreateAuctionCityOptions(next);
                }
              }}
              onChange={(_, v) => {
                const next = String(v || "").trim();
                setCreateAuctionLocation(next);
                setCreateAuctionLocationInput(next);
                queueCreateAuctionCityOptions(next);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location (Optional)"
                  placeholder={cityPlacesReady ? "Search and select a city" : "Type city or select saved location"}

                  sx={{ background: "#fff", borderRadius: 2 }}
                />
              )}
            />

            <Divider sx={{ my: 0.25 }} />

            <input
              ref={createAuctionRegistrationFileInputRef}
              type="file"
              accept=".csv,text/csv,.tsv,text/tab-separated-values,.xlsx,.xls"
              style={{ display: "none" }}
              onChange={(e) => {
                const f = e.target.files?.[0] || null;
                e.target.value = "";
                setCreateAuctionRegistrationFile(f);
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Button
                onClick={() => createAuctionRegistrationFileInputRef.current?.click()}
                disabled={createAuctionBusy}
                startIcon={<UploadFileIcon />}
                sx={{
                  textTransform: "none",
                  borderRadius: 999,
                  px: 2,
                  fontWeight: 900,
                  border: "1px solid rgba(51,57,153,0.18)",
                  color: primary,
                  background: "#fff",
                  "&:hover": { background: "rgba(99,102,241,0.06)" },
                }}
              >
                Registration File (Optional)
              </Button>
              {createAuctionRegistrationFile ? (
                <Chip
                  size="small"
                  label={createAuctionRegistrationFile.name}
                  onDelete={createAuctionBusy ? undefined : () => setCreateAuctionRegistrationFile(null)}
                  sx={{ borderRadius: 999, fontWeight: 800 }}
                />
              ) : (
                <Typography variant="caption" sx={{ color: "#64748b" }}>
                  CSV or XLSX
                </Typography>
              )}
            </Box>

            <input
              ref={createAuctionLotsFileInputRef}
              type="file"
              accept=".csv,text/csv,.tsv,text/tab-separated-values"
              style={{ display: "none" }}
              onChange={(e) => {
                const f = e.target.files?.[0] || null;
                e.target.value = "";
                setCreateAuctionLotsFile(f);
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Button
                onClick={() => createAuctionLotsFileInputRef.current?.click()}
                disabled={createAuctionBusy}
                startIcon={<UploadFileIcon />}
                sx={{
                  textTransform: "none",
                  borderRadius: 999,
                  px: 2,
                  fontWeight: 900,
                  border: "1px solid rgba(51,57,153,0.18)",
                  color: primary,
                  background: "#fff",
                  "&:hover": { background: "rgba(99,102,241,0.06)" },
                }}
              >
                Lot Stats File (Optional)
              </Button>
              {createAuctionLotsFile ? (
                <Chip
                  size="small"
                  label={createAuctionLotsFile.name}
                  onDelete={createAuctionBusy ? undefined : () => setCreateAuctionLotsFile(null)}
                  sx={{ borderRadius: 999, fontWeight: 800 }}
                />
              ) : (
                <Typography variant="caption" sx={{ color: "#64748b" }}>
                  CSV or TSV
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb", px: 2.5, py: 2 }}>
          <Button
            onClick={() => setCreateAuctionOpen(false)}
            disabled={createAuctionBusy}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              border: "1px solid rgba(51,57,153,0.18)",
              color: primary,
              background: "#fff",
              "&:hover": { background: "rgba(99,102,241,0.06)" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={createAuctionNow}
            disabled={createAuctionBusy || !String(createAuctionName || "").trim()}
            startIcon={createAuctionBusy ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <GavelIcon />}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#16a34a,#15803d)",
              "&:hover": { background: "linear-gradient(90deg,#15803d,#166534)" },
            }}
          >
            {createAuctionBusy ? "Creating..." : "Create Auction"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={lotsOpen}
        onClose={() => setLotsOpen(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            ...modalPaperSx,
            width: "90vw",
            maxWidth: "90vw",
            height: "90vh",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Lots — {lotsUser?.bidderEmail || lotsUser?.email || "-"}
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            {selectedAuctionLabel}
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ backgroundColor: "#f9fafb" }}>
          {lotsErr ? (
            <Alert severity="error" sx={{ borderRadius: 2, mb: 2 }}>
              {lotsErr}
            </Alert>
          ) : null}

          {lotsBusy ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2 }}>
              <CircularProgress size={18} />
              <Typography variant="body2">Loading lots…</Typography>
            </Box>
          ) : !lotsData ? (
            <Alert severity="info" sx={{ borderRadius: 2 }}>
              No lots data.
            </Alert>
          ) : (
            <>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: 1.25, mb: 2 }}>
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Lots
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 18 }}>
                    {safeNum(lotsData.lotsCount)}
                  </Typography>
                </Paper>
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    {lotsUserFulfillmentLabel}
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 18 }}>
                    {lotsUserFulfillmentStatusLabel}
                  </Typography>
                </Paper>
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Total HighBid
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 18 }}>
                    ${moneyPlain(lotsData.totalHighBid || 0)}
                  </Typography>
                </Paper>
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Upload
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: "#111827", fontSize: 12, wordBreak: "break-word" }}>
                    {lotsData.uploadId || "—"}
                  </Typography>
                </Paper>
              </Box>

              <TableContainer component={Paper} sx={{ borderRadius: 3, maxHeight: "68vh", overflow: "auto" }}>
                <Table size="small" stickyHeader sx={{ minWidth: 2300 }}>
                  <TableHead>
                    <TableRow sx={{ "& .MuiTableCell-root": { backgroundColor: "#f8fafc" } }}>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Thumbnail</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>{lotsUserFulfillmentLabel}</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "lot"}
                          direction={lotsModalSortKey === "lot" ? lotsModalSortDir : "asc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "lot", "asc")}
                        >
                          Lot
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "title"}
                          direction={lotsModalSortKey === "title" ? lotsModalSortDir : "asc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "title", "asc")}
                        >
                          Title
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Location</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Description</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Qty</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Consignor</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Start Bid</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "highBid"}
                          direction={lotsModalSortKey === "highBid" ? lotsModalSortDir : "desc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "highBid", "desc")}
                        >
                          High Bid
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "maxBid"}
                          direction={lotsModalSortKey === "maxBid" ? lotsModalSortDir : "desc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "maxBid", "desc")}
                        >
                          Max Bid
                        </TableSortLabel>
                      </TableCell>

                      <TableCell sx={{ fontWeight: 900, color: primary }}>Retail Price</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>UPC</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Weight</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Dimensions</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Brand</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Lister</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>Media Urls</TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "bids"}
                          direction={lotsModalSortKey === "bids" ? lotsModalSortDir : "desc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "bids", "desc")}
                        >
                          Bids
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "views"}
                          direction={lotsModalSortKey === "views" ? lotsModalSortDir : "desc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "views", "desc")}
                        >
                          Views
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "watches"}
                          direction={lotsModalSortKey === "watches" ? lotsModalSortDir : "desc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "watches", "desc")}
                        >
                          Watches
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 900, color: primary }}>
                        <TableSortLabel
                          active={lotsModalSortKey === "consignor"}
                          direction={lotsModalSortKey === "consignor" ? lotsModalSortDir : "asc"}
                          onClick={() => applySortToggle(lotsModalSortKey, setLotsModalSortKey, setLotsModalSortDir, "consignor", "asc")}
                        >
                          Auction Consignor
                        </TableSortLabel>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedLotsModalRows.map((lot) => {
                      const thumbnailUrl = getListernautThumbnailUrl(lot);
                      const mediaUrls = getListernautMediaUrls(lot);
                      const description = getLotDescriptionText(lot);
                      return (
                        <TableRow key={lot.id || `${lot.lot}-${lot.title}`} hover>
                          <TableCell>
                            {thumbnailUrl ? (
                              <Box
                                component="img"
                                src={thumbnailUrl}
                                alt={String(lot?.listernautTitle || lot?.title || lot?.lot || "Lot image")}
                                sx={{
                                  width: 52,
                                  height: 52,
                                  objectFit: "cover",
                                  borderRadius: 1.5,
                                  border: "1px solid rgba(148,163,184,0.28)",
                                  background: "#fff",
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: 52,
                                  height: 52,
                                  borderRadius: 1.5,
                                  border: "1px dashed rgba(148,163,184,0.6)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#94a3b8",
                                  fontSize: 11,
                                  fontWeight: 800,
                                }}
                              >
                                No Img
                              </Box>
                            )}
                          </TableCell>
                          <TableCell>
                            {lotsUserFulfillmentMode === "pickedUp" ? (
                              <Checkbox
                                size="small"
                                checked={!!lot?.pickedUp}
                                onChange={(e) =>
                                  updateLotPickup({
                                    lotId: lot?.id,
                                    email: lotsUser?.bidderEmail || lotsUser?.email,
                                    pickedUp: e.target.checked,
                                  })
                                }
                              />
                            ) : lotsUserFulfillmentMode === "shipped" ? (
                              <Checkbox
                                size="small"
                                checked={!!lot?.shipped}
                                onChange={(e) =>
                                  updateLotShipped({
                                    lotId: lot?.id,
                                    email: lotsUser?.bidderEmail || lotsUser?.email,
                                    shipped: e.target.checked,
                                  })
                                }
                              />
                            ) : lotsUserFulfillmentMode === "delivered" ? (
                              <Checkbox
                                size="small"
                                checked={!!lot?.delivered}
                                onChange={(e) =>
                                  updateLotDelivered({
                                    lotId: lot?.id,
                                    email: lotsUser?.bidderEmail || lotsUser?.email,
                                    delivered: e.target.checked,
                                  })
                                }
                              />
                            ) : (
                              <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: 800 }}>—</Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 900 }}>{lot.lot || "-"}</TableCell>
                          <TableCell sx={{ color: "#374151", minWidth: 200 }}>
                            {lot?.listernautTitle || lot?.title || "-"}
                          </TableCell>
                          <TableCell sx={{ color: "#374151", minWidth: 150 }}>
                            {String(lot?.listernautLocation || "").trim() || "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#475569", minWidth: 260 }}>
                            {renderDescriptionPreview(description, `Lot ${String(lot?.lot || "").trim() || "Description"}`)}
                          </TableCell>
                          <TableCell sx={{ color: "#374151" }}>{toAbsInt(lot?.listernautQuantity || 0) || "—"}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>
                            {String(lot?.listernautConsignorName || lot?.listernautSellerCode || "").trim() || "—"}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 900 }}>
                            {safeNum(lot?.listernautStartBid || 0) > 0 ? `$${moneyPlain(lot?.listernautStartBid || 0)}` : "—"}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 900 }}>${moneyPlain(lot.highBid || 0)}</TableCell>
                          <TableCell sx={{ fontWeight: 900 }}>${moneyPlain(lot.maxBid || 0)}</TableCell>

                          <TableCell sx={{ fontWeight: 900 }}>
                            {safeNum(lot?.listernautRetailPrice || 0) > 0 ? `$${moneyPlain(lot?.listernautRetailPrice || 0)}` : "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#374151", minWidth: 120 }}>
                            {String(lot?.listernautUpc || "").trim() || "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#374151" }}>
                            {safeNum(lot?.listernautWeight || 0) > 0 ? formatNumber2(lot?.listernautWeight || 0) : "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#374151" }}>{formatLotDimensions(lot)}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>{String(lot?.listernautBrand || "").trim() || "—"}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>{String(lot?.listernautLister || "").trim() || "—"}</TableCell>
                          <TableCell sx={{ color: "#374151", minWidth: 240 }}>
                            {mediaUrls.length ? (() => {
                              const expandKey = `lot-${String(lot?.id || lot?.lot || "lot")}-mediaUrls`;
                              const isExpanded = !!expandedMediaUrlsByKey?.[expandKey];
                              return (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.5 }}>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => toggleMediaUrlsExpanded(expandKey)}
                                    sx={{ textTransform: "none", borderRadius: 999, fontWeight: 800, minWidth: 0, px: 1.2, py: 0.2 }}
                                  >
                                    {isExpanded ? "Hide URLs" : `Show URLs (${formatNumber2(mediaUrls.length)})`}
                                  </Button>
                                  {isExpanded ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
                                      {mediaUrls.map((url, idx) => (
                                        <Typography key={`${lot.id || lot.lot}-media-${idx}`} variant="caption" sx={{ color: primary, wordBreak: "break-all" }}>
                                          {url}
                                        </Typography>
                                      ))}
                                    </Box>
                                  ) : null}
                                </Box>
                              );
                            })() : "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#374151" }}>{safeNum(lot.bids)}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>{safeNum(lot.views)}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>{safeNum(lot.watches)}</TableCell>
                          <TableCell sx={{ color: "#374151" }}>{String(lot.consignor || "").trim() || "—"}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

            </>
          )}
        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb", px: 2.5, py: 2 }}>
          <Button
            onClick={() => setLotsOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#6b7280,#4b5563)",
              "&:hover": { background: "linear-gradient(90deg,#4b5563,#374151)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={chargebackSignOpen}
        onClose={() => {
          setChargebackSignOpen(false);
          setChargebackSignRow(null);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Chargeback / Pickup Signature
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            {chargebackSignRow?.bidderEmail || chargebackSignRow?.email || "—"}
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f9fafb" }}>
          {(() => {
            const row = chargebackSignRow || {};
            const details = getChargebackSignDetails(row);
            const sent = isChargebackEmailSent(row);
            const sentAt = fmtDate(row?.chargebackEmailSentAtMs || row?.chargebackEmailSentAt);
            const signedAt = details?.signedAtMs ? fmtDate(details.signedAtMs) : "—";
            const rowEmail = row?.bidderEmail || row?.email || "—";
            const rowAuctionId = String(row?.auctionId || selectedAuctionId || "").trim();
            const rowMode = details?.signMode === "pickup" || !isShippingRequested(row) ? "pickup" : "shipping";
            return (
              <Box sx={{ display: "grid", gap: 1.25 }}>
                {chargebackSignError ? <Alert severity="error" sx={{ borderRadius: 2 }}>{chargebackSignError}</Alert> : null}
                {chargebackSignSuccess ? <Alert severity="success" sx={{ borderRadius: 2 }}>{chargebackSignSuccess}</Alert> : null}

                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Sign In Person
                  </Typography>
                  <Box sx={{ mt: 1, display: "grid", gap: 1 }}>
                    <TextField
                      label="Signature Name"
                      value={chargebackSignSignatureName}
                      onChange={(e) => setChargebackSignSignatureName(e.target.value)}
                      size="small"
                      fullWidth
                      disabled={chargebackSignSaving}
                      sx={{ background: "#fff", borderRadius: 2 }}
                    />
                    <Typography variant="caption" sx={{ color: "#64748b" }}>
                      Draw signature in the box below.
                    </Typography>
                    <Box sx={{ p: 1, borderRadius: 1.5, background: "#fff", border: "1px solid #e5e7eb" }}>
                      <canvas
                        ref={chargebackSignatureCanvasRef}
                        width={900}
                        height={220}
                        style={{ width: "100%", height: 220, display: "block", touchAction: "none", borderRadius: 8, background: "#fff" }}
                        onMouseDown={startChargebackSignatureDraw}
                        onMouseMove={moveChargebackSignatureDraw}
                        onMouseUp={endChargebackSignatureDraw}
                        onMouseLeave={endChargebackSignatureDraw}
                        onTouchStart={startChargebackSignatureDraw}
                        onTouchMove={moveChargebackSignatureDraw}
                        onTouchEnd={endChargebackSignatureDraw}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between", flexWrap: "wrap" }}>
                      <Chip
                        size="small"
                        label={chargebackSignSignatureHasInk ? "Signature captured" : "Please sign in canvas"}
                        sx={{ borderRadius: 999, fontWeight: 900 }}
                        color={chargebackSignSignatureHasInk ? "success" : "default"}
                        variant={chargebackSignSignatureHasInk ? "filled" : "outlined"}
                      />
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={resetChargebackSignatureCanvas}
                          disabled={chargebackSignSaving}
                          sx={{ textTransform: "none", borderRadius: 999, fontWeight: 900 }}
                        >
                          Clear Signature
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            const signatureDataUrl = captureChargebackSignatureDataUrl();
                            if (String(chargebackSignSignatureName || "").trim().length < 2) {
                              setChargebackSignError("Type the full signature name before signing.");
                              return;
                            }
                            if (!signatureDataUrl) {
                              setChargebackSignError("Draw the signature in the canvas before saving.");
                              return;
                            }
                            void updateRegistrationSignature({
                              auctionId: rowAuctionId,
                              email: rowEmail,
                              signatureName: String(chargebackSignSignatureName || "").trim(),
                              signatureDataUrl,
                            });
                          }}
                          disabled={chargebackSignSaving}
                          sx={{
                            textTransform: "none",
                            borderRadius: 999,
                            fontWeight: 900,
                            color: "#fff",
                            background: "linear-gradient(90deg,#333999,#4f46e5)",
                            "&:hover": { background: "linear-gradient(90deg,#2c318b,#4338ca)" },
                          }}
                        >
                          {chargebackSignSaving ? "Saving..." : "Save Signature"}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Chargeback / Pickup Mail Sent
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: sent ? "#166534" : "#991b1b" }}>
                    {sent ? "True" : "False"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b" }}>
                    Sent At: {sentAt || "—"}
                  </Typography>
                </Paper>

                <Paper sx={{ p: 1.25, borderRadius: 2, border: "1px solid rgba(229,231,235,0.9)" }}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 900, textTransform: "uppercase" }}>
                    Signed
                  </Typography>
                  <Typography sx={{ fontWeight: 900, color: details?.signed ? "#166534" : "#991b1b" }}>
                    {details?.signed ? "True" : "False"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Signed At: {signedAt}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Name: {details?.signatureName || "—"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Action: {details?.lastAction || "—"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Source: {details?.source || "—"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Opt Out Reason: {details?.optOutReason || "—"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block" }}>
                    Mode: {rowMode === "pickup" ? "Pickup" : "Shipping"}
                  </Typography>
                </Paper>

              </Box>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb", px: 2.5, py: 2 }}>
          <Button
            onClick={() => {
              setChargebackSignOpen(false);
              setChargebackSignRow(null);
            }}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              px: 3,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#6b7280,#4b5563)",
              "&:hover": { background: "linear-gradient(90deg,#4b5563,#374151)" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={fileNameMismatchDialog.open}
        onClose={() => resolveFileNameMismatchDialog(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ fontWeight: 900 }}>Filename Mismatch Warning</DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#f9fafb" }}>
          <Alert severity="warning" sx={{ borderRadius: 2, mb: 1.5 }}>
            This {fileNameMismatchDialog.uploadKindLabel} filename does not look like the selected auction.
          </Alert>
          <Typography sx={{ color: "#334155", mb: 0.75 }}>
            Selected auction: <strong>{fileNameMismatchDialog.auctionName || "—"}</strong>
          </Typography>
          <Typography sx={{ color: "#334155" }}>
            File: <strong>{fileNameMismatchDialog.fileName || "—"}</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, py: 1.5 }}>
          <Button
            onClick={() => resolveFileNameMismatchDialog(false)}
            sx={{ textTransform: "none", borderRadius: 999, fontWeight: 900 }}
          >
            Cancel Upload
          </Button>
          <Button
            onClick={() => resolveFileNameMismatchDialog(true)}
            sx={{
              textTransform: "none",
              borderRadius: 999,
              fontWeight: 900,
              color: "#fff",
              background: "linear-gradient(90deg,#6366f1,#4f46e5)",
              "&:hover": { background: "linear-gradient(90deg,#4f46e5,#4338ca)" },
            }}
          >
            Continue Anyway
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={uploadDialogOpen}
        onClose={(_, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: 900 }}>
          Uploading
        </DialogTitle>
        <DialogContent sx={{ py: 3.5, backgroundColor: "#f9fafb" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.25 }}>
            <CircularProgress size={22} />
            <Typography sx={{ fontWeight: 700, color: "#334155" }}>
              {uploadDialogMessage}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
